// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23333\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M1.5 6l6 6 6-6\" stroke=\"%23333\" stroke-width=\"2\" fill=\"none\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sidebarBox {
  background: var(--sidebar-gradient);
  background-repeat: no-repeat;
  box-shadow: 8px 0 24px rgba(11, 16, 38, 0.12);
  height: calc(100% + 2rem);
}

.sidebar {
  z-index: 1000;
  overflow: auto;
  height: calc(100% - 4rem);
  transition: 0.2s;
  left: 0;
  top: 50px;
  z-index: 9;
  color: white;
  width: 225px;
}
.sidebar .sidebar-item .sidebar-title {
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  min-height: 44px;
  height: auto;
  align-items: center;
}
.sidebar .sidebar-item .sidebar-title:hover {
  background: rgba(255, 255, 255, 0.1);
}
.sidebar .sidebar-item .sidebar-children {
  display: grid;
  grid-template-rows: 0fr;
  margin-left: 1rem;
  margin-top: 0;
  transition: grid-template-rows 0.28s ease, margin-top 0.28s ease;
}
.sidebar .sidebar-item .sidebar-children.is-open {
  grid-template-rows: 1fr;
  margin-top: 0.3rem;
}
.sidebar .sidebar-item .sidebar-children .sidebar-children-inner {
  min-height: 0;
  overflow: hidden;
}
.sidebar .sidebar-item .sidebar-children .sidebar-item .sidebar-title {
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
}
.sidebar .arrow {
  font-size: 0.8rem;
}
.sidebar .icon-display {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.sidebar .sidebar-label {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;
  color: #fff;
}
.sidebar .sidebar-children .sidebar-label {
  font-weight: 500;
  font-size: 12px;
}
.sidebar .sidebar-icon-badge {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #e4eef7;
  color: #1e71bb;
}
.sidebar .sidebar-icon-badge i {
  margin: 0;
  font-size: 14px;
  line-height: 1;
  color: #1e71bb;
}
.sidebar.sidebar-collapsed .sidebar-title {
  justify-content: center;
  padding-left: 4px;
  padding-right: 4px;
}
.sidebar.sidebar-collapsed .icon-display {
  justify-content: center;
}
@media (max-width: 768px) {
  .sidebar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
}

.sidebar {
  color: white;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar .sidebar-item .sidebar-children {
    transition: none;
  }
}
.sidebar-footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 5px 20px 20px;
  display: flex;
  flex-flow: nowrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.powered-by-text {
  font-size: 11px;
  font-weight: 500;
  color: #fff;
}

.powered-by-logo {
  display: block;
  width: 80px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  object-position: left center;
}

.sidebar-footer.sidebar-collapsed {
  padding: 0px !important;
  align-items: center;
}

.sidebar-collapsed .powered-by-logo {
  width: 100%;
  margin: 10px 0px;
  height: 36px;
  object-position: center;
  padding: 0px;
}

.login-page {
  display: flex;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  max-width: 100%;
}

.login-left {
  flex: 1 1;
  background: radial-gradient(680px 460px at -6% -8%, rgba(176, 48, 168, 0.62), transparent 58%), radial-gradient(520px 380px at 108% 112%, rgba(36, 92, 196, 0.32), transparent 62%), linear-gradient(180deg, #4c1d7a 0%, #2a1862 16%, #16184a 48%, #0c1438 78%, #090f28 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  max-height: 100vh;
  min-width: 0;
}

.hero-frame {
  position: relative;
  aspect-ratio: 555/642;
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
  container-type: size;
  font-family: "Montserrat", sans-serif;
}

.login-logo-section {
  position: absolute;
  z-index: 6;
  top: 3.6%;
  left: 4.8%;
  margin: 0;
  padding: 0;
  background: transparent;
}

.login-brand-logo {
  display: block;
  width: min(220px, 26%);
  height: auto;
  filter: drop-shadow(0 2px 6px rgba(10, 4, 30, 0.35));
}

.hub-copy {
  position: absolute;
  z-index: 3;
  top: 20.6cqw;
  left: 6%;
  right: 6%;
  text-align: center;
}
.hub-copy h2 {
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 5.75cqw;
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.03em;
  color: #fff;
}
.hub-copy p {
  margin: 1.35cqw 0 0;
  font-size: 2.05cqw;
  font-weight: 500;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.78);
}

.hub-stage {
  position: absolute;
  z-index: 2;
  left: 5%;
  width: 90%;
  top: 36.5%;
  aspect-ratio: 571/299;
  container-type: size;
}

.hub-lines {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 1;
}
.hub-lines line {
  stroke: rgba(198, 210, 240, 0.55);
  stroke-width: 1.15;
  stroke-dasharray: 2.4 3.6;
  stroke-linecap: round;
}

.hub-dot {
  position: absolute;
  width: 1.25cqw;
  height: 1.25cqw;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0 0 0.8cqw rgba(255, 255, 255, 0.85);
  pointer-events: none;
  z-index: 2;
}
.hub-dot.is-pink {
  background: #f0abfc;
  box-shadow: 0 0 0.9cqw rgba(232, 121, 249, 0.95);
}

.hub-node {
  position: absolute;
  left: var(--nx);
  top: var(--ny);
  z-index: 2;
}

.hub-node-ring {
  position: absolute;
  left: 0;
  top: 0;
  width: 7.1cqw;
  height: 7.1cqw;
  display: grid;
  place-items: center;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 0.16cqw solid rgba(214, 222, 248, 0.9);
  background: rgba(12, 18, 48, 0.55);
  color: #fff;
}
.hub-node-ring svg {
  width: 46%;
  height: 46%;
}

.hub-node-label {
  position: absolute;
  color: rgba(255, 255, 255, 0.94);
  font-size: 2.5cqw;
  font-weight: 500;
  letter-spacing: -0.01em;
  white-space: nowrap;
  line-height: 1;
}

.hub-node--left .hub-node-label {
  right: 4.7cqw;
  top: 0;
  transform: translateY(-50%);
}

.hub-node--right .hub-node-label {
  left: 4.7cqw;
  top: 0;
  transform: translateY(-50%);
}

.hub-node--below .hub-node-label {
  left: 0;
  top: 4.3cqw;
  transform: translateX(-50%);
}

.hub-core {
  position: absolute;
  z-index: 3;
  width: 13cqw;
  height: 13cqw;
  display: grid;
  place-items: center;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle at 50% 42%, rgba(206, 160, 255, 0.55), rgba(124, 64, 214, 0.16) 42%, transparent 68%);
  box-shadow: 0 0 0 0.14cqw rgba(226, 210, 255, 0.75), 0 0 1.5cqw rgba(168, 85, 247, 0.42), 0 0 3cqw rgba(236, 72, 153, 0.16);
}
.hub-core svg {
  width: 64%;
  height: 64%;
  filter: drop-shadow(0 0.4cqw 0.6cqw rgba(18, 6, 40, 0.35));
}

@keyframes hubCorePulse {
  0%, 100% {
    box-shadow: 0 0 0 1.5px rgba(220, 196, 255, 0.5), 0 0 22px rgba(168, 85, 247, 0.42), 0 0 48px rgba(236, 72, 153, 0.16);
  }
  50% {
    box-shadow: 0 0 0 1.5px rgba(236, 220, 255, 0.8), 0 0 36px rgba(168, 85, 247, 0.7), 0 0 72px rgba(236, 72, 153, 0.28);
  }
}
.hub-pills {
  position: absolute;
  z-index: 3;
  top: 79.4%;
  left: 7%;
  right: 7%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 1.5cqw;
}
.hub-pills span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 5cqw;
  padding: 0 2.1cqw;
  border-radius: 999px;
  border: 0.16cqw solid rgba(255, 255, 255, 0.22);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(8, 12, 36, 0.38));
  box-shadow: inset 0 0.12cqw 0 rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.92);
  font-size: 2.05cqw;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.hub-pills--single {
  top: 85.2%;
  left: 0;
  right: 0;
}

.hub-foot {
  position: absolute;
  z-index: 3;
  top: 93.6%;
  left: 10%;
  right: 10%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.hub-foot span {
  font-size: 2.25cqw;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.82);
}

@media (prefers-reduced-motion: reduce) {
  .hub-core {
    animation: none;
  }
}
.login-right {
  flex: 1 1;
  background-color: #f9fafb;
  background-image: url("https://www.toptal.com/designers/subtlepatterns/uploads/geometry2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  max-height: 100vh;
  overflow: hidden;
}

.login-box {
  background: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 450px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 90vh;
  overflow: hidden;
}
.login-box h2 {
  font-size: 1.75rem;
  color: #111827;
  margin-bottom: 0.25rem;
  text-align: center;
}
.login-box input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

.subtext {
  text-align: center;
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.google-button {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: white;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
.google-button img {
  width: 20px;
  height: 20px;
}

.divider {
  text-align: center;
  margin: 1rem 0;
  color: #9ca3af;
  position: relative;
}
.divider span {
  background: white;
  padding: 0 0.5rem;
}

.divider::before,
.divider::after {
  content: "";
  height: 1px;
  background: #e5e7eb;
  flex: 1 1;
  margin: 0 1rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #6b7280;
}
.actions a {
  color: #2B3991;
  text-decoration: none;
}
.actions a:hover {
  text-decoration: underline;
}

.login-submit {
  width: 100%;
  padding: 0.75rem;
  background: #2B3991;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
}
.login-submit:hover {
  background: #ED008C;
}

.signup-link {
  text-align: center;
  font-size: 0.9rem;
  margin-top: 1rem;
  color: #6b7280;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
.signup-link div {
  width: 100%;
  margin-bottom: 5px;
  text-align: center;
}
.signup-link span {
  color: #2B3991;
  cursor: pointer;
}

.terms {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 1rem;
}
.terms input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
}
.terms label {
  display: inline;
  cursor: pointer;
}
.terms a {
  color: #2B3991;
  text-decoration: none;
}
.terms a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
    max-height: none;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .login-left {
    flex: none;
    width: 100%;
    min-width: 0;
    min-height: 0;
    max-height: none;
    overflow: hidden;
    align-items: stretch;
  }
  .hero-frame {
    width: 100%;
    height: auto;
    max-height: none;
  }
  .login-right {
    flex: none;
    width: 100%;
    min-width: 0;
    padding: 1.5rem 1rem 2rem;
    min-height: auto;
    max-height: none;
    overflow: visible;
  }
  .login-stack,
  .login-right .login-card,
  .login-box {
    width: 100%;
    max-width: 100%;
  }
  .login-box {
    padding: 2rem;
    max-height: 100%;
    overflow: hidden;
  }
}
@media (max-width: 480px) {
  .login-box {
    padding: 1.5rem;
  }
}
.login-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(420px, 100%);
  gap: 1.1rem;
}

.login-right.login-panel {
  overflow: auto;
  background-color: #f5f6fa;
  background-image: radial-gradient(520px 280px at 80% 0%, rgba(43, 57, 145, 0.07), transparent 70%), linear-gradient(180deg, #f8f9fc 0%, #eef1f7 100%);
  background-repeat: no-repeat;
  background-size: auto;
  font-family: "Montserrat", sans-serif;
}

.login-right .login-card {
  width: min(420px, 100%);
  max-height: none;
  overflow: visible;
  padding: 2.4rem 2.15rem 1.85rem;
  border-radius: 20px;
  border: 1px solid rgba(43, 57, 145, 0.06);
  background: #fff;
  box-shadow: 0 20px 48px rgba(43, 57, 145, 0.1);
  gap: 0;
  text-align: center;
  font-family: "Montserrat", sans-serif;
}
.login-right .login-card h2 {
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 1.85rem;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1c2140;
  text-align: center;
}
.login-right .login-card input {
  width: 100%;
  height: 50px;
  padding: 0 1rem;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #eef3fb;
  color: #1c2140;
  font-family: "Montserrat", sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  cursor: text;
  outline: none;
  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.login-right .login-card input::placeholder {
  color: #8b95ad;
  font-weight: 400;
}
.login-right .login-card input:focus {
  background: #fff;
  border-color: #2b3991;
  box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);
}

.login-lead {
  margin: 0.4rem 0 1.4rem;
  font-family: "Montserrat", sans-serif;
  font-size: 0.84rem;
  font-weight: 500;
  color: #6b7280;
}

.login-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.4rem;
  margin-bottom: 0.85rem;
  text-align: left;
}
.login-field > span {
  font-family: "Montserrat", sans-serif;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #2b3991;
}

.login-password {
  position: relative;
}
.login-password input {
  padding-right: 4.5rem;
}

.login-reveal {
  position: absolute;
  top: 50%;
  right: 0.9rem;
  transform: translateY(-50%);
  border: 0;
  padding: 0;
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #2b3991;
  cursor: pointer;
}
.login-reveal:hover {
  color: #ed008c;
}

.login-right .login-card .actions {
  justify-content: flex-end;
  margin: -0.15rem 0 0.95rem;
  font-family: "Montserrat", sans-serif;
}
.login-right .login-card .actions a {
  font-weight: 600;
}
.login-right .login-card .actions a:hover {
  color: #ed008c;
  text-decoration: none;
}

.login-right .login-card .login-submit {
  height: 48px;
  border-radius: 12px;
  background: #2b3991;
  font-family: "Montserrat", sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  box-shadow: 0 10px 22px rgba(43, 57, 145, 0.2);
}
.login-right .login-card .login-submit:hover:not(:disabled) {
  background: #ed008c;
}
.login-right .login-card .login-submit:disabled {
  opacity: 0.7;
  cursor: wait;
}

.login-right .login-card .signup-link {
  margin-top: 1.15rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}
.login-right .login-card .signup-link span {
  font-weight: 600;
}
.login-right .login-card .signup-link span:hover {
  color: #ed008c;
}

.login-success-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(18, 22, 48, 0.46);
  backdrop-filter: blur(10px);
}

.login-success-modal {
  width: min(440px, 100%);
  padding: 2.35rem 2.1rem 1.85rem;
  border-radius: 24px;
  border: 1px solid rgba(43, 57, 145, 0.08);
  background: radial-gradient(280px 140px at 50% 0%, rgba(43, 57, 145, 0.08), transparent 70%), #fff;
  box-shadow: 0 28px 70px rgba(28, 33, 64, 0.28);
  text-align: center;
  font-family: "Montserrat", sans-serif;
  animation: loginSuccessIn 0.28s ease;
}
.login-success-modal h2 {
  margin: 0.35rem 0 0.7rem;
  font-family: "Montserrat", sans-serif;
  font-size: 1.55rem;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.03em;
  color: #1c2140;
}

@keyframes loginSuccessIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.login-success-mark {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(145deg, #2b3991 0%, #5b4db8 55%, #ed008c 140%);
  color: #fff;
  box-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);
  font-size: 1.7rem;
}
.login-success-mark.is-pending {
  background: linear-gradient(145deg, #b45309 0%, #f59e0b 100%);
  box-shadow: 0 12px 24px rgba(180, 83, 9, 0.24);
}

.login-success-name {
  display: block;
  margin-top: 0.2rem;
}

.login-success-kicker {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #2b3991;
}

.login-success-copy {
  margin: 0 0 1.15rem;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.5;
  color: #6b7280;
}

.login-success-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 1.35rem;
}

.login-success-role {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 0.85rem;
  border-radius: 999px;
  background: rgba(43, 57, 145, 0.08);
  color: #2b3991;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.login-success-email {
  font-size: 0.8rem;
  font-weight: 500;
  color: #8b95ad;
}

.login-success-setup {
  margin-top: 0.15rem;
}

.login-success-track {
  height: 4px;
  border-radius: 999px;
  background: rgba(43, 57, 145, 0.1);
  overflow: hidden;
}

.login-success-bar {
  display: block;
  height: 100%;
  width: 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #2b3991 0%, #ed008c 100%);
  animation: loginSetupFill 2.6s ease forwards;
}

.login-success-status {
  margin: 0.75rem 0 0;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #2b3991;
}

@keyframes loginSetupFill {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.login-interest {
  border: 0;
  background: transparent;
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 0.84rem;
  font-weight: 600;
  color: #2b3991;
  cursor: pointer;
}
.login-interest:hover {
  color: #ed008c;
}

.signup-page {
  display: flex;
  min-height: 100vh;
}

.signup-left {
  flex: 1 1;
  background: #fff;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #111827;
}

.brand-logo {
  font-size: 2.5rem;
  color: #2B3991;
  margin-bottom: 2rem;
  letter-spacing: 1px;
}

.feature h4 {
  margin: 1rem 0 0.5rem;
  color: #111827;
}
.feature p {
  color: #6b7280;
  font-size: 0.95rem;
}

.footer-links {
  margin-top: auto;
  display: flex;
  gap: 1rem;
  font-size: 0.9rem;
  color: #6b7280;
}
.footer-links a {
  color: inherit;
  text-decoration: none;
}
.footer-links a:hover {
  text-decoration: underline;
}

.signup-right {
  flex: 1 1;
  background: #f9fafb no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.signup-box {
  background: white;
  padding: 3rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}
.signup-box h2 {
  font-size: 1.75rem;
  color: #111827;
  margin-bottom: 0.25rem;
  text-align: center;
}
.signup-box label {
  font-size: 0.9rem;
  margin-top: 1rem;
  color: #374151;
}

.subtext {
  text-align: center;
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.signup-box input[type=text],
.signup-box input[type=email],
.signup-box input[type=password] {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  margin-top: 0.25rem;
}

.terms {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #6b7280;
}
.terms a {
  color: #2B3991;
  text-decoration: underline;
}

.signup-submit {
  width: 100%;
  margin-top: 1.5rem;
  padding: 0.75rem;
  background: #111827;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
}
.signup-submit:hover {
  background: #000000;
}

.signin-link {
  text-align: center;
  font-size: 0.9rem;
  margin-top: 1rem;
  color: #6b7280;
}
.signin-link span {
  color: #2B3991;
  cursor: pointer;
  text-decoration: underline;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
}
.top-header .logo {
  height: 40px;
}
.top-header .logo img {
  height: 40px;
  width: 60px;
}
.top-header .user_info {
  position: absolute;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}
.top-header .user_info .user_name {
  font-weight: bold;
}
.top-header .user_info button {
  font-size: 0.875rem;
}

.header_container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 1rem;
  position: relative;
  min-height: 48px;
  background-color: transparent;
  border-bottom: none;
}
.header_container i {
  display: block;
  cursor: pointer;
}
.header_container i::before {
  font-size: 1rem;
}
.header_container .simple-dropdown {
  position: relative;
}
.header_container .simple-dropdown .location-dropdown-trigger,
.header_container .simple-dropdown .simple-dropdown-trigger,
.header_container .simple-dropdown .user-profile-trigger {
  border-radius: 4px;
  transition: all 0.2s ease;
  min-height: 28px;
  display: flex;
  align-items: center;
  padding: 2px 6px;
}
.header_container .simple-dropdown .location-dropdown-trigger:hover,
.header_container .simple-dropdown .simple-dropdown-trigger:hover,
.header_container .simple-dropdown .user-profile-trigger:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.header_container .simple-dropdown .location-dropdown-trigger:active,
.header_container .simple-dropdown .simple-dropdown-trigger:active,
.header_container .simple-dropdown .user-profile-trigger:active {
  background-color: rgba(0, 0, 0, 0.08);
}
.header_container .simple-dropdown .user-profile-trigger .user-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_container .simple-dropdown .user-profile-trigger .user-details .user-name {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  letter-spacing: 0.02em;
}
.header_container .simple-dropdown .user-profile-trigger .user-details .user-role {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  letter-spacing: 0.02em;
}
.header_container .simple-dropdown .facility-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  min-width: 180px;
  max-width: 250px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  padding: 6px 0;
  margin-top: 2px;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item:hover {
  background-color: #f8f9fa;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item.active {
  background-color: #e3f2fd;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item.active .facility-name {
  color: #1565c0;
  font-weight: 600;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .facility-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .facility-icon i {
  font-size: 10px;
  color: #1976d2;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .facility-content {
  flex: 1 1;
  min-width: 0;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .facility-content .facility-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: #212529;
  margin-bottom: 1px;
  line-height: 1.1;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .facility-content .facility-type {
  font-size: 0.7rem;
  color: #6c757d;
  line-height: 1.1;
}
.header_container .simple-dropdown .facility-dropdown-menu .facility-dropdown-item .bi-check {
  font-size: 14px;
  margin-left: 6px;
}
.header_container .simple-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  min-width: 160px;
  border: 1px solid #dee2e6;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.15);
  border-radius: 0.3rem;
  padding: 0.4rem 0;
  background-color: white;
  margin-top: 2px;
}
.header_container .simple-dropdown .dropdown-item {
  padding: 0.4rem 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  color: #212529;
  font-size: 0.8rem;
}
.header_container .simple-dropdown .dropdown-item:hover {
  background-color: #f8f9fa;
}
.header_container .simple-dropdown .dropdown-item.active {
  background-color: #e3f2fd;
  color: #1976d2;
}
.header_container .cursor-pointer {
  cursor: pointer;
}

.header-notifications {
  position: relative;
}
.header-notifications__btn {
  position: relative;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: #e4eef7;
  color: #1e71bb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.header-notifications__btn i {
  font-size: 16px;
  line-height: 1;
}
.header-notifications__btn:hover, .header-notifications__btn.is-open {
  background: #d5e6f5;
}
.header-notifications__badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #dc3545;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}
.header-notifications__panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1060;
  width: 360px;
  max-width: min(360px, 80vw);
  background: #fff;
  border: 1px solid #e6eaf2;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.16);
  overflow: hidden;
}
.header-notifications__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #eef1f6;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1c2468;
}
.header-notifications__mark {
  border: 0;
  background: transparent;
  color: #1e71bb;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0;
}
.header-notifications__list {
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: 380px;
  overflow: auto;
}
.header-notifications__item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
  border: 0;
  background: transparent;
  border-radius: 10px;
  padding: 10px;
  position: relative;
}
.header-notifications__item:hover {
  background: #f6f8fc;
}
.header-notifications__item.is-unread {
  background: #f3f7fd;
}
.header-notifications__icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #e4eef7;
  color: #1e71bb;
}
.header-notifications__icon i {
  font-size: 15px;
}
.header-notifications__icon--po {
  background: #e8eefc;
  color: #2b3991;
}
.header-notifications__icon--asn {
  background: #e7f6ee;
  color: #1b7a45;
}
.header-notifications__icon--sales {
  background: #fff4e5;
  color: #b86e00;
}
.header-notifications__icon--shipment {
  background: #e4eef7;
  color: #1e71bb;
}
.header-notifications__copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-right: 10px;
}
.header-notifications__title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #212529;
}
.header-notifications__text {
  font-size: 0.75rem;
  color: #5c6778;
  margin-top: 2px;
}
.header-notifications__time {
  font-size: 0.7rem;
  color: #8b95a5;
  margin-top: 4px;
}
.header-notifications__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1e71bb;
  position: absolute;
  top: 14px;
  right: 10px;
}

.dropdown_wrapper {
  position: relative;
  display: inline-block;
  min-width: 70px;
}
.dropdown_wrapper .dropdown_label {
  border: none;
  background: #fff;
  font-size: 0.875rem !important;
  font-family: "Montserrat";
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: border 0.2s, box-shadow 0.2s;
  color: #222;
}
.dropdown_wrapper .dropdown_label:hover, .dropdown_wrapper .dropdown_label:focus {
  outline: none;
}
.dropdown_wrapper .dropdown_label i {
  height: 1rem;
  display: flex;
  align-items: center;
}
.dropdown_wrapper .dropdown_label i::before {
  font-size: 12px;
}
.dropdown_wrapper .dropdown_list {
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  background: #fff;
  border-radius: 0.25rem;
  z-index: 1000;
  padding: 0.5rem 0 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 180px;
}
.dropdown_wrapper .dropdown_list .dropdown_item {
  list-style: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.2rem;
  font-size: 0.75rem;
  transition: background 0.15s;
  color: #222;
}
.dropdown_wrapper .dropdown_list .dropdown_item:hover, .dropdown_wrapper .dropdown_list .dropdown_item:focus {
  background: #f5f5f5;
}
.dropdown_wrapper.dropdown-menu-left .dropdown_list {
  top: 110%;
  left: 0;
}
.dropdown_wrapper.dropdown-menu-right .dropdown_list {
  left: 65% !important;
  top: 105% !important;
}

.select_container .form-select:focus {
  box-shadow: none;
  outline: none;
  border: 1px solid #222;
}
.select_container .form-select option {
  background-color: white;
  color: black;
}
.select_container .form-select option:hover {
  background-color: #222;
  color: #fff;
}

.tab-wrapper {
  display: flex;
  flex-direction: column;
  width: calc(100% - 225px);
  height: 100%;
  overflow: hidden;
  transition: width 0.2s;
}

.sidebar-collapsed + .tab-wrapper {
  width: calc(100% - 56px);
}

.tab-bar {
  display: flex;
  background: #f8f8f8;
  border-bottom: 1px solid #c1c1c1;
  overflow-x: auto;
  white-space: nowrap;
  height: auto;
  overflow-y: hidden;
}

.tab-bar::-webkit-scrollbar {
  height: 4px;
}

.tab-bar::-webkit-scrollbar-thumb {
  background: #000;
  border-radius: 2px;
}

.tab {
  padding: 8px 12px;
  cursor: pointer;
  position: relative;
  /* background: #e0e0e0; */
  /* margin-right: 2px; */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  min-width: 100px;
  /* max-width: 200px; */
  overflow: hidden;
  text-overflow: ellipsis;
  height: auto;
  font-size: 14px;
  font-weight: 500;
}

.tab-icon-badge {
  width: 28px;
  height: 28px;
  margin-right: 8px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #e4eef7;
  color: #1e71bb;
}

.tab-icon {
  margin-right: 0;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
  color: #1e71bb;
}

.tab-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 auto;
}

.tab.active {
  background: #fff;
  border-bottom: 2px solid #2B3991;
}

.close-btn {
  margin-left: 5px;
  color: #888;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.add-btn {
  margin-left: 8px;
  padding: 0 10px;
  font-size: 18px;
  cursor: pointer;
  background: #e0e0e0;
  border: none;
  border-radius: 50%;
  height: 28px;
  display: flex;
  align-items: center;
}

.tab-content {
  flex: 1 1;
  padding: 5px;
  background: #fff;
  overflow-x: hidden;
  height: 100%;
}
.tab-content .card {
  height: calc(100% - 10px);
}

/* Inactive panes stay mounted (so tab state is kept) but hidden.
   The active pane fades and eases in instead of snapping open. */
.tab-pane-view {
  display: none;
}

.tab-pane-view.is-active {
  display: block;
  animation: tabPaneIn 0.32s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes tabPaneIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .tab-pane-view.is-active {
    animation: none;
  }
}
/* Responsive styles */
@media (max-width: 768px) {
  .tab-bar {
    font-size: 14px;
    padding: 0 4px;
    height: 30px;
  }
  .tab-bar::-webkit-scrollbar {
    height: 3px;
  }
  .tab {
    padding: 2px 8px;
    min-width: 80px;
    max-width: 120px;
    font-size: 13px;
    height: 22px;
  }
  .add-btn {
    height: 22px;
  }
  .tab-content {
    padding: 8px;
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .tab-bar {
    font-size: 12px;
    padding: 0 2px;
    height: 26px;
  }
  .tab-bar::-webkit-scrollbar {
    height: 2px;
  }
  .tab {
    padding: 1px 6px;
    min-width: 60px;
    max-width: 90px;
    font-size: 12px;
    height: 18px;
  }
  .add-btn {
    height: 18px;
  }
  .tab-content {
    padding: 4px;
    font-size: 13px;
  }
}
.ag-root-wrapper {
  font-weight: 400;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header {
  background-color: #222;
  color: #fff;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header .ag-header-viewport .ag-header-container .ag-header-row .ag-header-cell {
  padding: 0;
  font-size: 13px;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header .ag-header-viewport .ag-header-container .ag-header-row .ag-header-cell .ag-header-cell-resize::after {
  background-color: #fff;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header .ag-header-viewport .ag-header-container .ag-header-row .ag-header-cell .ag-header-cell-comp-wrapper .ag-cell-label-container .ag-header-cell-label .ag-header-cell-text {
  padding: 0 0.5rem;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body .ag-body-viewport .ag-viewport .ag-center-cols-container {
  height: 100% !important;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body .ag-body-viewport .ag-viewport .ag-center-cols-container .ag-row {
  border-bottom: 1px solid rgb(243, 243, 243);
  height: 40px !important;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body .ag-body-viewport .ag-viewport .ag-center-cols-container .ag-row .ag-cell {
  border: 0px !important;
  font-size: 12px;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body .ag-body-viewport .ag-viewport .ag-center-cols-container .ag-row.ag-row-hover:not(.ag-full-width-row):before {
  background-color: #cccccc;
}
.ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body .ag-body-viewport .ag-viewport .ag-center-cols-container .ag-row:last-child {
  border-bottom: none !important;
}

.row-deactivated {
  color: #888 !important;
  opacity: 0.7;
}

.ag-header-cell.ag-column-last,
.ag-cell.ag-column-last {
  border-right: none !important;
}

/* Hide resize handle for last column */
.ag-column-last .ag-header-cell-resize {
  display: none !important;
}

.MuiDataGrid-columnHeader {
  background-color: #f7f9fc !important;
}

.MuiDataGrid-columnSeparator--sideRight {
  right: -5px;
  color: #e2e8f0 !important;
}

.MuiDataGrid-scrollbarFiller {
  background-color: #f7f9fc !important;
}

.MuiDataGrid-filler {
  background-color: #f7f9fc !important;
}

.MuiDataGrid-virtualScroller {
  scroll-behavior: smooth !important;
}

.MuiDataGrid-virtualScrollerContent {
  transform: translateZ(0);
  will-change: transform;
}

.userTableRole {
  align-items: center;
  padding-bottom: 10px;
}

/* —— Admin tenant lists (pending approval + tenants) —— */
.admin-tenant-card {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(43, 57, 145, 0.12) !important;
}
.admin-tenant-card .admin-tenant-card__header {
  background: var(--sidebar-gradient) !important;
  padding: 1.1rem 1.35rem;
}
.admin-tenant-card .card-body {
  padding: 1.35rem;
  background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 140px);
}

.admin-tenant-grid-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(43, 57, 145, 0.1);
  box-shadow: 0 4px 24px rgba(30, 113, 187, 0.07);
  background: #fff;
}
.admin-tenant-grid-wrap .ag-root-wrapper {
  --ag-header-height: 46px;
  --ag-row-hover-color: rgba(43, 57, 145, 0.07);
  --ag-odd-row-background-color: rgba(248, 250, 252, 0.95);
  --ag-border-color: rgba(0, 0, 0, 0.06);
  font-size: 0.875rem;
}
.admin-tenant-grid-wrap .ag-header {
  background: var(--sidebar-gradient) !important;
  color: #fff !important;
}
.admin-tenant-grid-wrap .ag-header-cell,
.admin-tenant-grid-wrap .ag-header-cell .ag-header-cell-text {
  color: #fff !important;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.admin-tenant-grid-wrap .ag-icon {
  color: #fff !important;
  opacity: 0.9;
}
.admin-tenant-grid-wrap .ag-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.admin-tenant-grid-wrap .ag-cell {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  line-height: 1.45;
}
.admin-tenant-grid-wrap .ag-row-hover:not(.ag-full-width-row)::before {
  background-color: rgba(43, 57, 145, 0.06) !important;
}

.admin-tenant-grid-empty {
  border-radius: 12px;
  border: 1px dashed rgba(43, 57, 145, 0.2);
  background: rgba(248, 250, 252, 0.6);
}

/* Row action control (admin grids) */
.admin-grid-action-icon {
  cursor: pointer;
  font-size: 1.1rem !important;
  color: #2b3991 !important;
  padding: 0.4rem 0.5rem;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.admin-grid-action-icon:hover {
  background: rgba(43, 57, 145, 0.12);
  color: #1e71bb !important;
}
.admin-grid-action-icon:focus-visible {
  outline: 2px solid rgba(30, 113, 187, 0.5);
  outline-offset: 2px;
}

.admin-user-type-badge {
  background: rgba(255, 255, 255, 0.95) !important;
  border-color: rgba(43, 57, 145, 0.18) !important;
  color: #1a1d2e !important;
  font-weight: 600 !important;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2rem;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #222;
}
.footer p {
  margin: 0;
  padding: 0.5rem;
}

.password_container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.password_container .card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #222;
  color: #fff;
  padding: 2rem 2.5rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
}
.password_container .card h3 {
  color: #fff;
}
.password_container .card form .form-label {
  color: #ccc;
}
.password_container .card form input {
  width: 100%;
  background: #111;
  color: #fff;
  border: 1px solid #444;
}
.password_container .card form input:focus {
  border-color: #fff;
  outline: none;
  box-shadow: none;
}
.password_container .card form .btn {
  width: 100%;
  background: #fff;
  color: #111;
  font-weight: bold;
  border: none;
}

.onboarding-shell {
  --onboarding-primary: #2563eb;
  --onboarding-primary-hover: #1d4ed8;
  --onboarding-primary-active: #1e40af;
  --onboarding-secondary: #1e293b;
  --onboarding-bg: #f8fafc;
  --onboarding-muted: #64748b;
  --onboarding-border: #e2e8f0;
  --onboarding-card-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  min-height: 100vh;
  width: 100%;
  background: var(--onboarding-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1rem 3rem;
  gap: 1.75rem;
}

.onboarding-layout__main {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.75rem;
}

.onboarding-stepper-wrap {
  width: 100%;
  max-width: 960px;
  overflow-x: auto;
  overflow-y: visible;
  padding: 0.5rem 0 0.25rem;
  -webkit-overflow-scrolling: touch;
}
.onboarding-stepper-wrap::-webkit-scrollbar {
  height: 6px;
}
.onboarding-stepper-wrap::-webkit-scrollbar-thumb {
  background: var(--onboarding-border);
  border-radius: 3px;
}

.onboarding-stepper__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-width: min(100%, 680px);
  margin: 0 auto;
  gap: 0;
}

.onboarding-step-segment {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  min-width: 0;
  max-width: 120px;
}

.onboarding-step-node {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid var(--onboarding-border);
  background: #fff;
  color: var(--onboarding-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: background 0.25s ease, border-color 0.25s ease, color 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
}
.onboarding-step-node:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
}
.onboarding-step-node:disabled {
  cursor: default;
  opacity: 0.55;
}
.onboarding-step-node--current {
  background: var(--onboarding-primary);
  border-color: var(--onboarding-primary);
  color: #fff;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
}
.onboarding-step-node--complete {
  background: var(--onboarding-primary);
  border-color: var(--onboarding-primary);
  color: #fff;
}
.onboarding-step-node--upcoming {
  background: #fff;
  color: var(--onboarding-muted);
}

.onboarding-step-node__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.onboarding-step-icon,
.onboarding-step-check {
  font-size: 1.25rem !important;
}

.onboarding-step-fallback {
  font-size: 0.875rem;
  font-weight: 700;
}

.onboarding-step-label {
  margin-top: 0.5rem;
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--onboarding-muted);
  text-align: center;
  line-height: 1.2;
  transition: color 0.25s ease;
}
@media (min-width: 576px) {
  .onboarding-step-label {
    font-size: 0.75rem;
  }
}
.onboarding-step-label--current {
  color: var(--onboarding-primary);
  font-weight: 600;
}

.onboarding-step-connector {
  flex: 1 1 8px;
  min-width: 4px;
  height: 3px;
  /* Align bar with vertical center of 44px step node */
  margin-top: 20px;
  background: var(--onboarding-border);
  border-radius: 2px;
  transition: background 0.35s ease;
}
.onboarding-step-connector--active {
  background: linear-gradient(90deg, var(--onboarding-primary), #60a5fa);
}

.onboarding-card {
  width: min(100%, 560px);
  align-self: center;
  max-width: 560px;
  background: #fff;
  border-radius: 16px;
  box-shadow: var(--onboarding-card-shadow);
  padding: 1.75rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border: 1px solid rgba(226, 232, 240, 0.9);
}
@media (min-width: 768px) {
  .onboarding-card {
    padding: 2rem 2.25rem 1.75rem;
  }
}

.onboarding-back-link {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--onboarding-primary);
  text-decoration: none;
  transition: color 0.2s ease;
  align-self: center;
  white-space: nowrap;
}
.onboarding-back-link:hover {
  color: var(--onboarding-primary-hover);
  text-decoration: underline;
}

.onboarding-step-panel {
  animation: onboarding-step-in 0.4s ease;
}
.onboarding-step-panel .card_content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.onboarding-step-panel .card_content .onboarding-welcome-hero {
  text-align: center;
  margin-bottom: 0.25rem;
}
.onboarding-step-panel .card_content .onboarding-welcome-hero .onboarding-welcome-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;
}
.onboarding-step-panel .card_content .onboarding-welcome-hero .onboarding-welcome-brand img {
  height: 80px;
  width: auto;
  max-width: min(280px, 85vw);
  display: block;
  object-fit: contain;
}
.onboarding-step-panel .card_content .onboarding-welcome-hero .onboarding-page-subtitle {
  margin-top: 0.5rem;
}
.onboarding-step-panel .card_content h4,
.onboarding-step-panel .card_content .onboarding-page-title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--onboarding-secondary);
  line-height: 1.3;
  letter-spacing: -0.02em;
}
@media (min-width: 576px) {
  .onboarding-step-panel .card_content h4,
  .onboarding-step-panel .card_content .onboarding-page-title {
    font-size: 1.5rem;
  }
}
.onboarding-step-panel .card_content p,
.onboarding-step-panel .card_content .onboarding-page-subtitle {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--onboarding-muted);
  line-height: 1.55;
}
.onboarding-step-panel .card_content .select_container {
  width: 100%;
}
.onboarding-step-panel .card_content .select-input {
  width: 100%;
}
.onboarding-step-panel .card_content .form-label {
  color: var(--onboarding-secondary);
  margin-bottom: 0.35rem;
}
.onboarding-step-panel .card_content .form-select,
.onboarding-step-panel .card_content .form-control {
  border-radius: 10px;
  border: 1px solid var(--onboarding-border);
  padding: 0.55rem 0.85rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.onboarding-step-panel .card_content .form-select:hover:not(:disabled),
.onboarding-step-panel .card_content .form-control:hover:not(:disabled) {
  border-color: #cbd5e1;
}
.onboarding-step-panel .card_content .form-select:focus,
.onboarding-step-panel .card_content .form-control:focus {
  border-color: var(--onboarding-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  outline: none;
}
.onboarding-step-panel .card_content .input {
  width: 100%;
}
.onboarding-step-panel .card_content .card_container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.onboarding-step-panel .card_content .card_container .input,
.onboarding-step-panel .card_content .card_container .select-input {
  width: 100%;
  min-width: 200px;
}
@media (min-width: 576px) {
  .onboarding-step-panel .card_content .card_container .input,
  .onboarding-step-panel .card_content .card_container .select-input {
    width: calc(50% - 0.5rem);
  }
}
.onboarding-step-panel .card_content .card_container .onboarding-system-toggle .form-check.form-switch {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 46px;
  margin: 0;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--onboarding-border);
  border-radius: 10px;
  background: #fff;
}
.onboarding-step-panel .card_content .card_container .onboarding-system-toggle .form-check-input {
  width: 2.5rem;
  height: 1.3rem;
  margin: 0;
  float: none;
  cursor: pointer;
}
.onboarding-step-panel .card_content .card_container .onboarding-system-toggle .form-check-label {
  margin: 0;
  font-weight: 600;
  color: var(--onboarding-secondary);
}
.onboarding-step-panel .card_content .card_container .onboarding-system-toggle .form-check-input:checked {
  background-color: var(--onboarding-primary);
  border-color: var(--onboarding-primary);
}
.onboarding-step-panel .card_content .card_container .onboarding-system-toggle .form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  border-color: var(--onboarding-primary);
}
.onboarding-step-panel .card_content .card_container .onboarding-admin-toggle {
  width: 100%;
  padding-top: 0.15rem;
}
.onboarding-step-panel .card_content .card_container .onboarding-admin-toggle .form-check {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  min-height: 46px;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--onboarding-border);
  border-radius: 10px;
  background: #fff;
}
.onboarding-step-panel .card_content .card_container .onboarding-admin-toggle .form-check-input {
  margin: 0;
  float: none;
}
.onboarding-step-panel .card_content .card_container .onboarding-admin-toggle .form-check-label {
  margin: 0;
  color: var(--onboarding-secondary);
  font-weight: 600;
}
.onboarding-step-panel .card_content .card_container .onboarding-admin-toggle .form-check-input:checked {
  background-color: var(--onboarding-primary);
  border-color: var(--onboarding-primary);
}

@keyframes onboarding-step-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .onboarding-step-panel {
    animation: none;
  }
  .onboarding-step-node,
  .onboarding-step-connector,
  .onboarding-btn {
    transition: none;
  }
}
.onboarding-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  border-top: 1px solid var(--onboarding-border);
  margin-top: 0.25rem;
  padding-top: 1.25rem;
}

.onboarding-actions__buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-left: auto;
}

.onboarding-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.25;
  font-weight: 600;
  font-size: 0.9375rem;
  padding: 0.55rem 1.35rem;
  border-radius: 10px;
  min-width: 6rem;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease, opacity 0.2s ease;
}
.onboarding-btn--primary {
  background: linear-gradient(180deg, #3b82f6 0%, var(--onboarding-primary) 100%);
  border: none;
  color: #fff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
}
.onboarding-btn--primary:hover:not(:disabled) {
  background: linear-gradient(180deg, #2563eb 0%, var(--onboarding-primary-hover) 100%);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.4);
  transform: translateY(-1px);
  color: #fff;
}
.onboarding-btn--primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
  background: var(--onboarding-primary-active);
}
.onboarding-btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
.onboarding-btn--secondary {
  background: #fff;
  border: 1px solid var(--onboarding-border);
  color: var(--onboarding-secondary);
}
.onboarding-btn--secondary:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.onboarding-btn--ghost {
  background: transparent;
  border: 1px solid transparent;
  color: var(--onboarding-muted);
}
.onboarding-btn--ghost:hover:not(:disabled) {
  color: var(--onboarding-secondary);
  background: #f1f5f9;
}

.form-check-input {
  cursor: pointer;
}
.form-check-input:checked {
  background-color: #222;
  color: #fff;
  border-color: #222;
}
.form-check-input:focus {
  box-shadow: none;
  border-color: #222;
}

.checkbox_group .label {
  font-weight: 600;
  margin-bottom: 1rem;
}

.card-header.bg-secondary {
  background: #fff !important;
  color: #0f172a !important;
  border-bottom: 1px solid #eef2f7;
  padding: 12px 16px;
}
.card-header.bg-secondary h4,
.card-header.bg-secondary h5,
.card-header.bg-secondary h6,
.card-header.bg-secondary .h6 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #0f172a;
}
.card-header.bg-secondary h4::before,
.card-header.bg-secondary h5::before,
.card-header.bg-secondary h6::before,
.card-header.bg-secondary .h6::before {
  content: "";
  width: 4px;
  height: 18px;
  border-radius: 999px;
  background: var(--button-gradient, linear-gradient(to bottom, #2b3991, #1e71bb));
}

.inventory-module-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  padding: 0;
  margin: 0 0 14px;
}
.inventory-module-tabs button {
  border: 1px solid #d7dee8;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  padding: 8px 14px;
  border-radius: 6px;
}
.inventory-module-tabs button.active {
  background: #1e71bb;
  border-color: #1e71bb;
  color: #fff;
}

.card-body {
  overflow-x: overlay;
}
.card-body .table-navbar button {
  font-size: 12px;
}
.card-body .table-navbar .button-group .btn {
  font-size: 12px;
}
.card-body .MuiBox-root {
  gap: 10px;
}
.card-body .MuiButton-containedPrimary {
  background: #2B3991;
  box-shadow: none;
  text-transform: capitalize;
  font-family: "Montserrat" !important;
  font-size: 12px;
  padding: 6px 16px;
  border-radius: 6px;
}
.card-body .MuiButton-containedPrimary:hover {
  background: #ED008C;
  outline: none;
}
.card-body .MuiButton-outlined {
  text-transform: capitalize;
  font-family: "Montserrat" !important;
  color: #2B3991;
  border-color: #2B3991;
  font-size: 12px;
  padding: 6px 16px;
  border-radius: 6px;
}

.MuiDataGrid-root * {
  font-family: "Montserrat" !important;
}
.MuiDataGrid-root p {
  margin-bottom: 0;
}

.table-navbar .add-button {
  background: #2B3991;
  box-shadow: none;
  text-transform: capitalize;
  font-family: "Montserrat" !important;
  color: white !important;
}
.table-navbar .add-button:hover {
  background: #ED008C;
  outline: none;
}

.roleModule {
  padding: 10px;
}

.noGap .gap-3 {
  gap: 0 !important;
}

.default-role-row {
  background-color: #f5f5f5 !important; /* light gray */
}

.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0;
  margin: 0;
  z-index: 9999;
  list-style: none;
  min-width: 85px;
}

.temp-user-details {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: auto;
  max-height: 475px;
}

.custom-accordion .accordion-item {
  border: none;
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.custom-accordion .accordion-header {
  background: #f8f9fa;
}
.custom-accordion .accordion-header button {
  padding-left: 10px;
  padding-right: 0px;
}

.custom-accordion .accordion-button {
  font-weight: 600;
  font-size: 1.1rem;
  background: #f8f9fa;
  color: #333;
  border: none;
  outline: none;
  box-shadow: none;
  transition: background 0.2s;
  position: relative;
  /* padding-right: 2.5rem; */
}

.custom-accordion .accordion-button::after {
  content: "";
  display: inline-block;
  width: 1.1em;
  height: 1.1em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 1.1em 1.1em;
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  transition: transform 0.3s;
}

.custom-accordion .accordion-button:not(.collapsed) {
  background: #e9ecef;
  color: #007bff;
}

.custom-accordion .accordion-button:not(.collapsed)::after {
  transform: translateY(-50%) rotate(180deg);
}

.custom-accordion .accordion-body {
  background: #fff;
  padding: 1.5rem;
}

.contact-item {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  padding: 1.15rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid rgba(43, 57, 145, 0.08);
  box-shadow: 0 2px 12px rgba(30, 113, 187, 0.05);
}

.tenants-manage-panel {
  max-width: 960px;
  margin: 0 auto;
  padding: 0.25rem 0 1rem;
}
.tenants-manage-panel .tenants-manage-panel__title {
  letter-spacing: -0.02em;
  color: #1a1d2e;
}

.tenants-manage-accordion.custom-accordion .accordion-item {
  border: 1px solid rgba(43, 57, 145, 0.1);
  box-shadow: 0 4px 20px rgba(30, 113, 187, 0.06);
}

.tenants-manage-accordion.custom-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(90deg, rgba(43, 57, 145, 0.08) 0%, rgba(30, 113, 187, 0.06) 100%);
  color: #2b3991;
}

.section-review-box {
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%) !important;
  box-shadow: 0 4px 20px rgba(43, 57, 145, 0.08);
  border: 1px solid rgba(43, 57, 145, 0.1) !important;
}

.black-white-theme {
  background: #fff !important;
  color: #111 !important;
}

.black-white-theme .custom-accordion .accordion-item {
  background: #f8f9fa;
  color: #111;
  border: 1px solid #e0e0e0;
}

.black-white-theme .custom-accordion .accordion-header,
.black-white-theme .custom-accordion .accordion-button {
  background: #f5f5f5;
  color: #111;
  border: none;
}

.black-white-theme .custom-accordion .accordion-button:not(.collapsed) {
  background: #e9ecef;
  color: #111;
}

.black-white-theme .custom-accordion .accordion-body {
  background: #fff;
  color: #111;
}

.form-label {
  align-content: end;
  font-size: 12px;
}

select.form-control {
  appearance: auto !important;
}

input[readonly], .form-control[readonly] {
  background: #f5f5f5 !important;
  color: #888 !important;
  /* border: 1px solid #e0e0e0 !important; */
}

@media (max-width: 600px) {
  .temp-user-details {
    padding: 0.5rem !important;
  }
  .custom-accordion .accordion-body {
    padding: 1rem;
  }
}
.stripe-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(248, 250, 252, 0.72);
  backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stripe-loader-overlay-dots {
  background: rgba(248, 250, 252, 0.45);
  backdrop-filter: blur(2px);
}

.dot-loader {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px rgba(30, 57, 145, 0.12);
}
.dot-loader span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: linear-gradient(145deg, #2b3991, #1e71bb);
  animation: dot-loader-wave 1.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}
.dot-loader span:nth-child(2) {
  animation-delay: 0.16s;
}
.dot-loader span:nth-child(3) {
  animation-delay: 0.32s;
}

@keyframes dot-loader-wave {
  0%, 80%, 100% {
    transform: translateY(0) scale(0.85);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-7px) scale(1);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dot-loader span {
    animation: none;
    opacity: 0.8;
  }
}
.brand-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.brand-loader-stage {
  perspective: 900px;
}

.brand-loader-tile {
  position: relative;
  width: 220px;
  height: 150px;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #ffffff 0%, #f3f7fc 55%, #e7eff8 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), inset 0 -6px 14px rgba(30, 57, 145, 0.08), 0 2px 4px rgba(30, 57, 145, 0.08), 0 14px 28px rgba(30, 57, 145, 0.14), 0 30px 60px rgba(30, 113, 187, 0.16);
  transform-style: preserve-3d;
  animation: brand-loader-tilt 2.8s ease-in-out infinite;
}

.brand-loader-logo {
  width: 170px;
  height: auto;
  display: block;
  transform: translateZ(28px);
  filter: drop-shadow(0 6px 10px rgba(43, 57, 145, 0.22));
}

.brand-loader-shine {
  position: absolute;
  inset: -40% auto -40% -60%;
  width: 45%;
  background: linear-gradient(100deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0) 100%);
  transform: rotate(18deg);
  animation: brand-loader-shine 2.8s ease-in-out infinite;
  pointer-events: none;
}

.brand-loader-floor {
  width: 150px;
  height: 14px;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(30, 57, 145, 0.28) 0%, rgba(30, 57, 145, 0) 70%);
  animation: brand-loader-floor 2.8s ease-in-out infinite;
}

@keyframes brand-loader-tilt {
  0%, 100% {
    transform: rotateX(8deg) rotateY(-16deg) translateY(0);
  }
  50% {
    transform: rotateX(4deg) rotateY(16deg) translateY(-8px);
  }
}
@keyframes brand-loader-shine {
  0%, 25% {
    left: -60%;
  }
  75%, 100% {
    left: 130%;
  }
}
@keyframes brand-loader-floor {
  0%, 100% {
    transform: scaleX(1);
    opacity: 0.9;
  }
  50% {
    transform: scaleX(0.82);
    opacity: 0.55;
  }
}
@media (prefers-reduced-motion: reduce) {
  .brand-loader-tile,
  .brand-loader-shine,
  .brand-loader-floor {
    animation: none;
  }
}
.modules-container {
  padding: 20px;
  font-family: "Segoe UI", sans-serif;
}
.modules-container .title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}
.modules-container .modules-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #fff;
  display: block;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* clip children overflow to keep rounded corners */
  -webkit-overflow-scrolling: touch;
  table-layout: fixed;
  width: 100%;
  table-layout: auto;
  /* natural column sizing */
  overflow-x: visible;
  /* no horizontal scroll */
  max-height: none;
  /* remove max-height so no vertical scroll */
}
.modules-container .modules-table thead {
  position: sticky;
  top: 0;
  background-color: #212121;
  color: #fff;
  z-index: 1;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.modules-container .modules-table th,
.modules-container .modules-table td {
  padding: 12px 16px;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 1px solid #e0e0e0;
}
.modules-container .modules-table th:last-child,
.modules-container .modules-table td:last-child {
  border-right: none;
}
.modules-container .modules-table th:nth-child(1),
.modules-container .modules-table td:nth-child(1) {
  width: 60px;
  /* wider for the toggle icon */
}
.modules-container .modules-table th:nth-child(2),
.modules-container .modules-table td:nth-child(2) {
  width: 300px;
  /* wider for Title */
}
.modules-container .modules-table th:nth-child(3),
.modules-container .modules-table td:nth-child(3) {
  width: 350px;
  /* wider for Path */
}
.modules-container .modules-table th:nth-child(4),
.modules-container .modules-table td:nth-child(4) {
  width: 150px;
  /* Status */
}
.modules-container .modules-table th {
  font-weight: 500;
  font-size: 14px;
}
.modules-container .modules-table tr {
  transition: background 0.2s;
}
.modules-container .modules-table tr:hover {
  background-color: transparent;
}
.modules-container .modules-table .parent-row {
  background-color: #fff;
  font-weight: 500;
}
.modules-container .modules-table .child-row {
  background-color: #fafafa;
}
.modules-container .modules-table .child-row td:first-child {
  padding-left: 28px;
}
.modules-container .modules-table .subchild-row {
  background-color: #f2f2f2;
}
.modules-container .modules-table .subchild-row td:first-child {
  padding-left: 48px;
}
.modules-container .modules-table {
  /* round bottom corners on last row */
}
.modules-container .modules-table tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
.modules-container .modules-table tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

.row-active {
  background-color: #ffffff !important;
  color: #000000 !important;
}
.row-active:hover {
  background-color: #f5f5f5 !important;
}

.row-disabled {
  background-color: #f5f5f5 !important;
  color: #666666 !important;
  opacity: 0.7;
}
.row-disabled:hover {
  background-color: #eeeeee !important;
}
.row-disabled td {
  color: #999999 !important;
}

.cdt-root {
  font-family: "Montserrat", sans-serif;
}

.cdt-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.cdt-toolbar .cdt-divider {
  width: 1px;
  height: 22px;
  margin: 0 2px;
  background: #e2e8f0;
}

.cdt-toolbar .cdt-btn.MuiButton-root {
  height: 34px;
  min-width: auto;
  padding: 0 14px;
  gap: 6px;
  border-radius: 10px;
  font-family: "Montserrat", sans-serif !important;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  white-space: nowrap;
  box-shadow: none;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}
.cdt-toolbar .cdt-btn.MuiButton-root i {
  font-size: 14px;
  line-height: 1;
}
.cdt-toolbar .cdt-btn.MuiButton-root:active {
  transform: translateY(1px);
}

.cdt-toolbar .cdt-btn-primary.MuiButton-root {
  color: #fff;
  border: 0;
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
  box-shadow: 0 1px 2px rgba(43, 57, 145, 0.2), 0 6px 14px rgba(30, 113, 187, 0.22);
}
.cdt-toolbar .cdt-btn-primary.MuiButton-root:hover {
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
  box-shadow: 0 2px 4px rgba(43, 57, 145, 0.24), 0 10px 20px rgba(30, 113, 187, 0.28);
  transform: translateY(-1px);
}

.cdt-toolbar .cdt-btn-soft.MuiButton-root {
  color: #2b3991;
  background: #eef3fb;
  border: 1px solid transparent;
}
.cdt-toolbar .cdt-btn-soft.MuiButton-root:hover {
  background: #e2ebf8;
  border-color: transparent;
}

.cdt-toolbar .cdt-btn-ghost.MuiButton-root {
  color: #334155;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.cdt-toolbar .cdt-btn-ghost.MuiButton-root:hover {
  color: #1e71bb;
  background: #f8fbff;
  border-color: #c9d9ee;
}

.cdt-toolbar .cdt-btn-link.MuiButton-root {
  height: 30px;
  padding: 0 8px;
  color: #dc2626;
  background: transparent;
}
.cdt-toolbar .cdt-btn-link.MuiButton-root:hover {
  background: #fef2f2;
}

.cdt-toolbar .cdt-icon-btn.MuiIconButton-root {
  width: 34px;
  height: 34px;
  padding: 0 !important;
  border-radius: 10px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
}
.cdt-toolbar .cdt-icon-btn.MuiIconButton-root:hover, .cdt-toolbar .cdt-icon-btn.MuiIconButton-root.is-active {
  color: #1e71bb;
  background: #eef5fd;
  border-color: #c9d9ee;
}
.cdt-toolbar .cdt-icon-btn.MuiIconButton-root .MuiBadge-badge {
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-size: 10px;
}

.cdt-toolbar-end {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.cdt-refresh {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 4px 0 12px;
  border-radius: 999px;
  background: #f7f9fc;
  border: 1px solid #e6edf5;
  font-size: 12px;
}

.cdt-refresh-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
}

.cdt-refresh-label {
  color: #64748b;
  font-weight: 500;
}

.cdt-refresh-time {
  color: #0f172a;
  font-weight: 600;
}

.cdt-refresh .cdt-refresh-btn.MuiIconButton-root {
  width: 26px;
  height: 26px;
  padding: 0 !important;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.cdt-refresh .cdt-refresh-btn.MuiIconButton-root:hover {
  color: #1e71bb;
  border-color: #c9d9ee;
}
.cdt-refresh .cdt-refresh-btn.MuiIconButton-root:hover svg {
  transform: rotate(90deg);
}
.cdt-refresh .cdt-refresh-btn.MuiIconButton-root svg {
  transition: transform 0.3s ease;
}

.cdt-header-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.cdt-col-filter {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid #d6dee8;
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 12px;
  color: #111827;
  background: #fff;
  outline: none;
}

.cdt-col-filter:focus {
  border-color: #1e71bb;
  box-shadow: 0 0 0 2px rgba(30, 113, 187, 0.12);
}

.cdt-col-filter::placeholder {
  color: #94a3b8;
}

.cdt-grid .MuiDataGrid-row {
  animation: cdt-row-in 0.35s ease both;
}

.cdt-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
.cdt-status::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.cdt-status-primary {
  background: #eaf2fd;
  color: #1d5fae;
}

.cdt-status-info {
  background: #e6f6f8;
  color: #0e7490;
}

.cdt-status-success {
  background: #e8f6ee;
  color: #15803d;
}

.cdt-status-warning {
  background: #fdf3e2;
  color: #b45309;
}

.cdt-status-danger {
  background: #fdecec;
  color: #b91c1c;
}

.cdt-status-neutral {
  background: #f1f5f9;
  color: #475569;
}

@keyframes cdt-row-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .cdt-grid .MuiDataGrid-row {
    animation: none;
  }
}
.cdt-columns-dialog {
  display: flex;
  flex-direction: column;
  width: min(420px, 100vw);
  height: 100%;
  border-radius: 20px 0 0 20px !important;
  font-family: "Montserrat", sans-serif;
  color: #1c2140;
  overflow: hidden;
}

.cdt-columns-dialog .cdt-columns-head,
.cdt-columns-dialog .cdt-columns-foot {
  flex-shrink: 0;
}

.cdt-columns-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.35rem 1.35rem 1rem;
  background: radial-gradient(220px 120px at 0% 0%, rgba(237, 0, 140, 0.16), transparent 70%), linear-gradient(165deg, #1c2468 0%, #12183a 100%);
  color: #fff;
}
.cdt-columns-head h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.03em;
}
.cdt-columns-head p:last-child {
  margin: 0.4rem 0 0;
  max-width: 42ch;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.74);
}

.cdt-columns-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #f4b6d6;
}

.cdt-columns-close {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
}
.cdt-columns-close:hover {
  background: rgba(255, 255, 255, 0.18);
}

.cdt-columns-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  padding: 1rem 1.35rem 0.4rem;
}

.cdt-columns-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
}
.cdt-columns-meta button {
  border: 0;
  padding: 0;
  background: transparent;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  color: #2b3991;
  cursor: pointer;
}
.cdt-columns-meta button:hover {
  color: #ed008c;
}

.cdt-columns-search {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  height: 44px;
  padding: 0 0.85rem;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #eef3fb;
}
.cdt-columns-search i {
  color: #8b95ad;
}
.cdt-columns-search input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 500;
  color: #1c2140;
}
.cdt-columns-search input::placeholder {
  color: #8b95ad;
  font-weight: 400;
}
.cdt-columns-search button {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}
.cdt-columns-search button:hover {
  background: #fff;
  color: #1c2140;
}
.cdt-columns-search:focus-within {
  background: #fff;
  border-color: #2b3991;
  box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);
}

.cdt-columns-found {
  margin: 0.45rem 0 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
}

.cdt-columns-list {
  flex: 1 1;
  min-height: 0;
  margin-top: 0.75rem;
  overflow: auto;
}

.cdt-columns-empty {
  margin: 0;
  padding: 1.5rem 0.5rem;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6b7280;
}

.cdt-columns-row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0 0 0.35rem;
  padding: 0.15rem 0.45rem 0.15rem 0.2rem;
  border-radius: 12px;
  cursor: pointer;
}
.cdt-columns-row:hover {
  background: #f4f7fc;
}
.cdt-columns-row.is-on {
  background: rgba(43, 57, 145, 0.06);
}
.cdt-columns-row .MuiCheckbox-root {
  color: #94a3b8;
}
.cdt-columns-row .MuiCheckbox-root.Mui-checked {
  color: #2b3991;
}

.cdt-columns-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.cdt-columns-name {
  font-size: 0.86rem;
  font-weight: 600;
  color: #1c2140;
}

.cdt-columns-field {
  font-size: 0.72rem;
  font-weight: 500;
  color: #8b95ad;
}

.cdt-columns-index {
  min-width: 22px;
  font-size: 0.72rem;
  font-weight: 600;
  text-align: right;
  color: #8b95ad;
}

.cdt-columns-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1.35rem 1.1rem;
  border-top: 1px solid #eef1f6;
}

.cdt-columns-bulk,
.cdt-columns-actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.cdt-columns-foot button {
  height: 36px;
  padding: 0 0.85rem;
  border: 0;
  border-radius: 10px;
  background: #eef3fb;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  color: #2b3991;
  cursor: pointer;
}
.cdt-columns-foot button:hover:not(:disabled) {
  background: #e2ebf8;
}
.cdt-columns-foot button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.cdt-columns-foot button.is-primary {
  background: #2b3991;
  color: #fff;
  box-shadow: 0 8px 16px rgba(43, 57, 145, 0.2);
}
.cdt-columns-foot button.is-primary:hover {
  background: #ed008c;
}

.cdt-filters-dialog {
  display: flex;
  flex-direction: column;
  width: min(420px, 100vw);
  height: 100%;
  border-radius: 20px 0 0 20px !important;
  font-family: "Montserrat", sans-serif;
  color: #1c2140;
  overflow: hidden;
}

.cdt-filters-dialog .cdt-columns-head,
.cdt-filters-dialog .cdt-columns-foot {
  flex-shrink: 0;
}

.cdt-filters-body {
  flex: 1 1;
  min-height: 0;
  padding: 1rem 1.35rem 0.85rem;
  overflow: auto;
}

.cdt-filter-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  margin-top: 0.35rem;
  padding: 1.6rem 1rem 1.3rem;
  border: 1px dashed rgba(43, 57, 145, 0.18);
  border-radius: 16px;
  background: #f7f9fc;
  text-align: center;
}
.cdt-filter-empty i {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #fff;
  color: #2b3991;
  font-size: 1.05rem;
  box-shadow: 0 8px 18px rgba(43, 57, 145, 0.08);
}
.cdt-filter-empty p {
  margin: 0;
  max-width: 28ch;
  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.45;
  color: #6b7280;
}
.cdt-filter-empty button {
  height: 36px;
  margin-top: 0.2rem;
  padding: 0 0.95rem;
  border: 0;
  border-radius: 10px;
  background: #2b3991;
  color: #fff;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}
.cdt-filter-empty button:hover {
  background: #ed008c;
}

.cdt-filter-list {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.cdt-filter-card {
  padding: 0.75rem 0.8rem 0.85rem;
  border: 1px solid rgba(43, 57, 145, 0.08);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 33, 64, 0.04);
}

.cdt-filter-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.65rem;
}

.cdt-filter-index {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 0.55rem;
  border-radius: 999px;
  background: rgba(43, 57, 145, 0.08);
  color: #2b3991;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.cdt-filter-remove {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}
.cdt-filter-remove:hover {
  background: #fdecec;
  color: #b91c1c;
}

.cdt-filter-grid {
  display: grid;
  grid-template-columns: 1.3fr 0.9fr;
  gap: 0.7rem;
}

.cdt-filter-span {
  grid-column: 1/-1;
}

.cdt-filter-field.MuiFormControl-root .MuiInputLabel-root {
  font-family: "Montserrat", sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
}
.cdt-filter-field.MuiFormControl-root .MuiInputLabel-root.Mui-focused {
  color: #2b3991;
}
.cdt-filter-field.MuiFormControl-root .MuiOutlinedInput-root {
  border-radius: 12px;
  background: #eef3fb;
  font-family: "Montserrat", sans-serif;
  font-size: 0.86rem;
  font-weight: 500;
  color: #1c2140;
}
.cdt-filter-field.MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.cdt-filter-field.MuiFormControl-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.cdt-filter-field.MuiFormControl-root .MuiOutlinedInput-root.Mui-focused {
  background: #fff;
  box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);
}
.cdt-filter-field.MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #2b3991;
  border-width: 1px;
}
.cdt-filter-field.MuiFormControl-root .MuiSelect-select {
  font-family: "Montserrat", sans-serif;
}

@media (max-width: 640px) {
  .cdt-filter-grid {
    grid-template-columns: 1fr;
  }
  .cdt-filter-span {
    grid-column: auto;
  }
  .cdt-columns-foot {
    flex-direction: column;
    align-items: stretch;
  }
  .cdt-columns-bulk,
  .cdt-columns-actions {
    justify-content: space-between;
  }
}
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.confirm-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  width: 350px;
  z-index: 1001;
}

.confirm-title {
  margin: 0 0 12px 0;
  font-size: 20px;
}

.confirm-message {
  margin: 0 0 20px 0;
  color: #555;
}

.confirm-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.confirm-btn {
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease;
}

.yes-btn {
  border: none;
  background-color: #007bff;
  color: #fff;
}

.yes-btn:hover {
  background-color: #0056b3;
}

.no-btn {
  border: 1px solid #ccc;
  background-color: #f0f0f0;
}

.no-btn:hover {
  background-color: #e0e0e0;
}

.modal-dialog.pp-disable-dialog {
  max-width: 520px;
  height: 100%;
  min-height: 0;
  align-items: center;
}

.pp-disable-content {
  height: auto;
  flex: 0 0 auto;
  width: 100%;
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(17, 24, 39, 0.18), 0 2px 8px rgba(17, 24, 39, 0.06);
}

body .modal-body.pp-disable-body {
  position: relative;
  flex: 0 0 auto;
  height: auto;
  overflow: visible;
  padding: 28px 28px 8px;
}

.pp-disable-close {
  position: absolute;
  top: 18px;
  right: 18px;
}

.pp-disable-mark {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(180deg, #f7f8fd 0%, #e8ebf7 100%);
  color: #2b3991;
  font-size: 1.35rem;
  box-shadow: inset 0 0 0 1px rgba(43, 57, 145, 0.14);
}

.pp-disable-kicker {
  font-size: 0.7rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
}

.pp-disable-title {
  margin: 0 0 8px;
  padding-right: 24px;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #111827;
}

.pp-disable-copy {
  margin: 0;
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.55;
}

.pp-disable-details {
  margin: 20px 0 0;
  padding: 4px 16px;
  border-radius: 14px;
  background: #f7f8fc;
  border: 1px solid #e6e8f2;
}

.pp-disable-detail {
  display: grid;
  grid-template-columns: 108px 1fr;
  gap: 12px;
  align-items: baseline;
  padding: 10px 0;
  border-bottom: 1px solid #e6e8f2;
}

.pp-disable-detail:last-child {
  border-bottom: 0;
}

.pp-disable-detail dt {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 600;
  color: #6b7280;
}

.pp-disable-detail dd {
  margin: 0;
  color: #111827;
  font-size: 0.92rem;
  line-height: 1.4;
  word-break: break-word;
}

.pp-disable-detail-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.04em;
  color: #2b3991;
  font-weight: 700;
}

.pp-disable-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: #eef0f6;
  color: #374151;
}

.pp-disable-status--active {
  background: #e8f6ee;
  color: #166534;
}

.pp-disable-status--inactive,
.pp-disable-status--pending {
  background: #f3f4f6;
  color: #4b5563;
}

.pp-disable-footer {
  border: 0;
  padding: 20px 28px 28px;
  gap: 10px;
}

.pp-disable-confirm {
  background: #2b3991;
  border-color: #2b3991;
  color: #fff;
  min-width: 112px;
  font-weight: 600;
}

.pp-disable-confirm:hover,
.pp-disable-confirm:focus {
  background: #1e2870;
  border-color: #1e2870;
  color: #fff;
}

.settings-content {
  font-size: 0.85rem;
  font-weight: 400;
}

.settings-content .card-header h5 {
  font-size: 0.9rem;
  font-weight: 500;
}

.settings-content .form-label,
.settings-content .form-check-label,
.settings-content p,
.settings-content li {
  font-size: 0.85rem;
  font-weight: 400;
}

.settings-content .form-control,
.settings-content .form-select {
  font-size: 0.85rem;
  font-weight: 400;
}

.tenant-card {
  font-size: 0.85rem;
  font-weight: 400;
}

.tenant-card-header {
  font-size: 0.9rem;
  font-weight: 500;
}

.tenant-card-title {
  font-size: 0.9rem;
  font-weight: 500;
}

.tenant-card-body {
  font-size: 0.85rem;
  font-weight: 400;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.tenant-label {
  font-size: 0.85rem;
  font-weight: 500;
}

.tenant-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.tenant-select {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.tenant-subtitle {
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.tenant-btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  border-radius: 6px;
  min-width: 70px;
}

.tenant-url-row {
  gap: 0.25rem;
}

.password-card {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.85rem;
  font-weight: 400;
}

.password-card-header {
  font-size: 0.9rem;
  font-weight: 500;
}

.password-card-title {
  font-size: 0.9rem;
  font-weight: 500;
}

.password-card-body {
  font-size: 0.85rem;
  font-weight: 400;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.password-label {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.password-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.password-btn {
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
}

.profile-card {
  font-size: 0.85rem;
  font-weight: 400;
}

.profile-card-header {
  font-size: 0.9rem;
  font-weight: 500;
}

.profile-card-title {
  font-size: 0.9rem;
  font-weight: 500;
}

.profile-card-body {
  font-size: 0.85rem;
  font-weight: 400;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.profile-label {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.profile-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.profile-btn {
  padding: 0.25rem 0.75rem;
  font-size: 0.8rem;
}

.gradient-btn {
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
  color: #fff !important;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  transition: opacity 0.2s ease-in-out;
}

.gradient-btn:hover {
  opacity: 0.9;
}

.user-settings {
  --settings-ink: #171b2e;
  --settings-muted: #6d758c;
  --settings-line: rgba(28, 39, 84, 0.08);
  --settings-surface: #ffffff;
  --settings-canvas: #f3f5fb;
  min-height: calc(100vh - 156px);
  display: grid;
  grid-template-columns: 292px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 16px;
  background: radial-gradient(900px 280px at 0% -20%, rgba(43, 57, 145, 0.1), transparent 60%), radial-gradient(700px 240px at 100% 0%, rgba(30, 113, 187, 0.1), transparent 55%), var(--settings-canvas);
  color: var(--settings-ink);
  font-family: "Montserrat", "Segoe UI", sans-serif;
  font-size: 0.8rem;
}

.settings-rail,
.settings-panel {
  background: var(--settings-surface);
  border: 1px solid var(--settings-line);
  border-radius: 22px;
  box-shadow: 0 16px 40px rgba(23, 32, 74, 0.06);
}

.settings-rail {
  padding: 18px 14px 14px;
  position: sticky;
  top: 8px;
  align-self: start;
}

.settings-identity {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 8px 8px 18px;
  border-bottom: 1px solid var(--settings-line);
  margin-bottom: 14px;
}

.settings-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  font-size: 0.85rem;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: #fff;
  font-weight: 650;
  letter-spacing: 0.04em;
  background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));
  box-shadow: 0 10px 22px rgba(43, 57, 145, 0.28);
}

.settings-identity__copy {
  min-width: 0;
}
.settings-identity__copy h1 {
  margin: 0 0 2px;
  font-size: 0.84rem;
  font-weight: 650;
  line-height: 1.3;
}
.settings-identity__copy p {
  margin: 0;
  color: var(--settings-muted);
  font-size: 0.72rem;
  word-break: break-word;
}

.settings-org {
  display: inline-flex;
  text-wrap: auto;
  margin-top: 8px;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(43, 57, 145, 0.08);
  color: #2b3991;
  font-size: 0.65rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settings-nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.settings-nav__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  color: #30364a;
  text-align: left;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}
.settings-nav__item strong,
.settings-nav__item small {
  display: block;
}
.settings-nav__item strong {
  font-size: 0.78rem;
  font-weight: 650;
}
.settings-nav__item small {
  margin-top: 1px;
  color: var(--settings-muted);
  font-size: 0.65rem;
}
.settings-nav__item:hover {
  background: #f6f8fd;
}
.settings-nav__item.is-active {
  background: linear-gradient(180deg, rgba(43, 57, 145, 0.1), rgba(30, 113, 187, 0.06));
  border-color: rgba(43, 57, 145, 0.14);
  color: #24306f;
}
.settings-nav__item.is-active .settings-nav__icon {
  background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));
  color: #fff;
}

.settings-nav__icon {
  width: 30px;
  height: 30px;
  font-size: 0.85rem;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #eef2fa;
  color: #2b3991;
  flex-shrink: 0;
}

.settings-panel {
  padding: 26px 28px 22px;
  min-width: 0;
}

.settings-kicker {
  margin: 0 0 6px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.68rem;
  font-weight: 700;
  color: #1e71bb;
}

.settings-panel__head {
  margin-bottom: 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--settings-line);
}
.settings-panel__head h2 {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.settings-lead {
  margin: 8px 0 0;
  max-width: 62ch;
  color: var(--settings-muted);
  font-size: 0.75rem;
  line-height: 1.45;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 18px;
}

.settings-grid--single {
  grid-template-columns: minmax(0, 520px);
}

.settings-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.settings-field__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7b8296;
}
.settings-field__label em {
  font-style: normal;
  letter-spacing: 0;
  text-transform: none;
  font-size: 0.62rem;
  font-weight: 600;
  color: #9aa1b5;
}

.settings-field__value,
.settings-input {
  width: 100%;
  min-height: 34px;
  border-radius: 10px;
  border: 1px solid #e4e8f2;
  background: #f8f9fd;
  color: var(--settings-ink);
  padding: 7px 10px;
  font: inherit;
  font-size: 0.78rem;
}

.settings-input {
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.settings-input:focus {
  outline: none;
  border-color: #1e71bb;
  box-shadow: 0 0 0 4px rgba(30, 113, 187, 0.14);
}
.settings-input:disabled {
  background: #f4f6fb;
  color: #98a0b3;
}
.settings-input.is-invalid {
  border-color: #e15b64;
  box-shadow: 0 0 0 4px rgba(225, 91, 100, 0.12);
}

.settings-input-wrap {
  position: relative;
}
.settings-input-wrap .settings-input {
  padding-right: 46px;
}

.settings-eye {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #667089;
  cursor: pointer;
}
.settings-eye:hover {
  background: #f1f4fb;
  color: #2b3991;
}

.settings-hint,
.settings-error,
.settings-footnote {
  font-size: 0.7rem;
  line-height: 1.4;
}

.settings-hint,
.settings-footnote {
  color: var(--settings-muted);
}

.settings-error {
  color: #c43b48;
}

.settings-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.settings-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 650;
  cursor: pointer;
}

.settings-btn--primary {
  color: #fff;
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
  box-shadow: 0 10px 20px rgba(43, 57, 145, 0.22);
}
.settings-btn--primary:hover {
  filter: brightness(1.05);
}

.settings-btn--ghost {
  background: #fff;
  color: #30364a;
  border-color: #e1e6f0;
}
.settings-btn--ghost:hover {
  background: #f7f8fc;
}

.settings-security-note {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(43, 57, 145, 0.06), rgba(30, 113, 187, 0.04));
  color: #31406f;
}
.settings-security-note i {
  font-size: 0.9rem;
  margin-top: 1px;
}
.settings-security-note p {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.5;
}

.settings-toggle-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.settings-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #e6eaf3;
  background: #fff;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.settings-toggle.is-on {
  border-color: rgba(43, 57, 145, 0.22);
  background: linear-gradient(180deg, rgba(43, 57, 145, 0.05), #fff 70%);
}
.settings-toggle.is-on .settings-switch {
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
}
.settings-toggle.is-on .settings-switch span {
  transform: translateX(18px);
}

.settings-toggle--compact {
  min-height: 46px;
  padding: 8px 10px 8px 14px;
}

.settings-toggle__icon,
.settings-access__icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: #eef2fa;
  color: #2b3991;
}

.settings-toggle__copy {
  flex: 1 1;
  min-width: 0;
}
.settings-toggle__copy strong,
.settings-toggle__copy small {
  display: block;
}
.settings-toggle__copy strong {
  font-size: 0.78rem;
}
.settings-toggle__copy small {
  margin-top: 2px;
  color: var(--settings-muted);
  font-size: 0.7rem;
}

.settings-switch {
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background: #d7dce8;
  padding: 3px;
  flex-shrink: 0;
  transition: background 0.18s ease;
}
.settings-switch span {
  display: block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(20, 28, 60, 0.18);
  transition: transform 0.18s ease;
}

.settings-theme {
  margin-top: 22px;
  padding: 18px;
  border-radius: 18px;
  border: 1px solid var(--settings-line);
  background: #fbfcfe;
}

.settings-branding-source {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid var(--settings-line);
  border-radius: 12px;
  background: var(--settings-surface);
}

.settings-branding-source__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 56px;
  height: 44px;
  border-radius: 10px;
  background: #f4f6fb;
}
.settings-branding-source__logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.settings-branding-source__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.settings-branding-source__copy strong {
  font-size: 0.78rem;
}
.settings-branding-source__copy span {
  color: var(--settings-muted);
  font-size: 0.7rem;
}

.settings-theme__copy h3 {
  margin: 0 0 4px;
  font-size: 0.82rem;
}
.settings-theme__copy p {
  margin: 0 0 14px;
  color: var(--settings-muted);
  font-size: 0.72rem;
}

.settings-theme__preview {
  height: 52px;
  font-size: 0.75rem;
  border-radius: 16px;
  display: flex;
  align-items: flex-end;
  padding: 14px 16px;
  color: #fff;
  font-weight: 650;
  letter-spacing: 0.04em;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
}

.settings-swatches {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.settings-swatch {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e7ebf4;
}
.settings-swatch span,
.settings-swatch em {
  font-size: 0.65rem;
}
.settings-swatch span {
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #7b8296;
}
.settings-swatch em {
  font-style: normal;
  color: var(--settings-muted);
}
.settings-swatch input[type=color] {
  width: 100%;
  height: 36px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.settings-preview-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.settings-chip {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 650;
}

.settings-access-list {
  display: grid;
  gap: 12px;
}

.settings-access {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #e6eaf3;
  background: #fff;
}
.settings-access h3 {
  margin: 0 0 4px;
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7b8296;
}
.settings-access p {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.45;
}

.settings-footnote {
  margin: 16px 0 0;
}

.settings-feedback {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: grid;
  place-items: center;
  padding: 24px;
}

.settings-feedback__backdrop {
  position: absolute;
  inset: 0;
  z-index: 0;
  border: 0;
  background: rgba(16, 22, 44, 0.52);
  backdrop-filter: blur(8px);
}

.settings-feedback__panel {
  position: relative;
  z-index: 1;
  width: min(420px, 100%);
  padding: 28px 26px 24px;
  border-radius: 24px;
  background: #fff;
  color: #171b2e;
  text-align: center;
  box-shadow: 0 30px 80px rgba(16, 22, 44, 0.28);
  animation: settings-feedback-in 0.28s ease;
}
.settings-feedback__panel h3 {
  margin: 6px 0 6px;
  font-size: 1rem;
  letter-spacing: -0.02em;
}

.settings-feedback__kicker {
  margin: 14px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.68rem;
  font-weight: 700;
  color: #1e71bb;
}

.settings-feedback__message {
  margin: 0 0 16px;
  color: var(--settings-muted, #6d758c);
  font-size: 0.8rem;
  line-height: 1.45;
}

.settings-feedback__icon {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #fff;
  font-size: 1.25rem;
  background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));
  box-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);
}

.settings-feedback__btn {
  min-width: 112px;
  min-height: 32px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));
}

@keyframes settings-feedback-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 980px) {
  .user-settings {
    grid-template-columns: 1fr;
  }
  .settings-rail {
    position: static;
  }
  .settings-nav {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 4px;
  }
  .settings-nav__item {
    min-width: 180px;
  }
  .settings-swatches,
  .settings-grid,
  .admin-url-row {
    grid-template-columns: 1fr;
  }
  .admin-toolbar,
  .admin-toolbar__actions,
  .admin-request header {
    flex-direction: column;
    align-items: stretch;
  }
}
.admin-settings .settings-identity__copy h1 {
  font-size: 1.02rem;
  font-weight: 600;
  letter-spacing: -0.03em;
}
.admin-settings .settings-panel__head h2 {
  font-size: 1.45rem;
  font-weight: 600;
  letter-spacing: -0.035em;
}
.admin-settings .settings-lead,
.admin-settings .settings-kicker,
.admin-settings .settings-nav__item strong,
.admin-settings .settings-nav__item small,
.admin-settings .settings-field__label,
.admin-settings .settings-input,
.admin-settings .settings-btn,
.admin-settings .admin-toolbar p,
.admin-settings .admin-order-item {
  font-family: "Montserrat", "Segoe UI", sans-serif;
}
.admin-settings .settings-lead,
.admin-settings .admin-toolbar p,
.admin-settings .settings-footnote {
  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.55;
}
.admin-settings .settings-input {
  min-height: 44px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 12px;
}
.admin-settings .settings-btn {
  min-height: 40px;
  padding: 0 16px;
  font-size: 0.78rem;
  font-weight: 600;
}

.admin-block {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.admin-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.admin-toolbar h3 {
  margin: 0 0 4px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.admin-toolbar p {
  margin: 0;
  max-width: 62ch;
  color: var(--settings-muted, #6d758c);
}

.admin-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.admin-urls {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));
}

.admin-url-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.admin-url-row {
  display: grid;
  grid-template-columns: minmax(160px, 200px) minmax(0, 1fr) auto auto auto;
  gap: 10px;
  align-items: end;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));
  background: #fbfcfe;
}

.admin-sync,
.admin-remove {
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e1e6f0;
  background: #fff;
  color: #4b5368;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}

.admin-sync {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
}
.admin-sync.is-on {
  color: #24306f;
  border-color: rgba(43, 57, 145, 0.22);
  background: rgba(43, 57, 145, 0.08);
}
.admin-sync:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.admin-remove {
  width: 44px;
}
.admin-remove:hover:not(:disabled) {
  color: #c43b48;
  border-color: rgba(196, 59, 72, 0.3);
  background: #fff6f7;
}
.admin-remove:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.admin-module {
  cursor: default;
}

.admin-status {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef1f6;
  color: #6d758c;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.admin-status.is-on {
  background: rgba(43, 57, 145, 0.1);
  color: #2b3991;
}

.admin-extra,
.admin-requests {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));
  background: #fbfcfe;
}
.admin-extra ul,
.admin-requests ul {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
}
.admin-extra li,
.admin-requests li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));
  font-size: 0.84rem;
}
.admin-extra code,
.admin-requests code {
  padding: 2px 6px;
  border-radius: 8px;
  background: #fff;
  color: #6d758c;
  font-size: 0.75rem;
}

.admin-request-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow: auto;
}

.admin-request {
  padding: 14px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));
}
.admin-request header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}
.admin-request strong {
  font-size: 0.86rem;
}
.admin-request span,
.admin-request p {
  margin: 0;
  color: var(--settings-muted, #6d758c);
  font-size: 0.78rem;
}
.admin-request p + p {
  margin-top: 4px;
}

.admin-request__actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.admin-order-lead {
  margin: 0;
  color: var(--settings-muted, #6d758c);
  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.5;
}

.admin-order-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-order-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid #e6eaf3;
  background: #fff;
  cursor: grab;
  touch-action: none;
}
.admin-order-item:active {
  cursor: grabbing;
}
.admin-order-item strong,
.admin-order-item small {
  display: block;
}
.admin-order-item strong {
  font-size: 0.88rem;
  font-weight: 600;
}
.admin-order-item small {
  margin-top: 2px;
  color: #6d758c;
  font-size: 0.72rem;
}
.admin-order-item > i {
  margin-left: auto;
  color: #98a0b3;
  font-size: 1.1rem;
}

.admin-request-dialog {
  max-width: 560px;
}

.admin-request-modal {
  max-height: calc(100vh - 48px);
  border: 0 !important;
  border-radius: 24px;
  overflow: auto;
  padding: 22px 22px 18px;
  color: #171b2e;
  font-family: "Montserrat", "Segoe UI", sans-serif;
  box-shadow: 0 30px 80px rgba(16, 22, 44, 0.28);
}

.admin-request-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.admin-request-modal__head h2 {
  margin: 2px 0 6px;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.03em;
}
.admin-request-modal__head p:last-child {
  margin: 0;
  max-width: 46ch;
  color: #6d758c;
  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.5;
}

.admin-request-modal__close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 12px;
  background: #f3f5fb;
  color: #4b5368;
  flex-shrink: 0;
  cursor: pointer;
}
.admin-request-modal__close:hover:not(:disabled) {
  background: #e7ebf5;
  color: #171b2e;
}

.admin-request-search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin-bottom: 12px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #e4e8f2;
  background: #f8f9fd;
  color: #7b8296;
}
.admin-request-search input {
  width: 100%;
  border: 0;
  background: transparent;
  color: #171b2e;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 500;
  outline: none;
}
.admin-request-search:focus-within {
  background: #fff;
  border-color: #2b3991;
  box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);
}

.admin-request-modal__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #6d758c;
  font-size: 0.75rem;
  font-weight: 600;
}
.admin-request-modal__meta div {
  display: flex;
  gap: 12px;
}
.admin-request-modal__meta button {
  border: 0;
  padding: 0;
  background: transparent;
  color: #2b3991;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}
.admin-request-modal__meta button:hover {
  color: #ed008c;
}

.admin-menu-list {
  max-height: 280px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 2px;
}

.admin-menu-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  margin: 0;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid #e6eaf3;
  background: #fff;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 500;
}
.admin-menu-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.admin-menu-option.is-on {
  border-color: rgba(43, 57, 145, 0.22);
  background: linear-gradient(180deg, rgba(43, 57, 145, 0.06), #fff 72%);
}
.admin-menu-option.is-on .admin-menu-option__mark {
  background: #2b3991;
  border-color: #2b3991;
  color: #fff;
}

.admin-menu-option__mark {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1px solid #cfd5e4;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: transparent;
  font-size: 0.75rem;
  background: #fff;
}

.admin-request-note {
  margin-top: 14px;
}
.admin-request-note textarea.settings-input {
  min-height: 84px;
  padding-top: 10px;
  resize: vertical;
  font-family: inherit;
}

.admin-request-modal__status {
  margin: 8px 0 16px;
  color: #6d758c;
  font-size: 0.84rem;
  font-weight: 500;
}

.admin-request-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}
.admin-request-modal__actions .settings-btn {
  min-height: 40px;
  padding: 0 16px;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
}

.admin-order-item__index {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #eef2fa;
  color: #2b3991;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .user-settings,
  .settings-panel {
    padding: 14px;
  }
  .settings-panel__head h2 {
    font-size: 0.95rem;
  }
  .settings-actions {
    flex-direction: column-reverse;
  }
  .settings-btn {
    width: 100%;
  }
}
.select-facility-container {
  background-color: #f5f5f5 !important;
  height: calc(100vh - 92px) !important;
}
.select-facility-container .facility-card {
  width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.select-facility-container .facility-card h2 {
  font-size: 1.5rem;
  font-weight: 600;
}
.select-facility-container .facility-card .form-label {
  font-size: 0.95rem;
}
.select-facility-container .facility-card .form-control,
.select-facility-container .facility-card .form-select {
  border-radius: 0.375rem;
}
.select-facility-container .facility-card .btn {
  font-size: 1rem;
  font-weight: 500;
}

.interest-page {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(320px, 0.92fr) minmax(440px, 1.08fr);
  font-family: "Montserrat", sans-serif;
  background: #f4f6fb;
  color: #1c2140;
}

.interest-story {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2.4rem 3.2rem 3rem;
  color: #fff;
  background: radial-gradient(520px 320px at 8% 0%, rgba(237, 0, 140, 0.32), transparent 62%), radial-gradient(460px 340px at 100% 100%, rgba(30, 113, 187, 0.38), transparent 58%), linear-gradient(168deg, #1c2468 0%, #12183a 52%, #0b1026 100%);
}

.interest-logo-frame {
  width: 112px;
  height: 72px;
  overflow: hidden;
  align-self: flex-start;
  background: transparent;
}

.interest-logo {
  display: block;
  height: 200px;
  width: 200px;
  max-width: none;
  transform: translate(-41px, -65px);
  mix-blend-mode: screen;
}

.interest-story-body {
  position: sticky;
  top: 2.4rem;
  max-width: 480px;
  margin-top: 2.6rem;
}

.interest-kicker {
  margin: 0 0 0.85rem;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #f4b6d6;
}

.interest-kicker-dark {
  color: #2b3991;
}

.interest-story h1 {
  margin: 0;
  font-size: clamp(2.15rem, 3.2vw, 3.2rem);
  font-weight: 600;
  line-height: 1.06;
  letter-spacing: -0.045em;
}

.interest-story-copy {
  max-width: 38ch;
  margin: 1.15rem 0 0;
  font-size: 0.98rem;
  font-weight: 500;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
}

.interest-points {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin: 1.8rem 0 0;
  padding: 0;
  list-style: none;
}
.interest-points li {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 0.88rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
}
.interest-points i {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.95rem;
}

.interest-direct {
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  width: fit-content;
  max-width: 100%;
  margin-top: 2rem;
  padding: 0.85rem 1rem 0.85rem 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  color: inherit;
  text-decoration: none;
  backdrop-filter: blur(10px);
  transition: background 0.2s ease, transform 0.2s ease;
}
.interest-direct i {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 1.05rem;
}
.interest-direct small {
  display: block;
  margin-bottom: 0.15rem;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.62);
}
.interest-direct strong {
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}
.interest-direct:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}

.interest-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.75rem;
  background: radial-gradient(480px 240px at 88% 0%, rgba(43, 57, 145, 0.08), transparent 70%), linear-gradient(180deg, #f8f9fc 0%, #eef1f7 100%);
}

.interest-card {
  width: min(560px, 100%);
  padding: 2.15rem 2.1rem 1.55rem;
  border: 1px solid rgba(43, 57, 145, 0.06);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(28, 33, 64, 0.08);
}
.interest-card h2 {
  margin: 0;
  font-size: 1.7rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: #1c2140;
}

.interest-lead {
  margin: 0.5rem 0 1.15rem;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.55;
  color: #6b7280;
}

.interest-destination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.15rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(43, 57, 145, 0.08);
  border-radius: 16px;
  background: linear-gradient(100deg, rgba(43, 57, 145, 0.08), rgba(237, 0, 140, 0.07));
}
.interest-destination small {
  display: block;
  margin-bottom: 0.15rem;
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #2b3991;
}
.interest-destination a {
  color: #1c2140;
  font-size: 0.98rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  text-decoration: none;
}
.interest-destination a:hover {
  color: #ed008c;
}
.interest-destination > i {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #fff;
  color: #2b3991;
  box-shadow: 0 6px 16px rgba(43, 57, 145, 0.12);
}

.interest-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem 0.9rem;
}

.interest-field {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
  margin: 0;
  text-align: left;
}
.interest-field > span {
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #2b3991;
}
.interest-field input,
.interest-field textarea {
  width: 100%;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #eef3fb;
  color: #1c2140;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  outline: none;
  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.interest-field input::placeholder,
.interest-field textarea::placeholder {
  color: #8b95ad;
  font-weight: 400;
}
.interest-field input:focus,
.interest-field textarea:focus {
  background: #fff;
  border-color: #2b3991;
  box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);
}
.interest-field input {
  height: 48px;
  padding: 0 0.95rem;
}
.interest-field textarea {
  min-height: 118px;
  padding: 0.85rem 0.95rem;
  resize: vertical;
}

.interest-span {
  grid-column: 1/-1;
}

.interest-error {
  margin: 0.85rem 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: #b42318;
}

.interest-submit {
  width: 100%;
  height: 50px;
  margin-top: 1.15rem;
  border: 0;
  border-radius: 12px;
  background: #2b3991;
  color: #fff;
  font-family: inherit;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(43, 57, 145, 0.22);
  transition: background 0.2s ease;
}
.interest-submit:hover {
  background: #ed008c;
}

.interest-back {
  display: inline-flex;
  justify-content: center;
  width: 100%;
  margin-top: 0.95rem;
  color: #2b3991;
  font-size: 0.84rem;
  font-weight: 600;
  text-decoration: none;
}
.interest-back:hover {
  color: #ed008c;
}

.interest-success {
  text-align: center;
}
.interest-success h2 {
  margin-bottom: 0.7rem;
}
.interest-success p:not(.interest-kicker) {
  margin: 0 0 0.4rem;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.55;
  color: #6b7280;
}

.interest-success-mark {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin: 0.2rem auto 1rem;
  border-radius: 50%;
  background: linear-gradient(145deg, #2b3991 0%, #5b4db8 55%, #ed008c 140%);
  color: #fff;
  font-size: 1.55rem;
  box-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);
}

@media (max-width: 980px) {
  .interest-page {
    grid-template-columns: 1fr;
  }
  .interest-story {
    min-height: auto;
    padding: 1.4rem 1.25rem 1.6rem;
  }
  .interest-story-body {
    position: static;
    margin-top: 1.6rem;
  }
  .interest-story h1 {
    font-size: 2.1rem;
  }
  .interest-panel {
    align-items: flex-start;
    padding: 1.25rem 1rem 2rem;
  }
}
@media (max-width: 640px) {
  .interest-grid {
    grid-template-columns: 1fr;
  }
  .interest-span {
    grid-column: auto;
  }
  .interest-card {
    padding: 1.4rem 1.15rem 1.2rem;
    border-radius: 18px;
  }
  .interest-points li:nth-child(2) {
    display: none;
  }
}
.pp-toast-region {
  position: fixed;
  z-index: 12000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(480px, 100vw - 32px);
  pointer-events: none;
}
.pp-toast-region--top-center {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.pp-toast-region--top-right {
  top: 20px;
  right: 20px;
}
.pp-toast-region--top-left {
  top: 20px;
  left: 20px;
}
.pp-toast-region--bottom-center {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.pp-toast-region--bottom-right {
  bottom: 20px;
  right: 20px;
}
.pp-toast-region--bottom-left {
  bottom: 20px;
  left: 20px;
}

.pp-toast {
  --pp-toast-accent: #2b3991;
  --pp-toast-accent-2: #ed008c;
  --pp-toast-tint: rgba(237, 0, 140, 0.14);
  --pp-toast-shadow: rgba(43, 57, 145, 0.28);
  position: relative;
  isolation: isolate;
  pointer-events: auto;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  column-gap: 14px;
  align-items: flex-start;
  padding: 16px 14px 18px 20px;
  padding-inline-start: 20px;
  padding-inline-end: 14px;
  border-radius: 18px;
  overflow: hidden;
  font-family: "Montserrat", sans-serif;
  color: var(--pp-ink, #1c2140);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.92) 100%);
  backdrop-filter: blur(18px) saturate(1.6);
  -webkit-backdrop-filter: blur(18px) saturate(1.6);
  border: 1px solid rgba(255, 255, 255, 0.85);
  box-shadow: 0 1px 1px rgba(11, 16, 38, 0.04), 0 10px 24px rgba(28, 33, 64, 0.12), 0 28px 64px rgba(28, 33, 64, 0.18), 0 0 0 1px rgba(28, 36, 104, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.95);
  transition: box-shadow 0.25s ease;
  will-change: transform, opacity;
}
.pp-toast.is-clickable {
  cursor: pointer;
}
.pp-toast:hover {
  box-shadow: 0 1px 1px rgba(11, 16, 38, 0.05), 0 14px 30px rgba(28, 33, 64, 0.16), 0 34px 72px rgba(28, 33, 64, 0.22), 0 0 0 1px rgba(28, 36, 104, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.95);
}
.pp-toast::before {
  content: "";
  position: absolute;
  top: 14px;
  bottom: 14px;
  inset-inline-start: 0;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, var(--pp-toast-accent), var(--pp-toast-accent-2));
  box-shadow: 0 0 12px var(--pp-toast-shadow);
}
.pp-toast::after {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 46%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0));
  pointer-events: none;
  z-index: -1;
}
.pp-toast__glow {
  position: absolute;
  top: -110px;
  inset-inline-end: -70px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(closest-side, var(--pp-toast-tint), transparent 72%);
  pointer-events: none;
  z-index: -1;
}
.pp-toast__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 14px;
  color: #fff;
  font-size: 1.15rem;
  line-height: 1;
  background: linear-gradient(135deg, var(--pp-toast-accent) 0%, var(--pp-toast-accent-2) 100%);
  box-shadow: 0 10px 22px var(--pp-toast-shadow), inset 0 1px 0 rgba(255, 255, 255, 0.35), inset 0 -2px 6px rgba(0, 0, 0, 0.12);
  animation: pp-toast-icon-pop 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.08s both;
}
.pp-toast__icon i {
  display: block;
}
.pp-toast__icon i.bi-check-lg,
.pp-toast__icon i.bi-x-lg {
  font-weight: 700;
}
.pp-toast__spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2.5px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  animation: pp-toast-spin 0.8s linear infinite;
}
.pp-toast__body {
  min-width: 0;
  padding-top: 2px;
}
.pp-toast__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: -0.012em;
  line-height: 1.25;
  color: var(--pp-ink, #1c2140);
}
.pp-toast__count {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--pp-toast-accent);
  background: var(--pp-toast-tint);
}
.pp-toast__message {
  margin-top: 4px;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.5;
  color: #4b5270;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.pp-toast__action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 12px;
  border: 0;
  border-radius: 999px;
  font-family: inherit;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--pp-toast-accent);
  background: var(--pp-toast-tint);
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}
.pp-toast__action:hover {
  color: #fff;
  background: linear-gradient(135deg, var(--pp-toast-accent), var(--pp-toast-accent-2));
}
.pp-toast__action:active {
  transform: translateY(1px);
}
.pp-toast__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: -4px -2px 0 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--pp-muted, #6b7280);
  font-size: 0.72rem;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}
.pp-toast__close:hover {
  color: var(--pp-ink, #1c2140);
  background: rgba(28, 33, 64, 0.07);
  transform: rotate(90deg);
}
.pp-toast__close:focus-visible {
  outline: none;
  box-shadow: var(--pp-focus-ring, 0 0 0 4px rgba(43, 57, 145, 0.14));
}
.pp-toast__progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--pp-toast-accent), var(--pp-toast-accent-2));
  transform-origin: left center;
  opacity: 0.9;
  animation-name: pp-toast-progress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.pp-toast {
  /* ----- enter / exit ----- */
}
.pp-toast.is-open {
  animation: pp-toast-in 0.46s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.pp-toast.is-closing {
  pointer-events: none;
  animation: pp-toast-out 0.26s cubic-bezier(0.4, 0, 1, 1) forwards;
}
.pp-toast {
  /* ----- tones ----- */
}
.pp-toast--success {
  --pp-toast-accent: #10b981;
  --pp-toast-accent-2: #047857;
  --pp-toast-tint: rgba(16, 185, 129, 0.16);
  --pp-toast-shadow: rgba(16, 185, 129, 0.32);
}
.pp-toast--error {
  --pp-toast-accent: #f43f5e;
  --pp-toast-accent-2: #be123c;
  --pp-toast-tint: rgba(244, 63, 94, 0.16);
  --pp-toast-shadow: rgba(244, 63, 94, 0.32);
}
.pp-toast--warning {
  --pp-toast-accent: #f59e0b;
  --pp-toast-accent-2: #d97706;
  --pp-toast-tint: rgba(245, 158, 11, 0.18);
  --pp-toast-shadow: rgba(245, 158, 11, 0.32);
}
.pp-toast--info {
  --pp-toast-accent: #2b3991;
  --pp-toast-accent-2: #1e71bb;
  --pp-toast-tint: rgba(30, 113, 187, 0.16);
  --pp-toast-shadow: rgba(43, 57, 145, 0.3);
}
.pp-toast--loading {
  --pp-toast-accent: #1c2468;
  --pp-toast-accent-2: #3a48b4;
  --pp-toast-tint: rgba(43, 57, 145, 0.14);
  --pp-toast-shadow: rgba(43, 57, 145, 0.3);
}

/* bottom regions slide up instead of down */
.pp-toast-region[class*="--bottom"] .pp-toast.is-open {
  animation-name: pp-toast-in-up;
}
.pp-toast-region[class*="--bottom"] .pp-toast.is-closing {
  animation-name: pp-toast-out-down;
}

/* RTL */
[dir=rtl] .pp-toast::before {
  border-radius: 4px 0 0 4px;
}
[dir=rtl] .pp-toast__close {
  margin: -4px 0 0 -2px;
}
[dir=rtl] .pp-toast__progress {
  transform-origin: right center;
  background: linear-gradient(270deg, var(--pp-toast-accent), var(--pp-toast-accent-2));
}

/* ----- keyframes ----- */
@keyframes pp-toast-in {
  from {
    opacity: 0;
    transform: translateY(-18px) scale(0.94);
    filter: blur(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
@keyframes pp-toast-out {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-10px) scale(0.96);
    filter: blur(4px);
  }
}
@keyframes pp-toast-in-up {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.94);
    filter: blur(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
@keyframes pp-toast-out-down {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
    filter: blur(4px);
  }
}
@keyframes pp-toast-icon-pop {
  from {
    transform: scale(0.55) rotate(-8deg);
    opacity: 0;
  }
  60% {
    transform: scale(1.08) rotate(2deg);
    opacity: 1;
  }
  to {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
}
@keyframes pp-toast-progress {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}
@keyframes pp-toast-spin {
  to {
    transform: rotate(360deg);
  }
}
/* ----- responsive ----- */
@media (max-width: 520px) {
  .pp-toast-region {
    width: calc(100vw - 20px);
    gap: 10px;
  }
  .pp-toast-region--top-center, .pp-toast-region--top-right, .pp-toast-region--top-left {
    top: 10px;
  }
  .pp-toast-region--bottom-center, .pp-toast-region--bottom-right, .pp-toast-region--bottom-left {
    bottom: 10px;
  }
  .pp-toast-region--top-right, .pp-toast-region--top-left, .pp-toast-region--bottom-right, .pp-toast-region--bottom-left {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
  .pp-toast {
    column-gap: 12px;
    padding: 14px 12px 16px 16px;
    padding-inline-start: 16px;
    padding-inline-end: 12px;
    border-radius: 16px;
  }
  .pp-toast__icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    border-radius: 12px;
    font-size: 1rem;
  }
  .pp-toast__title {
    font-size: 0.86rem;
  }
  .pp-toast__message {
    font-size: 0.78rem;
  }
}
/* ----- motion preferences ----- */
@media (prefers-reduced-motion: reduce) {
  .pp-toast,
  .pp-toast.is-open,
  .pp-toast.is-closing,
  .pp-toast__icon {
    animation: none;
  }
  .pp-toast.is-closing {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .pp-toast__close:hover {
    transform: none;
  }
}
:root {
  --pp-navy-900: #0b1026;
  --pp-navy-700: #12183a;
  --pp-navy-500: #1c2468;
  --pp-blue: #2b3991;
  --pp-blue-soft: #eef3fb;
  --pp-pink: #ed008c;
  --pp-ink: #1c2140;
  --pp-muted: #6b7280;
  --pp-surface: #f4f6fb;
  --pp-line: #e6eaf2;
  --pp-panel-gradient:
      radial-gradient(520px 320px at 8% 0%, rgba(237, 0, 140, 0.32), transparent 62%),
      radial-gradient(460px 340px at 100% 100%, rgba(30, 113, 187, 0.38), transparent 58%),
      linear-gradient(168deg, #1c2468 0%, #12183a 52%, #0b1026 100%);
  --pp-button-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);
  --pp-button-shadow: 0 8px 18px rgba(28, 36, 104, 0.22);
  --pp-focus-ring: 0 0 0 4px rgba(43, 57, 145, 0.14);
  --sidebar-gradient:
      radial-gradient(280px 220px at 0% 0%, rgba(237, 0, 140, 0.38), transparent 64%),
      radial-gradient(260px 240px at 120% 100%, rgba(30, 113, 187, 0.45), transparent 60%),
      linear-gradient(180deg, #1c2468 0%, #12183a 48%, #0b1026 100%);
  --button-gradient: var(--pp-button-gradient);
  --import-gradient: var(--pp-button-gradient);
  --bs-primary: #2b3991;
  --bs-primary-rgb: 43, 57, 145;
  --bs-link-color: #2b3991;
  --bs-link-color-rgb: 43, 57, 145;
  --bs-link-hover-color: #ed008c;
  --bs-link-hover-color-rgb: 237, 0, 140;
  --bs-body-color: #1c2140;
  --bs-border-color: #e6eaf2;
}

/* ---------- Surfaces ---------- */
.sidebar {
  background: var(--sidebar-gradient);
  background-repeat: no-repeat;
  box-shadow: 8px 0 24px rgba(11, 16, 38, 0.12);
}

.sidebar .sidebar-item .sidebar-title:hover {
  background: rgba(255, 255, 255, 0.1);
}

.main_container {
  background: var(--pp-surface);
}

.main_container .content {
  background: var(--pp-surface);
}

.top-header {
  background: #ffffff;
  border-bottom: 1px solid var(--pp-line);
}

.header_container {
  background: transparent;
  border-bottom: none;
}

.tab-bar {
  background: #eef1f7;
  border-bottom: 1px solid var(--pp-line);
}

.tab-bar::-webkit-scrollbar-thumb {
  background: rgba(43, 57, 145, 0.35);
}

.tab {
  color: var(--pp-muted);
  font-family: "Montserrat", sans-serif;
}

.tab.active {
  color: var(--pp-ink);
  border-bottom: 2px solid var(--pp-pink);
}

.tab-content {
  background: var(--pp-surface);
}

.footer {
  background: var(--pp-panel-gradient);
  color: rgba(255, 255, 255, 0.78);
  font-family: "Montserrat", sans-serif;
}

.card {
  border: 1px solid var(--pp-line);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(28, 33, 64, 0.05);
}

a {
  color: var(--pp-blue);
}

a:hover {
  color: var(--pp-pink);
}

/* ---------- Scrollbars ---------- */
::-webkit-scrollbar-track {
  background: #eef1f7;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #2b3991, #1c2468);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #3a48b4, #2b3991);
}

* {
  scrollbar-color: #2b3991 #eef1f7;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar,
.ag-body-horizontal-scroll-viewport::-webkit-scrollbar,
.ag-body-vertical-scroll-viewport::-webkit-scrollbar,
.table-responsive::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb,
.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,
.ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,
.table-responsive::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #2b3991, #1c2468);
  border-radius: 999px;
}

.MuiDataGrid-virtualScroller::-webkit-scrollbar-track,
.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,
.ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,
.table-responsive::-webkit-scrollbar-track {
  background: #eef1f7;
  border-radius: 999px;
}

/* ---------- Forms ---------- */
.form-control,
.form-select {
  border-color: var(--pp-line);
  border-radius: 10px;
  color: var(--pp-ink);
}

.form-control:focus,
.form-select:focus,
body .input_field .form-control:focus {
  border-color: var(--pp-blue);
  box-shadow: var(--pp-focus-ring);
  outline: none;
}

.form-check-input:checked {
  background-color: var(--pp-blue);
  border-color: var(--pp-blue);
}

.form-check-input:focus {
  border-color: var(--pp-blue);
  box-shadow: var(--pp-focus-ring);
}

/* ---------- Bootstrap buttons ---------- */
.btn {
  --bs-btn-border-radius: 10px;
  --bs-btn-font-weight: 600;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 0.01em;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.btn:active {
  transform: translateY(1px);
}

.btn:focus-visible {
  box-shadow: var(--pp-focus-ring);
}

.btn-primary,
.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #2b3991;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ed008c;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c8007a;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2b3991;
  --bs-btn-disabled-border-color: transparent;
  background-image: var(--pp-button-gradient);
  box-shadow: var(--pp-button-shadow);
}

.btn-primary:hover,
.btn-dark:hover {
  background-image: linear-gradient(135deg, #ed008c 0%, #c8007a 100%);
  box-shadow: 0 10px 22px rgba(237, 0, 140, 0.24);
}

.btn-primary:disabled,
.btn-primary.disabled,
.btn-dark:disabled,
.btn-dark.disabled {
  opacity: 0.55;
  box-shadow: none;
}

.btn-secondary,
.btn-light {
  --bs-btn-color: #2b3991;
  --bs-btn-bg: #eef3fb;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #1c2468;
  --bs-btn-hover-bg: #e2ebf8;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #1c2468;
  --bs-btn-active-bg: #d6e2f4;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #8b95ad;
  --bs-btn-disabled-bg: #eef3fb;
  --bs-btn-disabled-border-color: transparent;
}

.btn-outline-primary,
.btn-outline-secondary,
.btn-outline-dark {
  --bs-btn-color: #2b3991;
  --bs-btn-border-color: rgba(43, 57, 145, 0.28);
  --bs-btn-hover-color: #2b3991;
  --bs-btn-hover-bg: #eef3fb;
  --bs-btn-hover-border-color: rgba(43, 57, 145, 0.4);
  --bs-btn-active-color: #1c2468;
  --bs-btn-active-bg: #e2ebf8;
  --bs-btn-active-border-color: rgba(43, 57, 145, 0.4);
  --bs-btn-disabled-color: #8b95ad;
  --bs-btn-disabled-border-color: var(--pp-line);
}

.btn-link {
  --bs-btn-color: #2b3991;
  --bs-btn-hover-color: #ed008c;
  text-decoration: none;
}

.btn-import {
  color: #fff;
  border: 0;
  box-shadow: var(--pp-button-shadow);
}

/* ---------- Modals and offcanvas ---------- */
.modal-content,
.offcanvas {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 28px 70px rgba(28, 33, 64, 0.28);
}

.offcanvas {
  border-radius: 18px 0 0 18px;
}

.modal-header:not([class*=bg-]),
.offcanvas-header:not([class*=bg-]) {
  background: var(--pp-panel-gradient);
  color: #fff;
  border-bottom: 0;
}

.modal-header:not([class*=bg-]) .modal-title,
.offcanvas-header:not([class*=bg-]) .offcanvas-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.modal-header:not([class*=bg-]) .btn-close,
.offcanvas-header:not([class*=bg-]) .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.8;
}

.modal-header:not([class*=bg-]) .btn-close:hover,
.offcanvas-header:not([class*=bg-]) .btn-close:hover {
  opacity: 1;
}

.modal-footer {
  border-top: 1px solid var(--pp-line);
}

/* ---------- Material UI ---------- */
.MuiButton-root.MuiButton-containedPrimary:not(.cdt-btn) {
  border-radius: 10px;
  background: var(--pp-button-gradient);
  box-shadow: var(--pp-button-shadow);
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  text-transform: none;
}

.MuiButton-root.MuiButton-containedPrimary:not(.cdt-btn):hover {
  background: linear-gradient(135deg, #ed008c 0%, #c8007a 100%);
  box-shadow: 0 10px 22px rgba(237, 0, 140, 0.24);
}

.MuiButton-root.MuiButton-outlinedPrimary:not(.cdt-btn),
.MuiButton-root.MuiButton-textPrimary:not(.cdt-btn) {
  border-radius: 10px;
  color: var(--pp-blue);
  border-color: rgba(43, 57, 145, 0.28);
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  text-transform: none;
}

.MuiButton-root.MuiButton-outlinedPrimary:not(.cdt-btn):hover,
.MuiButton-root.MuiButton-textPrimary:not(.cdt-btn):hover {
  background: var(--pp-blue-soft);
  border-color: rgba(43, 57, 145, 0.4);
}

.MuiCheckbox-root.Mui-checked,
.MuiRadio-root.Mui-checked,
.MuiSwitch-switchBase.Mui-checked {
  color: var(--pp-blue) !important;
}

.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: var(--pp-blue) !important;
}

.MuiTabs-indicator {
  background-color: var(--pp-pink) !important;
}

.MuiTab-root.Mui-selected {
  color: var(--pp-blue) !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--pp-blue) !important;
}

.MuiInputLabel-root.Mui-focused {
  color: var(--pp-blue) !important;
}

.MuiDialog-paper {
  border-radius: 18px !important;
}

.MuiDialogTitle-root {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--pp-ink);
}

/* Entity detail tabs (Customer / Supplier edit & view: "<Entity>" | "Ship To" / "Ship From") */
.pp-entity-tabs {
  --bs-nav-tabs-border-width: 0;
  gap: 0.35rem;
  padding: 0.3rem;
  border-radius: 12px;
  background: var(--pp-blue-soft);
  width: fit-content;
}

.pp-entity-tabs .nav-link {
  border: 0;
  border-radius: 9px;
  color: var(--pp-blue);
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.45rem 1rem;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.pp-entity-tabs .nav-link:hover {
  background: rgba(43, 57, 145, 0.1);
}

.pp-entity-tabs .nav-link.active {
  color: #fff;
  background: var(--pp-button-gradient);
  box-shadow: 0 4px 12px rgba(43, 57, 145, 0.28);
}

.pp-entity-tabs .nav-link.active i {
  color: #fff;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

:root {
  --sidebar-gradient:
      radial-gradient(280px 220px at 0% 0%, rgba(237, 0, 140, 0.38), transparent 64%),
      radial-gradient(260px 240px at 120% 100%, rgba(30, 113, 187, 0.45), transparent 60%),
      linear-gradient(180deg, #1c2468 0%, #12183a 48%, #0b1026 100%);
  --button-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);
  --import-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);
  --yes-gradient: linear-gradient(to right, #4caf50, #2e7d32);
  --no-gradient: linear-gradient(to right, #f44336, #c62828);
}

.btn-import {
  background: var(--import-gradient);
}

.btn-yes {
  background: var(--yes-gradient);
}

.btn-no {
  background: var(--no-gradient);
}

/* Apply globally */
html {
  scroll-behavior: smooth; /* smooth anchor/page scroll */
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f4f4f4; /* light gray track */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #4f46e5, #3b82f6); /* indigo → blue */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #4338ca, #2563eb); /* darker hover */
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #3b82f6 #f4f4f4;
}

body {
  margin: 0;
  padding: 0;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
  box-sizing: none;
  height: 100%;
  font-family: "Montserrat" !important;
  overflow-x: hidden;
}
body #root {
  height: 100%;
}
body .input_field {
  width: 100%;
}
body .input_field .form-control {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 0.875rem;
  width: 100%;
}
body .input_field .form-control:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #222;
}
body .main_container {
  height: 100vh;
  overflow: hidden;
  width: 100vw;
  position: relative;
}
body .main_container .content {
  display: flex;
  height: calc(100vh - 92px);
  position: relative;
  z-index: 1;
}
body .main_container .content .content_conteiner {
  width: 100%;
  padding: 1rem;
}
body .main_container .welcome-portal {
  text-align: center;
  padding: 3rem 1rem;
  color: #222;
  background: #f8f8f8;
  border-radius: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
body .required {
  color: #ff0000;
  margin-left: 2px;
}
body .form-po {
  gap: 0.5rem;
}
body .form-po .checkboxField {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
}
body .form-po .checkboxField .form-label {
  margin-bottom: 0.875rem;
}
body .modal-body {
  height: 30rem;
  overflow-y: clip;
}

a {
  color: #222;
}

h1 {
  margin: 0;
}

.form-select {
  padding: 0.375rem 0.75rem;
}

ol.breadcrumb.mb-0 {
  align-items: center;
}

input,
select,
textarea {
  cursor: pointer;
}

.form-select-sm {
  line-height: 1.2;
}

.belowSpace {
  margin-bottom: 1.5%;
}

.MuiAutocomplete-listbox .MuiAutocomplete-option {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_main.scss","webpack://./src/styles/_sidebar.scss","webpack://./src/styles/_login.scss","webpack://./src/styles/_signup.scss","webpack://./src/styles/_header.scss","webpack://./src/styles/_dropdown.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_tabWrapper.scss","webpack://./src/styles/_table.scss","webpack://./src/styles/_footer.scss","webpack://./src/styles/_forgotPassword.scss","webpack://./src/styles/_stepper.scss","webpack://./src/styles/_checkbox.scss","webpack://./src/styles/_roleManagement.scss","webpack://./src/styles/_contextMenu.scss","webpack://./src/styles/_tempUserDetails.scss","webpack://./src/styles/_loader.scss","webpack://./src/styles/_customtable.scss","webpack://./src/styles/_commonTable.scss","webpack://./src/styles/_confirmDialog.scss","webpack://./src/styles/_settings.scss","webpack://./src/styles/_home.scss","webpack://./src/styles/_showInterest.scss","webpack://./src/styles/_appToast.scss","webpack://./src/styles/_theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACQ,mCAAA;EACJ,4BAAA;EACA,6CAAA;EACE,yBAAA;ADEN;;ACAA;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EAEA,OAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;ADEJ;ACCQ;EACI,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;ADCZ;ACCY;EACI,oCAAA;ADChB;ACGQ;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,gEAAA;ADDZ;ACGY;EACI,uBAAA;EACA,kBAAA;ADDhB;ACIY;EACI,aAAA;EACA,gBAAA;ADFhB;ACMgB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;ADJpB;ACUI;EACI,iBAAA;ADRR;ACYI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;ADVR;ACaI;EACI,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;ADXR;ACcI;EACI,gBAAA;EACA,eAAA;ADZR;ACeI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;ADbR;ACeQ;EACI,SAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;ADbZ;ACkBQ;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;ADhBZ;ACmBQ;EACI,uBAAA;ADjBZ;ACsBI;EAnHJ;IAoHQ,kBAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;EDnBN;AACF;;ACwBA;EACE,YAAA;ADrBF;;ACwBA;EACE;IACE,gBAAA;EDrBF;AACF;ACyBA;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACF,SAAA;ADvBF;;AC0BA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;ADvBF;;AC0BA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;ADvBF;;AC6BA;EACE,uBAAA;EACA,mBAAA;AD1BF;;AC6BA;EACK,WAAA;EACD,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AD1BJ;;AE3JA;EACC,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AF8JD;;AE3JA;EACC,SAAA;EACA,6QACC;EAGD,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AF2JD;;AExJA;EACC,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qCAAA;AF2JD;;AExJA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AF2JD;;AExJA;EACC,cAAA;EACA,sBAAA;EACA,YAAA;EACA,oDAAA;AF2JD;;AExJA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AF2JD;AEzJC;EACC,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;AF2JF;AExJC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AF0JF;;AEtJA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,oBAAA;AFyJD;;AEtJA;EACC,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AFyJD;AEvJC;EACC,iCAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AFyJF;;AErJA;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gDAAA;EACA,oBAAA;EACA,UAAA;AFwJD;AEtJC;EACC,mBAAA;EACA,gDAAA;AFwJF;;AEpJA;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AFuJD;;AEpJA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,8CAAA;EACA,kCAAA;EACA,WAAA;AFuJD;AErJC;EACC,UAAA;EACA,WAAA;AFuJF;;AEnJA;EACC,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AFsJD;;AEnJA;EACC,aAAA;EACA,MAAA;EACA,2BAAA;AFsJD;;AEnJA;EACC,YAAA;EACA,MAAA;EACA,2BAAA;AFsJD;;AEnJA;EACC,OAAA;EACA,WAAA;EACA,2BAAA;AFsJD;;AEnJA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wHAAA;EACA,2HACC;AFqJF;AEjJC;EACC,UAAA;EACA,WAAA;EACA,0DAAA;AFmJF;;AE/IA;EACC;IAEC,sHACC;EFgJD;EE3ID;IACC,qHACC;EF4ID;AACF;AEvIA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;AFyID;AEvIC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,+CAAA;EACA,qFAAA;EACA,uDAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AFyIF;;AErIA;EACC,UAAA;EACA,OAAA;EACA,QAAA;AFwID;;AErIA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;AFwID;AEtIC;EACC,kBAAA;EACA,gBAAA;EACA,gCAAA;AFwIF;;AEpIA;EACC;IACC,eAAA;EFuIA;AACF;AEpIA;EACC,SAAA;EACA,yBAAA;EACA,8FAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AFsID;;AEnIA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AFsID;AEpIC;EACC,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AFsIF;AEnIC;EACC,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AFqIF;;AEjIA;EACC,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AFoID;;AEjIA;EACC,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AFoID;AElIC;EACC,WAAA;EACA,YAAA;AFoIF;;AEhIA;EACC,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AFmID;AEjIC;EACC,iBAAA;EACA,iBAAA;AFmIF;;AE/HA;;EAEC,WAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AFkID;;AE/HA;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;AFkID;AEhIC;EACC,cAAA;EACA,qBAAA;AFkIF;AEhIE;EACC,0BAAA;AFkIH;;AE7HA;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AFgID;AE9HC;EACC,mBAAA;AFgIF;;AE5HA;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;AF+HD;AE7HC;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;AF+HF;AE5HC;EACC,cAAA;EACA,eAAA;AF8HF;;AE1HA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AF6HD;AE3HC;EACC,WAAA;EACA,YAAA;EACA,SAAA;AF6HF;AE1HC;EACC,eAAA;EACA,eAAA;AF4HF;AEzHC;EACC,cAAA;EACA,qBAAA;AF2HF;AEzHE;EACC,0BAAA;AF2HH;;AErHA;EACC;IACC,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EFwHA;EErHD;IACC,UAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;IACA,oBAAA;EFuHA;EEpHD;IACC,WAAA;IACA,YAAA;IACA,gBAAA;EFsHA;EEnHD;IACC,UAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;EFqHA;EElHD;;;IAGC,WAAA;IACA,eAAA;EFoHA;EEjHD;IACC,aAAA;IACA,gBAAA;IACA,gBAAA;EFmHA;AACF;AEhHA;EACC;IACC,eAAA;EFkHA;AACF;AE/GA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AFiHD;;AE9GA;EACC,cAAA;EACA,yBAAA;EACA,qJACC;EAED,4BAAA;EACA,qBAAA;EACA,qCAAA;AF+GD;;AE5GA;EACC,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,8CAAA;EACA,MAAA;EACA,kBAAA;EACA,qCAAA;AF+GD;AE7GC;EACC,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AF+GF;AE5GC;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8EAAA;AF8GF;AE5GE;EACC,cAAA;EACA,gBAAA;AF8GH;AE3GE;EACC,gBAAA;EACA,qBAAA;EACA,6CAAA;AF6GH;;AExGA;EACC,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AF2GD;;AExGA;EACC,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AF2GD;AEzGC;EACC,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AF2GF;;AEvGA;EACC,kBAAA;AF0GD;AExGC;EACC,qBAAA;AF0GF;;AEtGA;EACC,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AFyGD;AEvGC;EACC,cAAA;AFyGF;;AErGA;EACC,yBAAA;EACA,0BAAA;EACA,qCAAA;AFwGD;AEtGC;EACC,gBAAA;AFwGF;AErGC;EACC,cAAA;EACA,qBAAA;AFuGF;;AEnGA;EACC,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8CAAA;AFsGD;AEpGC;EACC,mBAAA;AFsGF;AEnGC;EACC,YAAA;EACA,YAAA;AFqGF;;AEjGA;EACC,mBAAA;EACA,qCAAA;EACA,gBAAA;AFoGD;AElGC;EACC,gBAAA;AFoGF;AEjGC;EACC,cAAA;AFmGF;;AE/FA;EACC,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;EACA,2BAAA;AFkGD;;AE/FA;EACC,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,yCAAA;EACA,kGACC;EAED,8CAAA;EACA,kBAAA;EACA,qCAAA;EACA,oCAAA;AFgGD;AE9FC;EACC,wBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AFgGF;;AE5FA;EACC;IACC,UAAA;IACA,uCAAA;EF+FA;EE5FD;IACC,UAAA;IACA,eAAA;EF8FA;AACF;AE3FA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0EAAA;EACA,WAAA;EACA,+CAAA;EACA,iBAAA;AF6FD;AE3FC;EACC,6DAAA;EACA,8CAAA;AF6FF;;AEzFA;EACC,cAAA;EACA,kBAAA;AF4FD;;AEzFA;EACC,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AF4FD;;AEzFA;EACC,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AF4FD;;AEzFA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AF4FD;;AEzFA;EACC,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AF4FD;;AEzFA;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;AF4FD;;AEzFA;EACC,mBAAA;AF4FD;;AEzFA;EACC,WAAA;EACA,oBAAA;EACA,kCAAA;EACA,gBAAA;AF4FD;;AEzFA;EACC,cAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;EACA,4DAAA;EACA,4CAAA;AF4FD;;AEzFA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AF4FD;;AEzFA;EACC;IACC,QAAA;EF4FA;EEzFD;IACC,WAAA;EF2FA;AACF;AExFA;EACC,SAAA;EACA,uBAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AF0FD;AExFC;EACC,cAAA;AF0FF;;AGt6BA;EACC,aAAA;EACA,iBAAA;AHy6BD;;AGv6BA;EACC,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AH06BD;;AGx6BA;EACC,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AH26BD;;AGx6BC;EACC,qBAAA;EACA,cAAA;AH26BF;AGz6BC;EACC,cAAA;EACA,kBAAA;AH26BF;;AGx6BA;EACC,gBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AH26BD;AG16BC;EACC,cAAA;EACA,qBAAA;AH46BF;AG36BE;EACC,0BAAA;AH66BH;;AGz6BA;EACC,SAAA;EACA,2CAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AH46BD;;AG16BA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AH66BD;AG56BC;EACC,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AH86BF;AG56BC;EACC,iBAAA;EACA,gBAAA;EACA,cAAA;AH86BF;;AG36BA;EACC,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AH86BD;;AG56BA;;;EAGC,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AH+6BD;;AG76BA;EACC,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AHg7BD;AG/6BC;EACC,cAAA;EACA,0BAAA;AHi7BF;;AG96BA;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AHi7BD;AGh7BC;EACC,mBAAA;AHk7BF;;AG/6BA;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AHk7BD;AGj7BC;EACC,cAAA;EACA,eAAA;EACA,0BAAA;AHm7BF;;AIziCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AJ4iCF;AI1iCE;EACE,YAAA;AJ4iCJ;AI1iCI;EACE,YAAA;EACA,WAAA;AJ4iCN;AIxiCE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AJ0iCJ;AIxiCI;EACE,iBAAA;AJ0iCN;AIviCI;EACE,mBAAA;AJyiCN;;AIpiCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AJuiCF;AIriCE;EACE,cAAA;EACA,eAAA;AJuiCJ;AIriCI;EACE,eAAA;AJuiCN;AIliCE;EACE,kBAAA;AJoiCJ;AIliCI;;;EAGE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AJoiCN;AIliCM;;;EACE,qCAAA;AJsiCR;AIniCM;;;EACE,qCAAA;AJuiCR;AIjiCM;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJmiCR;AI/hCQ;EACE,8EAAA;EACA,sBAAA;AJiiCV;AI9hCQ;EACE,8EAAA;EACA,sBAAA;AJgiCV;AI1hCI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;AJ4hCN;AI1hCM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,uCAAA;AJ4hCR;AI1hCQ;EACE,yBAAA;AJ4hCV;AIzhCQ;EACE,yBAAA;AJ2hCV;AIzhCU;EACE,cAAA;EACA,gBAAA;AJ2hCZ;AIvhCQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AJyhCV;AIvhCU;EACE,eAAA;EACA,cAAA;AJyhCZ;AIrhCQ;EACE,SAAA;EACA,YAAA;AJuhCV;AIrhCU;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJuhCZ;AIphCU;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AJshCZ;AIlhCQ;EACE,eAAA;EACA,gBAAA;AJohCV;AI9gCI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,+CAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;AJghCN;AI7gCI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AJ+gCN;AI7gCM;EACE,yBAAA;AJ+gCR;AI5gCM;EACE,yBAAA;EACA,cAAA;AJ8gCR;AIzgCE;EACE,eAAA;AJ2gCJ;;AIvgCA;EACE,kBAAA;AJ0gCF;AIxgCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AJ0gCJ;AIxgCI;EACE,eAAA;EACA,cAAA;AJ0gCN;AIvgCI;EAEE,mBAAA;AJwgCN;AIpgCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AJsgCJ;AIngCE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AJqgCJ;AIlgCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AJogCJ;AIjgCE;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AJmgCJ;AIhgCE;EACE,gBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AJkgCJ;AI//BE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AJigCJ;AI//BI;EACE,mBAAA;AJigCN;AI9/BI;EACE,mBAAA;AJggCN;AI5/BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AJ8/BJ;AI5/BI;EACE,eAAA;AJ8/BN;AI3/BI;EACE,mBAAA;EACA,cAAA;AJ6/BN;AI1/BI;EACE,mBAAA;EACA,cAAA;AJ4/BN;AIz/BI;EACE,mBAAA;EACA,cAAA;AJ2/BN;AIx/BI;EACE,mBAAA;EACA,cAAA;AJ0/BN;AIt/BE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AJw/BJ;AIr/BE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AJu/BJ;AIp/BE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AJs/BJ;AIn/BE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AJq/BJ;AIl/BE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AJo/BJ;;AK93CA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;ALi4CJ;AK/3CI;EACI,YAAA;EACA,gBCNG;EDOH,8BAAA;EACA,yBCTE;EDUF,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,wCAAA;EACA,WCjBG;ANk5CX;AK/3CQ;EAEI,aAAA;ALg4CZ;AK73CQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AL+3CZ;AK73CY;EACI,eAAA;AL+3ChB;AK13CI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,gBCzCG;ED0CH,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,gBAAA;AL43CR;AK13CQ;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WCzDD;ANq7CX;AK13CY;EAEI,mBAAA;AL23ChB;AKp3CQ;EACI,SAAA;EACA,OAAA;ALs3CZ;AKj3CQ;EACI,oBAAA;EACA,oBAAA;ALm3CZ;;AK52CQ;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AL+2CZ;AK52CQ;EACI,uBAAA;EACA,YAAA;AL82CZ;AK52CY;EACI,sBC/FL;EDgGK,WCjGL;AN+8CX;;AOh9CA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;APm9CF;;AOh9CA;EACE,wBAAA;APm9CF;;AOh9CA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;APm9CF;;AOh9CA;EACE,WAAA;APm9CF;;AOh9CA;EACE,gBAAA;EACA,kBAAA;APm9CF;;AOh9CA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;APm9CF;;AOh9CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;APm9CF;;AOh9CA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;APm9CF;;AOh9CA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;APm9CF;;AOh9CA;EACE,gBAAA;EACA,gCAAA;APm9CF;;AOh9CA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;APm9CF;;AOh9CA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;APm9CF;;AOh9CA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;APm9CF;AOh9CE;EACE,yBAAA;APk9CJ;;AO78CA;iEAAA;AAEA;EACE,aAAA;APg9CF;;AO78CA;EACE,cAAA;EACA,yDAAA;APg9CF;;AO78CA;EACE;IACE,UAAA;IACA,2BAAA;EPg9CF;EO78CA;IACE,UAAA;IACA,eAAA;EP+8CF;AACF;AO58CA;EACE;IACE,eAAA;EP88CF;AACF;AO38CA,sBAAA;AACA;EACE;IACE,eAAA;IACA,cAAA;IACA,YAAA;EP68CF;EO18CA;IACE,WAAA;EP48CF;EOz8CA;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;EP28CF;EOx8CA;IACE,YAAA;EP08CF;EOv8CA;IACE,YAAA;IACA,eAAA;EPy8CF;AACF;AOt8CA;EACE;IACE,eAAA;IACA,cAAA;IACA,YAAA;EPw8CF;EOr8CA;IACE,WAAA;EPu8CF;EOp8CA;IACE,gBAAA;IACA,eAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;EPs8CF;EOn8CA;IACE,YAAA;EPq8CF;EOl8CA;IACE,YAAA;IACA,eAAA;EPo8CF;AACF;AQhpDA;EACI,gBAAA;ARkpDJ;AQ/oDY;EACI,sBFHL;EEIK,WFLL;ANspDX;AQ5oD4B;EACI,UAAA;EACA,eFLjB;ANmpDf;AQ5oDoC;EACI,sBFf7B;AN6pDX;AQxoD4C;EACI,iBAAA;AR0oDhD;AQ3nDwB;EACI,uBAAA;AR6nD5B;AQ5nD4B;EACI,2CAAA;EACA,uBAAA;AR8nDhC;AQ7nDgC;EACI,sBAAA;EACA,eFtCtB;ANqqDd;AQ5nDoC;EACI,yBF9C9B;AN4qDV;AQ3nDgC;EACI,8BAAA;AR6nDpC;;AQlnDA;EACE,sBAAA;EACA,YAAA;ARqnDF;;AQlnDA;;EAEE,6BAAA;ARqnDF;;AQlnDA,uCAAA;AACA;EACE,wBAAA;ARqnDF;;AQlnDA;EACI,oCAAA;ARqnDJ;;AQlnDA;EACI,WAAA;EACA,yBAAA;ARqnDJ;;AQ7mDA;EACI,oCAAA;ARgnDJ;;AQ7mDA;EACK,oCAAA;ARgnDL;;AQ7mDA;EACE,kCAAA;ARgnDF;;AQ7mDA;EACE,wBAAA;EACA,sBAAA;ARgnDF;;AQ7mDA;EACI,mBAAA;EACA,oBAAA;ARgnDJ;;AQ7mDA,0DAAA;AACA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0DAAA;ARgnDJ;AQ9mDI;EACI,8CAAA;EACA,uBAAA;ARgnDR;AQ7mDI;EACI,gBAAA;EACA,8DAAA;AR+mDR;;AQ3mDA;EACI,mBAAA;EACA,gBAAA;EACA,wCAAA;EACA,+CAAA;EACA,gBAAA;AR8mDJ;AQ5mDI;EACI,wBAAA;EACA,6CAAA;EACA,wDAAA;EACA,sCAAA;EACA,mBAAA;AR8mDR;AQ3mDI;EACI,8CAAA;EACA,sBAAA;AR6mDR;AQ1mDI;;EAEI,sBAAA;EACA,gBAAA;EACA,sBAAA;AR4mDR;AQzmDI;EACI,sBAAA;EACA,YAAA;AR2mDR;AQxmDI;EACI,uDAAA;AR0mDR;AQvmDI;EACI,4BAAA;EACA,+BAAA;EACA,iBAAA;ARymDR;AQtmDI;EACI,oDAAA;ARwmDR;;AQpmDA;EACI,mBAAA;EACA,yCAAA;EACA,oCAAA;ARumDJ;;AQpmDA,qCAAA;AACA;EACI,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yEAAA;ARumDJ;AQrmDI;EACI,mCAAA;EACA,yBAAA;ARumDR;AQpmDI;EACI,0CAAA;EACA,mBAAA;ARsmDR;;AQlmDA;EACI,gDAAA;EACA,gDAAA;EACA,yBAAA;EACA,2BAAA;ARqmDJ;;ASvzDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WHRO;ANk0DX;ASxzDI;EACI,SAAA;EACA,eAAA;AT0zDR;;AUx0DA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBJLO;ANg1DX;AU10DI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AV40DR;AU30DQ;EACI,WAAA;AV60DZ;AU10DY;EACI,WAAA;AV40DhB;AU10DY;EACI,WAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AV40DhB;AU30DgB;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;AV60DpB;AU10DY;EACI,WAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AV40DhB;;AWn3DA;EACI,6BAAA;EACA,mCAAA;EACA,oCAAA;EACA,+BAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,wDAAA;EAEA,iBAAA;EACA,WAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AXq3DJ;;AWl3DA;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AXq3DJ;;AWl3DA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;AXq3DJ;AWn3DI;EACI,WAAA;AXq3DR;AWn3DI;EACI,oCAAA;EACA,kBAAA;AXq3DR;;AWj3DA;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,cAAA;EACA,MAAA;AXo3DJ;;AWj3DA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AXo3DJ;;AWj3DA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,wHACI;AXm3DR;AW72DI;EACI,2BAAA;EACA,8CAAA;AX+2DR;AW52DI;EACI,eAAA;EACA,aAAA;AX82DR;AW32DI;EACI,qCAAA;EACA,uCAAA;EACA,WAAA;EACA,8CAAA;AX62DR;AW12DI;EACI,qCAAA;EACA,uCAAA;EACA,WAAA;AX42DR;AWz2DI;EACI,gBAAA;EACA,8BAAA;AX22DR;;AWv2DA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AX02DJ;;AWv2DA;;EAEI,6BAAA;AX02DJ;;AWv2DA;EACI,mBAAA;EACA,gBAAA;AX02DJ;;AWv2DA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AX02DJ;AWx2DI;EATJ;IAUQ,kBAAA;EX22DN;AACF;AWz2DI;EACI,gCAAA;EACA,gBAAA;AX22DR;;AWv2DA;EACI,aAAA;EACA,cAAA;EACA,WAAA;EACA,qDAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iCAAA;AX02DJ;AWx2DI;EACI,sEAAA;AX02DR;;AWt2DA;EACI,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,0CAAA;AXy2DJ;AWv2DI;EAbJ;IAcQ,6BAAA;EX02DN;AACF;;AWv2DA;EACI,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AX02DJ;AWx2DI;EACI,sCAAA;EACA,0BAAA;AX02DR;;AWt2DA;EACI,uCAAA;AXy2DJ;AWv2DI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AXy2DR;AWv2DQ;EACI,kBAAA;EACA,sBAAA;AXy2DZ;AWv2DY;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;AXy2DhB;AWv2DgB;EACI,YAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AXy2DpB;AWr2DY;EACI,kBAAA;AXu2DhB;AWn2DQ;;EAEI,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;AXq2DZ;AWn2DY;EATJ;;IAUQ,iBAAA;EXu2Dd;AACF;AWp2DQ;;EAEI,SAAA;EACA,oBAAA;EACA,8BAAA;EACA,iBAAA;AXs2DZ;AWn2DQ;EACI,WAAA;AXq2DZ;AWl2DQ;EACI,WAAA;AXo2DZ;AWj2DQ;EACI,kCAAA;EACA,sBAAA;AXm2DZ;AWh2DQ;;EAEI,mBAAA;EACA,0CAAA;EACA,wBAAA;EACA,wDACI;AXi2DhB;AW91DY;;EACI,qBAAA;AXi2DhB;AW91DY;;EACI,uCAAA;EACA,4CAAA;EACA,aAAA;AXi2DhB;AW71DQ;EACI,WAAA;AX+1DZ;AW51DQ;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AX81DZ;AW51DY;;EAEI,WAAA;EACA,gBAAA;AX81DhB;AW51DgB;EALJ;;IAMQ,yBAAA;EXg2DlB;AACF;AW51DgB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;AX81DpB;AW31DgB;EACI,aAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AX61DpB;AW11DgB;EACI,SAAA;EACA,gBAAA;EACA,kCAAA;AX41DpB;AWz1DgB;EACI,2CAAA;EACA,uCAAA;AX21DpB;AWx1DgB;EACI,4CAAA;EACA,uCAAA;AX01DpB;AWt1DY;EACI,WAAA;EACA,oBAAA;AXw1DhB;AWt1DgB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;AXw1DpB;AWr1DgB;EACI,SAAA;EACA,WAAA;AXu1DpB;AWp1DgB;EACI,SAAA;EACA,kCAAA;EACA,gBAAA;AXs1DpB;AWn1DgB;EACI,2CAAA;EACA,uCAAA;AXq1DpB;;AW90DA;EACI;IACI,UAAA;IACA,2BAAA;EXi1DN;EW/0DE;IACI,UAAA;IACA,wBAAA;EXi1DN;AACF;AW90DA;EACI;IACI,eAAA;EXg1DN;EW70DE;;;IAGI,gBAAA;EX+0DN;AACF;AW50DA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,8CAAA;EACA,mBAAA;EACA,oBAAA;AX80DJ;;AW30DA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AX80DJ;;AW30DA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,wIACI;AX60DR;AWt0DI;EACI,+EAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;AXw0DR;AWt0DQ;EACI,qFAAA;EACA,6CAAA;EACA,2BAAA;EACA,WAAA;AXw0DZ;AWr0DQ;EACI,wBAAA;EACA,6CAAA;EACA,4CAAA;AXu0DZ;AWp0DQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AXs0DZ;AWl0DI;EACI,gBAAA;EACA,0CAAA;EACA,kCAAA;AXo0DR;AWl0DQ;EACI,mBAAA;EACA,qBAAA;AXo0DZ;AWh0DI;EACI,uBAAA;EACA,6BAAA;EACA,8BAAA;AXk0DR;AWh0DQ;EACI,kCAAA;EACA,mBAAA;AXk0DZ;;AY3yEA;EACI,eAAA;AZ8yEJ;AY7yEI;EACI,sBNDG;EMEH,WNHG;EMIH,kBNHG;ANkzEX;AY7yEI;EACI,gBAAA;EACA,kBNPG;ANszEX;;AY1yEI;EACI,gBAAA;EACA,mBAAA;AZ6yER;;Aa7zEA;EACI,2BAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;Abg0EJ;Aa9zEI;;;;EAII,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;Abg0ER;Aa9zEQ;;;;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,gFAAA;Abm0EZ;;Aa9zEA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;Abi0EJ;Aa/zEI;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;Abi0ER;Aa/zEQ;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;Abi0EZ;;Aa5zEA;EACI,mBAAA;Ab+zEJ;Aa5zEQ;EACI,eAAA;Ab8zEZ;Aa1zEY;EACI,eAAA;Ab4zEhB;AavzEI;EACI,SAAA;AbyzER;AatzEI;EACI,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AbwzER;AatzEQ;EACI,mBAAA;EACA,aAAA;AbwzEZ;AapzEI;EACI,0BAAA;EACA,oCAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AbszER;;AajzEI;EACI,oCAAA;AbozER;AajzEI;EACI,gBAAA;AbmzER;;Aa9yEA;EACI,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,oCAAA;EACA,uBAAA;AbizEJ;Aa/yEI;EACI,mBAAA;EACA,aAAA;AbizER;;Aa5yEA;EACI,aAAA;Ab+yEJ;;Aa3yEI;EACI,iBAAA;Ab8yER;;Aa1yEA;EACE,oCAAA,EAAA,eAAA;Ab6yEF;;Acr7EA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yCAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;Adw7EF;;Ael8EA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,iBAAA;Afq8EF;;Ael8EA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;Afq8EF;;Ael8EA;EACE,mBAAA;Afq8EF;Aep8EE;EACM,kBAAA;EACA,kBAAA;Afs8ER;;Ael8EA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;Afq8EF;;Ael8EA;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,2EAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,wCAAA;EACA,0BAAA;Afq8EF;;Ael8EA;EACE,mBAAA;EACA,cAAA;Afq8EF;;Ael8EA;EACE,0CAAA;Afq8EF;;Ael8EA;EACE,gBAAA;EACA,eAAA;Afq8EF;;Ael8EA;EACE,6DAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,yCAAA;EACA,+CAAA;Afq8EF;;Ael8EA;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;Afq8EF;Aen8EE;EACE,uBAAA;EACA,cAAA;Afq8EJ;;Aej8EA;EACE,wCAAA;EACA,+CAAA;Afo8EF;;Aej8EA;EACE,6FAAA;EACA,cAAA;Afo8EF;;Aej8EA;EACE,qEAAA;EACA,8CAAA;EACA,mDAAA;Afo8EF;;Aej8EA;EACE,2BAAA;EACA,sBAAA;Afo8EF;;Aej8EA;EACE,mBAAA;EACA,WAAA;EACA,yBAAA;Afo8EF;;Aej8EA;;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;Afo8EF;;Aej8EA;EACE,mBAAA;EACA,WAAA;Afo8EF;;Aej8EA;EACE,gBAAA;EACA,WAAA;Afo8EF;;Aej8EA;EAEE,kBAAA;EACI,eAAA;Afm8EN;;Aej8EA;EAGE,2BAAA;Afo8EF;;Ael8EA;EACE,8BAAA;EACA,sBAAA;EACA,0CAAA;Afq8EF;;Ael8EA;EACE;IACE,0BAAA;Efq8EF;Een8EA;IACE,aAAA;Efq8EF;AACF;AgB9lFA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AhBgmFF;;AgB7lFA;EACE,qCAAA;EACA,0BAAA;AhBgmFF;;AgB7lFA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,qCAAA;EACA,8CAAA;AhBgmFF;AgB9lFE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qDAAA;EACA,uEAAA;AhBgmFJ;AgB9lFI;EAAiB,sBAAA;AhBimFrB;AgBhmFI;EAAiB,sBAAA;AhBmmFrB;;AgB/lFA;EACE;IAAgB,oCAAA;IAAsC,aAAA;EhBomFtD;EgBnmFA;IAAM,oCAAA;IAAsC,UAAA;EhBumF5C;AACF;AgBrmFA;EACE;IAAmB,eAAA;IAAiB,YAAA;EhBymFpC;AACF;AgBvmFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AhBymFF;;AgBtmFA;EACE,kBAAA;AhBymFF;;AgBtmFA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0EAAA;EACA,4MACE;EAKF,4BAAA;EACA,sDAAA;AhBomFF;;AgBjmFA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;EACA,uDAAA;AhBomFF;;AgBjmFA;EACE,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,0HAAA;EAMA,wBAAA;EACA,uDAAA;EACA,oBAAA;AhB+lFF;;AgB5lFA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oGAAA;EACA,uDAAA;AhB+lFF;;AgB5lFA;EACE;IAAW,sDAAA;EhBgmFX;EgB/lFA;IAAM,wDAAA;EhBkmFN;AACF;AgBhmFA;EACE;IAAU,UAAA;EhBmmFV;EgBlmFA;IAAY,UAAA;EhBqmFZ;AACF;AgBnmFA;EACE;IAAW,oBAAA;IAAsB,YAAA;EhBumFjC;EgBtmFA;IAAM,uBAAA;IAAyB,aAAA;EhB0mF/B;AACF;AgBxmFA;EACE;;;IAGE,eAAA;EhB0mFF;AACF;AiB7uFA;EACE,aAAA;EACA,mCAAA;AjB+uFF;AiB7uFE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AjB+uFJ;AiB5uFE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,iCAAA;EACA,mBAAA;EAEA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,4CAAA;AjB6uFJ;AiB3uFI;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,4BAAA;AjB6uFN;AiB1uFI;;EAEE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;AjB4uFN;AiBzuFI;;EAGE,kBAAA;AjB0uFN;AiBvuFI;;EAEE,WAAA;EACA,8BAAA;AjByuFN;AiBtuFI;;EAEE,YAAA;EACA,oBAAA;AjBwuFN;AiBruFI;;EAEE,YAAA;EACA,mBAAA;AjBuuFN;AiBpuFI;;EAEE,YAAA;EACA,WAAA;AjBsuFN;AiBnuFI;EACE,gBAAA;EACA,eAAA;AjBquFN;AiBluFI;EACE,2BAAA;AjBouFN;AiBluFM;EACE,6BAAA;AjBouFR;AiBhuFI;EACE,sBAAA;EACA,gBAAA;AjBkuFN;AiB/tFI;EACE,yBAAA;AjBiuFN;AiB/tFM;EACE,kBAAA;AjBiuFR;AiB7tFI;EACE,yBAAA;AjB+tFN;AiB7tFM;EACE,kBAAA;AjB+tFR;AiBr0FE;EA0GE,qCAAA;AjB8tFJ;AiB7tFI;EACE,8BAAA;AjB+tFN;AiB5tFI;EACE,+BAAA;AjB8tFN;;AiBxtFA;EACE,oCAAA;EACA,yBAAA;AjB2tFF;AiBztFE;EACE,oCAAA;AjB2tFJ;;AiBvtFA;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AjB0tFF;AiBxtFE;EACE,oCAAA;AjB0tFJ;AiBttFE;EACE,yBAAA;AjBwtFJ;;AkB52FA;EACE,qCAAA;AlB+2FF;;AkB52FA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AlB+2FF;;AkB52FA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AlB+2FF;;AkB52FA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yHAAA;AlB+2FF;AkB72FE;EACE,eAAA;EACA,cAAA;AlB+2FJ;AkB52FE;EACE,0BAAA;AlB82FJ;;AkB12FA;EACE,WAAA;EACA,SAAA;EACA,+EAAA;EACA,iFAAA;AlB62FF;AkB32FE;EACE,+EAAA;EACA,mFAAA;EACA,2BAAA;AlB62FJ;;AkBz2FA;EACE,cAAA;EACA,mBAAA;EACA,6BAAA;AlB42FF;AkB12FE;EACE,mBAAA;EACA,yBAAA;AlB42FJ;;AkBx2FA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;AlB22FF;AkBz2FE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AlB22FJ;;AkBv2FA;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;AlB02FF;AkBx2FE;EACE,mBAAA;AlB02FJ;;AkBt2FA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,4EAAA;AlBy2FF;AkBv2FE;EAEE,cAAA;EACA,mBAAA;EACA,qBAAA;AlBw2FJ;AkBr2FE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AlBu2FJ;;AkBn2FA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AlBs2FF;;AkBn2FA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AlBs2FF;;AkBn2FA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;AlBs2FF;;AkBn2FA;EACE,cAAA;EACA,gBAAA;AlBs2FF;;AkBn2FA;EACE,cAAA;EACA,gBAAA;AlBs2FF;;AkBn2FA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AlBs2FF;AkBp2FE;EACE,cAAA;EACA,qBAAA;AlBs2FJ;AkBn2FE;EACE,wBAAA;AlBq2FJ;AkBl2FE;EACE,+BAAA;AlBo2FJ;;AkBh2FA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AlBm2FF;;AkBh2FA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AlBm2FF;;AkBh2FA;EACE,qBAAA;EACA,8CAAA;AlBm2FF;;AkBh2FA;EACE,cAAA;AlBm2FF;;AkBh2FA;EACE,qCAAA;AlBm2FF;;AkBh2FA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AlBm2FF;AkBj2FE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AlBm2FJ;;AkB/1FA;EAAsB,mBAAA;EAAqB,cAAA;AlBo2F3C;;AkBn2FA;EAAmB,mBAAA;EAAqB,cAAA;AlBw2FxC;;AkBv2FA;EAAsB,mBAAA;EAAqB,cAAA;AlB42F3C;;AkB32FA;EAAsB,mBAAA;EAAqB,cAAA;AlBg3F3C;;AkB/2FA;EAAqB,mBAAA;EAAqB,cAAA;AlBo3F1C;;AkBn3FA;EAAsB,mBAAA;EAAqB,cAAA;AlBw3F3C;;AkBt3FA;EACE;IAAO,UAAA;ElB03FP;EkBz3FA;IAAK,UAAA;ElB43FL;AACF;AkB13FA;EACE;IAA6B,eAAA;ElB63F7B;AACF;AkB33FA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,uCAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AlB63FF;;AkB13FA;;EAEE,cAAA;AlB63FF;;AkB13FA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,8IACE;EAEF,WAAA;AlB23FF;AkBz3FE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AlB23FJ;AkBx3FE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AlB03FJ;;AkBt3FA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AlBy3FF;;AkBt3FA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;AlBy3FF;AkBv3FE;EACE,qCAAA;AlBy3FJ;;AkBr3FA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,4BAAA;AlBw3FF;;AkBr3FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBw3FF;AkBt3FE;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AlBw3FJ;AkBt3FI;EACE,cAAA;AlBw3FN;;AkBn3FA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AlBs3FF;AkBp3FE;EACE,cAAA;AlBs3FJ;AkBn3FE;EACE,SAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBq3FJ;AkBn3FI;EACE,cAAA;EACA,gBAAA;AlBq3FN;AkBj3FE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AlBm3FJ;AkBj3FI;EACE,gBAAA;EACA,cAAA;AlBm3FN;AkB/2FE;EACE,gBAAA;EACA,qBAAA;EACA,6CAAA;AlBi3FJ;;AkB72FA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBg3FF;;AkB72FA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AlBg3FF;;AkB72FA;EACE,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBg3FF;;AkB72FA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,eAAA;AlBg3FF;AkB92FE;EACE,mBAAA;AlBg3FJ;AkB72FE;EACE,mCAAA;AlB+2FJ;AkB52FE;EACE,cAAA;AlB82FJ;AkB32FE;EACE,cAAA;AlB62FJ;;AkBz2FA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AlB42FF;;AkBz2FA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AlB42FF;;AkBz2FA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AlB42FF;;AkBz2FA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AlB42FF;;AkBz2FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,+BAAA;EACA,6BAAA;AlB42FF;;AkBz2FA;;EAEE,aAAA;EACA,mBAAA;EACA,YAAA;AlB42FF;;AkBz2FA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AlB42FF;AkB12FE;EACE,mBAAA;AlB42FJ;AkBz2FE;EACE,aAAA;EACA,mBAAA;AlB22FJ;AkBx2FE;EACE,mBAAA;EACA,WAAA;EACA,6CAAA;AlB02FJ;AkBx2FI;EACE,mBAAA;AlB02FN;;AkBr2FA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,uCAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AlBw2FF;;AkBr2FA;;EAEE,cAAA;AlBw2FF;;AkBr2FA;EACE,SAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;AlBw2FF;;AkBr2FA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AlBw2FF;AkBt2FE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,8CAAA;AlBw2FJ;AkBr2FE;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AlBu2FJ;AkBp2FE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AlBs2FJ;AkBp2FI;EACE,mBAAA;AlBs2FN;;AkBj2FA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AlBo2FF;;AkBj2FA;EACE,+BAAA;EACA,yCAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;AlBo2FF;;AkBj2FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AlBo2FF;;AkBj2FA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AlBo2FF;;AkBj2FA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AlBo2FF;AkBl2FE;EACE,mBAAA;EACA,cAAA;AlBo2FJ;;AkBh2FA;EACE,aAAA;EACA,kCAAA;EACA,WAAA;AlBm2FF;;AkBh2FA;EACE,iBAAA;AlBm2FF;;AkB/1FE;EACE,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBk2FJ;AkB/1FE;EACE,cAAA;AlBi2FJ;AkB91FE;EACE,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlBg2FJ;AkB91FI;EACE,yBAAA;AlBg2FN;AkB71FI;EACE,yBAAA;AlB+1FN;AkB51FI;EACE,gBAAA;EACA,6CAAA;AlB81FN;AkB51FM;EACE,qBAAA;EACA,iBAAA;AlB81FR;AkBz1FE;EACE,qCAAA;AlB21FJ;;AkBv1FA;EACE;IACE,0BAAA;ElB01FF;EkBv1FA;IACE,iBAAA;ElBy1FF;EkBt1FA;IACE,sBAAA;IACA,oBAAA;ElBw1FF;EkBr1FA;;IAEE,8BAAA;ElBu1FF;AACF;AmB7iHA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;AnB+iHF;;AmB5iHA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;AnB+iHF;;AmB5iHA;EACE,kBAAA;EACA,eAAA;AnB+iHF;;AmB5iHA;EACE,kBAAA;EACA,WAAA;AnB+iHF;;AmB5iHA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AnB+iHF;;AmB5iHA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AnB+iHF;;AmB5iHA;EACE,YAAA;EACA,yBAAA;EACA,WAAA;AnB+iHF;;AmB5iHA;EACE,yBAAA;AnB+iHF;;AmB5iHA;EACE,sBAAA;EACA,yBAAA;AnB+iHF;;AmB5iHA;EACE,yBAAA;AnB+iHF;;AmB5iHA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AnB+iHF;;AmB5iHA;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,gFACE;AnB8iHJ;;AmB1iHA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AnB6iHF;;AmB1iHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AnB6iHF;;AmB1iHA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,6DAAA;EACA,cAAA;EACA,kBAAA;EACA,mDAAA;AnB6iHF;;AmB1iHA;EACE,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AnB6iHF;;AmB1iHA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AnB6iHF;;AmB1iHA;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AnB6iHF;;AmB1iHA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AnB6iHF;;AmB1iHA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,qBAAA;EACA,eAAA;EACA,gCAAA;AnB6iHF;;AmB1iHA;EACE,gBAAA;AnB6iHF;;AmB1iHA;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AnB6iHF;;AmB1iHA;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AnB6iHF;;AmB1iHA;EACE,qEAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AnB6iHF;;AmB1iHA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AnB6iHF;;AmB1iHA;EACE,mBAAA;EACA,cAAA;AnB6iHF;;AmB1iHA;;EAEE,mBAAA;EACA,cAAA;AnB6iHF;;AmB1iHA;EACE,SAAA;EACA,uBAAA;EACA,SAAA;AnB6iHF;;AmB1iHA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AnB6iHF;;AmB1iHA;;EAEE,mBAAA;EACA,qBAAA;EACA,WAAA;AnB6iHF;;AoB5wHA;EACE,kBAAA;EACA,gBAAA;ApB+wHF;;AoB5wHA;EACE,iBAAA;EACA,gBAAA;ApB+wHF;;AoB5wHA;;;;EAIE,kBAAA;EACA,gBAAA;ApB+wHF;;AoB5wHA;;EAEE,kBAAA;EACA,gBAAA;ApB+wHF;;AoBzwHA;EACE,kBAAA;EACA,gBAAA;ApB4wHF;;AoBzwHA;EACE,iBAAA;EACA,gBAAA;ApB4wHF;;AoBzwHA;EACE,iBAAA;EACA,gBAAA;ApB4wHF;;AoBzwHA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;ApB4wHF;;AoBzwHA;EACE,kBAAA;EACA,gBAAA;ApB4wHF;;AoBzwHA;EACE,kBAAA;EACA,uBAAA;ApB4wHF;;AoBzwHA;EACE,kBAAA;EACA,uBAAA;ApB4wHF;;AoBzwHA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;ApB4wHF;;AoBzwHA;EACE,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ApB4wHF;;AoBzwHA;EACE,YAAA;ApB4wHF;;AoBxwHA;EACE,4DAAA;EACA,kBAAA;EACA,gBAAA;ApB2wHF;;AoBxwHA;EACE,iBAAA;EACA,gBAAA;ApB2wHF;;AoBxwHA;EACE,iBAAA;EACA,gBAAA;ApB2wHF;;AoBxwHA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;ApB2wHF;;AoBxwHA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;ApB2wHF;;AoBxwHA;EACE,kBAAA;EACA,uBAAA;ApB2wHF;;AoBxwHA;EACE,wBAAA;EACA,iBAAA;ApB2wHF;;AoBtwHA;EACE,kBAAA;EACA,gBAAA;ApBywHF;;AoBtwHA;EACE,iBAAA;EACA,gBAAA;ApBywHF;;AoBtwHA;EACE,iBAAA;EACA,gBAAA;ApBywHF;;AoBtwHA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;ApBywHF;;AoBtwHA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;ApBywHF;;AoBtwHA;EACE,kBAAA;EACA,uBAAA;ApBywHF;;AoBtwHA;EACE,wBAAA;EACA,iBAAA;ApBywHF;;AoBnwHA;EACE,+EAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;ApBswHF;;AoBnwHA;EACE,YAAA;ApBswHF;;AoBnwHA;EACE,uBAAA;EACA,yBAAA;EACA,uCAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,uMACE;EAGF,0BAAA;EACA,iDAAA;EACA,iBAAA;ApBmwHF;;AoBhwHA;;EAEE,mCAAA;EACA,sCAAA;EACA,mBAAA;EACA,8CAAA;ApBmwHF;;AoBhwHA;EACE,uBAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;ApBmwHF;;AoBhwHA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,6CAAA;EACA,mBAAA;ApBmwHF;;AoBhwHA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,6EAAA;EACA,+CAAA;ApBmwHF;;AoBhwHA;EACE,YAAA;ApBmwHF;AoBjwHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ApBmwHJ;AoBhwHE;EACE,SAAA;EACA,4BAAA;EACA,kBAAA;EACA,sBAAA;ApBkwHJ;;AoB9vHA;EACE,oBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ApBiwHF;;AoB9vHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ApBiwHF;;AoB9vHA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gFAAA;ApBiwHF;AoB/vHE;;EAEE,cAAA;ApBiwHJ;AoB9vHE;EACE,kBAAA;EACA,gBAAA;ApBgwHJ;AoB7vHE;EACE,eAAA;EACA,4BAAA;EACA,kBAAA;ApB+vHJ;AoB5vHE;EACE,mBAAA;ApB8vHJ;AoB3vHE;EACE,qFAAA;EACA,qCAAA;EACA,cAAA;ApB6vHJ;AoB3vHI;EACE,6EAAA;EACA,WAAA;ApB6vHN;;AoBxvHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;ApB2vHF;;AoBxvHA;EACE,uBAAA;EACA,YAAA;ApB2vHF;;AoBxvHA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApB2vHF;;AoBxvHA;EACE,mBAAA;EACA,oBAAA;EACA,6CAAA;ApB2vHF;AoBzvHE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;ApB2vHJ;;AoBvvHA;EACE,eAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,iBAAA;ApB0vHF;;AoBvvHA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;ApB0vHF;;AoBvvHA;EACE,uCAAA;ApB0vHF;;AoBvvHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ApB0vHF;;AoBvvHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;ApB0vHF;AoBxvHE;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApB0vHJ;;AoBtvHA;;EAEE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;ApByvHF;;AoBtvHA;EACE,gBAAA;EACA,0DAAA;ApByvHF;AoBvvHE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;ApByvHJ;AoBtvHE;EACE,mBAAA;EACA,cAAA;ApBwvHJ;AoBrvHE;EACE,qBAAA;EACA,8CAAA;ApBuvHJ;;AoBnvHA;EACE,kBAAA;ApBsvHF;AoBpvHE;EACE,mBAAA;ApBsvHJ;;AoBlvHA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;ApBqvHF;AoBnvHE;EACE,mBAAA;EACA,cAAA;ApBqvHJ;;AoBjvHA;;;EAGE,iBAAA;EACA,gBAAA;ApBovHF;;AoBjvHA;;EAEE,4BAAA;ApBovHF;;AoBjvHA;EACE,cAAA;ApBovHF;;AoBjvHA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;ApBovHF;;AoBjvHA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ApBovHF;;AoBjvHA;EACE,WAAA;EACA,+EAAA;EACA,+CAAA;ApBovHF;AoBlvHE;EACE,wBAAA;ApBovHJ;;AoBhvHA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;ApBmvHF;AoBjvHE;EACE,mBAAA;ApBmvHJ;;AoB/uHA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sFAAA;EACA,cAAA;ApBkvHF;AoBhvHE;EACE,iBAAA;EACA,eAAA;ApBkvHJ;AoB/uHE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;ApBivHJ;;AoB7uHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ApBgvHF;;AoB7uHA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ApBgvHF;AoB9uHE;EACE,qCAAA;EACA,sEAAA;ApBgvHJ;AoB9uHI;EACE,+EAAA;ApBgvHN;AoB9uHM;EACE,2BAAA;ApBgvHR;;AoB1uHA;EACE,gBAAA;EACA,0BAAA;ApB6uHF;;AoB1uHA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;ApB6uHF;;AoB1uHA;EACE,SAAA;EACA,YAAA;ApB6uHF;AoB3uHE;;EAEE,cAAA;ApB6uHJ;AoB1uHE;EACE,kBAAA;ApB4uHJ;AoBzuHE;EACE,eAAA;EACA,4BAAA;EACA,iBAAA;ApB2uHJ;;AoBvuHA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;ApB0uHF;AoBxuHE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gCAAA;ApB0uHJ;;AoBtuHA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;ApByuHF;;AoBtuHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mCAAA;ApByuHF;;AoBtuHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;ApByuHF;AoBvuHE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ApByuHJ;;AoBruHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ApBwuHF;AoBtuHE;EACE,kBAAA;ApBwuHJ;AoBruHE;EACE,4BAAA;EACA,iBAAA;ApBuuHJ;;AoBluHE;EACE,eAAA;EACA,kBAAA;ApBquHJ;AoBluHE;EACE,gBAAA;EACA,4BAAA;EACA,kBAAA;ApBouHJ;;AoBhuHA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,qDAAA;ApBmuHF;;AoBhuHA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;ApBmuHF;;AoBhuHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;ApBmuHF;AoBjuHE;;EAEE,kBAAA;ApBmuHJ;AoBhuHE;EACE,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;ApBkuHJ;AoB/tHE;EACE,kBAAA;EACA,4BAAA;ApBiuHJ;AoB9tHE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;ApBguHJ;;AoB5tHA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;ApB+tHF;;AoB5tHA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;ApB+tHF;;AoB5tHA;EACE,aAAA;EACA,SAAA;ApB+tHF;;AoB5tHA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ApB+tHF;AoB7tHE;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;ApB+tHJ;AoB5tHE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;ApB8tHJ;;AoB1tHA;EACE,gBAAA;ApB6tHF;;AoB1tHA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;ApB6tHF;;AoB1tHA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;ApB6tHF;;AoB1tHA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,8CAAA;EACA,0CAAA;ApB6tHF;AoB3tHE;EACE,iBAAA;EACA,eAAA;EACA,uBAAA;ApB6tHJ;;AoBztHA;EACE,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApB4tHF;;AoBztHA;EACE,gBAAA;EACA,qCAAA;EACA,iBAAA;EACA,iBAAA;ApB4tHF;;AoBztHA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,6EAAA;EACA,+CAAA;ApB4tHF;;AoBztHA;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+EAAA;ApB4tHF;;AoBztHA;EACE;IACE,UAAA;IACA,uCAAA;EpB4tHF;EoB1tHA;IACE,UAAA;IACA,eAAA;EpB4tHF;AACF;AoBztHA;EACE;IACE,0BAAA;EpB2tHF;EoBxtHA;IACE,gBAAA;EpB0tHF;EoBvtHA;IACE,mBAAA;IACA,gBAAA;IACA,mBAAA;EpBytHF;EoBttHA;IACE,gBAAA;EpBwtHF;EoBrtHA;;;IAGE,0BAAA;EpButHF;EoBptHA;;;IAGE,sBAAA;IACA,oBAAA;EpBstHF;AACF;AoBltHE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;ApBotHJ;AoBjtHE;EACE,kBAAA;EACA,gBAAA;EACA,wBAAA;ApBmtHJ;AoBhtHE;;;;;;;;;EASE,iDAAA;ApBktHJ;AoB/sHE;;;EAGE,kBAAA;EACA,gBAAA;EACA,iBAAA;ApBitHJ;AoB9sHE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ApBgtHJ;AoB7sHE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApB+sHJ;;AoB3sHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ApB8sHF;;AoB3sHA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;ApB8sHF;AoB5sHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;ApB8sHJ;AoB3sHE;EACE,SAAA;EACA,eAAA;EACA,qCAAA;ApB6sHJ;;AoBzsHA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;ApB4sHF;;AoBzsHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kEAAA;ApB4sHF;;AoBzsHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ApB4sHF;;AoBzsHA;EACE,aAAA;EACA,yEAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,mBAAA;ApB4sHF;;AoBzsHA;;EAEE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ApB4sHF;;AoBzsHA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ApB4sHF;AoB1sHE;EACE,cAAA;EACA,qCAAA;EACA,mCAAA;ApB4sHJ;AoBzsHE;EACE,aAAA;EACA,mBAAA;ApB2sHJ;;AoBvsHA;EACE,WAAA;ApB0sHF;AoBxsHE;EACE,cAAA;EACA,oCAAA;EACA,mBAAA;ApB0sHJ;AoBvsHE;EACE,YAAA;EACA,mBAAA;ApBysHJ;;AoBrsHA;EACE,eAAA;ApBwsHF;;AoBrsHA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;ApBwsHF;AoBtsHE;EACE,kCAAA;EACA,cAAA;ApBwsHJ;;AoBpsHA;;EAEE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,mBAAA;ApBusHF;AoBrsHE;;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;ApBwsHJ;AoBrsHE;;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kEAAA;EACA,kBAAA;ApBwsHJ;AoBrsHE;;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ApBwsHJ;;AoBpsHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;ApBusHF;;AoBpsHA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8DAAA;ApBusHF;AoBrsHE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;ApBusHJ;AoBpsHE;EACE,kBAAA;ApBssHJ;AoBnsHE;;EAEE,SAAA;EACA,qCAAA;EACA,kBAAA;ApBqsHJ;AoBlsHE;EACE,eAAA;ApBosHJ;;AoBhsHA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;ApBmsHF;;AoBhsHA;EACE,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ApBmsHF;;AoBhsHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ApBmsHF;;AoBhsHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ApBmsHF;AoBjsHE;EACE,gBAAA;ApBmsHJ;AoBhsHE;;EAEE,cAAA;ApBksHJ;AoB/rHE;EACE,kBAAA;EACA,gBAAA;ApBisHJ;AoB9rHE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;ApBgsHJ;AoB7rHE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;ApB+rHJ;;AoB3rHA;EACE,gBAAA;ApB8rHF;;AoB3rHA;EACE,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,iDAAA;EACA,8CAAA;ApB8rHF;;AoB3rHA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;ApB8rHF;AoB5rHE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;ApB8rHJ;AoB3rHE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ApB6rHJ;;AoBzrHA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;ApB4rHF;AoB1rHE;EACE,mBAAA;EACA,cAAA;ApB4rHJ;;AoBxrHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;ApB2rHF;AoBzrHE;EACE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;ApB2rHJ;AoBxrHE;EACE,gBAAA;EACA,qBAAA;EACA,6CAAA;ApB0rHJ;;AoBtrHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ApByrHF;AoBvrHE;EACE,aAAA;EACA,SAAA;ApByrHJ;AoBtrHE;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ApBwrHJ;AoBtrHI;EACE,cAAA;ApBwrHN;;AoBnrHA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;ApBsrHF;;AoBnrHA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApBsrHF;AoBprHE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;ApBsrHJ;AoBnrHE;EACE,qCAAA;EACA,sEAAA;ApBqrHJ;AoBnrHI;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;ApBqrHN;;AoBhrHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ApBmrHF;;AoBhrHA;EACE,gBAAA;ApBmrHF;AoBjrHE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;ApBmrHJ;;AoB/qHA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ApBkrHF;;AoB/qHA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;ApBkrHF;AoBhrHE;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;ApBkrHJ;;AoB9qHA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApBirHF;;AoB9qHA;EACE;;IAEE,aAAA;EpBirHF;EoB9qHA;IACE,kBAAA;EpBgrHF;EoB7qHA;IACE,8BAAA;EpB+qHF;EoB5qHA;IACE,WAAA;EpB8qHF;AACF;AqB3mKA;EACI,oCAAA;EACA,qCAAA;ArB6mKJ;AqB3mKI;EACI,YAAA;EACA,0CAAA;ArB6mKR;AqB3mKQ;EACI,iBAAA;EACA,gBAAA;ArB6mKZ;AqB1mKQ;EACI,kBAAA;ArB4mKZ;AqBzmKQ;;EAEI,uBAAA;ArB2mKZ;AqBxmKQ;EACI,eAAA;EACA,gBAAA;ArB0mKZ;;AsBloKA;EACC,iBAAA;EACA,aAAA;EACA,kEAAA;EACA,qCAAA;EACA,mBAAA;EACA,cAAA;AtBqoKD;;AsBloKA;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,iPACC;AtBooKF;;AsB/nKA;EACC,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AtBkoKD;;AsB/nKA;EACC,cAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,sBAAA;AtBkoKD;;AsB/nKA;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AtBkoKD;;AsB/nKA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AtBkoKD;;AsB/nKA;EACC,cAAA;AtBkoKD;;AsB/nKA;EACC,SAAA;EACA,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AtBkoKD;;AsB/nKA;EACC,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AtBkoKD;;AsB/nKA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AtBkoKD;AsBhoKC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;AtBkoKF;AsB/nKC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;AtBioKF;;AsB7nKA;EACC,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,qDAAA;AtBgoKD;AsB9nKC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;AtBgoKF;AsB7nKC;EACC,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;AtB+nKF;AsB5nKC;EACC,kBAAA;EACA,gBAAA;EACA,uBAAA;AtB8nKF;AsB3nKC;EACC,qCAAA;EACA,2BAAA;AtB6nKF;;AsBznKA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,+IACC;AtB2nKF;;AsBvnKA;EACC,uBAAA;EACA,+BAAA;EACA,yCAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;AtB0nKD;AsBxnKC;EACC,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AtB0nKF;;AsBtnKA;EACC,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AtBynKD;;AsBtnKA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,oBAAA;EACA,yCAAA;EACA,mBAAA;EACA,qFAAA;AtBynKD;AsBvnKC;EACC,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AtBynKF;AsBtnKC;EACC,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AtBwnKF;AsBtnKE;EACC,cAAA;AtBwnKH;AsBpnKC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,8CAAA;AtBsnKF;;AsBlnKA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AtBqnKD;;AsBlnKA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AtBqnKD;AsBnnKC;EACC,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AtBqnKF;AsBlnKC;;EAEC,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,8EAAA;AtBonKF;AsBlnKE;;EACC,cAAA;EACA,gBAAA;AtBqnKH;AsBlnKE;;EACC,gBAAA;EACA,qBAAA;EACA,6CAAA;AtBqnKH;AsBjnKC;EACC,YAAA;EACA,kBAAA;AtBmnKF;AsBhnKC;EACC,iBAAA;EACA,wBAAA;EACA,gBAAA;AtBknKF;;AsB9mKA;EACC,iBAAA;AtBinKD;;AsB9mKA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AtBinKD;;AsB9mKA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,+CAAA;EACA,gCAAA;AtBinKD;AsB/mKC;EACC,mBAAA;AtBinKF;;AsB7mKA;EACC,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AtBgnKD;AsB9mKC;EACC,cAAA;AtBgnKF;;AsB5mKA;EACC,kBAAA;AtB+mKD;AsB7mKC;EACC,qBAAA;AtB+mKF;AsB5mKC;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AtB8mKF;;AsB1mKA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,0EAAA;EACA,WAAA;EACA,kBAAA;EACA,+CAAA;AtB6mKD;;AsB1mKA;EACC;IACC,0BAAA;EtB6mKA;EsB1mKD;IACC,gBAAA;IACA,8BAAA;EtB4mKA;EsBzmKD;IACC,gBAAA;IACA,kBAAA;EtB2mKA;EsBxmKD;IACC,iBAAA;EtB0mKA;EsBvmKD;IACC,uBAAA;IACA,0BAAA;EtBymKA;AACF;AsBtmKA;EACC;IACC,0BAAA;EtBwmKA;EsBrmKD;IACC,iBAAA;EtBumKA;EsBpmKD;IACC,8BAAA;IACA,mBAAA;EtBsmKA;EsBnmKD;IACC,aAAA;EtBqmKA;AACF;AuB1/KA;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;EACA,oBAAA;AvB4/KJ;AuB1/KI;EAAmB,SAAA;EAAW,SAAA;EAAW,2BAAA;AvB+/K7C;AuB9/KI;EAAmB,SAAA;EAAW,WAAA;AvBkgLlC;AuBjgLI;EAAmB,SAAA;EAAW,UAAA;AvBqgLlC;AuBpgLI;EAAmB,YAAA;EAAc,SAAA;EAAW,2BAAA;AvBygLhD;AuBxgLI;EAAmB,YAAA;EAAc,WAAA;AvB4gLrC;AuB3gLI;EAAmB,YAAA;EAAc,UAAA;AvB+gLrC;;AuB5gLA;EAEI,0BAAA;EACA,4BAAA;EACA,wCAAA;EACA,0CAAA;EAEA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,+CAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,6BAAA;EACA,iGACI;EACJ,yCAAA;EACA,iDAAA;EACA,2CAAA;EACA,gMACI;EAKJ,iCAAA;EACA,+BAAA;AvBugLJ;AuBrgLI;EAAiB,eAAA;AvBwgLrB;AuBtgLI;EACI,gMACI;AvBugLZ;AuB//KI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,0BAAA;EACA,qFAAA;EACA,2CAAA;AvBigLR;AuB7/KI;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,sFAAA;EACA,oBAAA;EACA,WAAA;AvB+/KR;AuB5/KI;EACI,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gFAAA;EACA,oBAAA;EACA,WAAA;AvB8/KR;AuB3/KI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,6FAAA;EACA,6HACI;EAGJ,4EAAA;AvB0/KR;AuBx/KQ;EAAI,cAAA;AvB2/KZ;AuB1/KQ;;EACY,gBAAA;AvB6/KpB;AuB1/KI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,6CAAA;AvB4/KR;AuBz/KI;EACI,YAAA;EACA,gBAAA;AvB2/KR;AuBx/KI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,6BAAA;AvB0/KR;AuBv/KI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;AvBy/KR;AuBt/KI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;AvBw/KR;AuBr/KI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;EACA,yEAAA;AvBu/KR;AuBr/KQ;EACI,WAAA;EACA,qFAAA;AvBu/KZ;AuBr/KQ;EAAW,0BAAA;AvBw/KnB;AuBr/KI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,yEAAA;AvBu/KR;AuBr/KQ;EACI,6BAAA;EACA,kCAAA;EACA,wBAAA;AvBu/KZ;AuBr/KQ;EACI,aAAA;EACA,mEAAA;AvBu/KZ;AuBn/KI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,oFAAA;EACA,6BAAA;EACA,YAAA;EACA,iCAAA;EACA,iCAAA;EACA,6BAAA;AvBq/KR;AuB3sLA;EAyNI,6BAAA;AvBq/KJ;AuBp/KI;EACI,gEAAA;AvBs/KR;AuBn/KI;EACI,oBAAA;EACA,iEAAA;AvBq/KR;AuBrtLA;EAmOI,sBAAA;AvBq/KJ;AuBp/KI;EACI,0BAAA;EACA,4BAAA;EACA,yCAAA;EACA,2CAAA;AvBs/KR;AuBn/KI;EACI,0BAAA;EACA,4BAAA;EACA,wCAAA;EACA,0CAAA;AvBq/KR;AuBl/KI;EACI,0BAAA;EACA,4BAAA;EACA,yCAAA;EACA,2CAAA;AvBo/KR;AuBj/KI;EACI,0BAAA;EACA,4BAAA;EACA,yCAAA;EACA,yCAAA;AvBm/KR;AuBh/KI;EACI,0BAAA;EACA,4BAAA;EACA,wCAAA;EACA,yCAAA;AvBk/KR;;AuB9+KA,4CAAA;AAEI;EAAe,8BAAA;AvBi/KnB;AuBh/KI;EAAe,iCAAA;AvBm/KnB;;AuBh/KA,QAAA;AAEI;EAAY,0BAAA;AvBm/KhB;AuBl/KI;EAAW,qBAAA;AvBq/Kf;AuBp/KI;EACI,8BAAA;EACA,qFAAA;AvBs/KR;;AuBl/KA,0BAAA;AACA;EACI;IAAO,UAAA;IAAY,wCAAA;IAA0C,iBAAA;EvBw/K/D;EuBv/KE;IAAO,UAAA;IAAY,iCAAA;IAAwC,eAAA;EvB4/K7D;AACF;AuB1/KA;EACI;IAAO,UAAA;IAAY,iCAAA;EvB8/KrB;EuB7/KE;IAAO,UAAA;IAAY,wCAAA;IAA0C,iBAAA;EvBkgL/D;AACF;AuBhgLA;EACI;IAAO,UAAA;IAAY,uCAAA;IAAyC,iBAAA;EvBqgL9D;EuBpgLE;IAAO,UAAA;IAAY,iCAAA;IAAuC,eAAA;EvBygL5D;AACF;AuBvgLA;EACI;IAAO,UAAA;IAAY,iCAAA;EvB2gLrB;EuB1gLE;IAAO,UAAA;IAAY,uCAAA;IAAyC,iBAAA;EvB+gL9D;AACF;AuB7gLA;EACI;IAAO,oCAAA;IAAsC,UAAA;EvBihL/C;EuBhhLE;IAAO,mCAAA;IAAqC,UAAA;EvBohL9C;EuBnhLE;IAAO,6BAAA;IAA+B,UAAA;EvBuhLxC;AACF;AuBrhLA;EACI;IAAO,oBAAA;EvBwhLT;EuBvhLE;IAAO,oBAAA;EvB0hLT;AACF;AuBxhLA;EACI;IAAK,yBAAA;EvB2hLP;AACF;AuBzhLA,2BAAA;AACA;EACI;IACI,yBAAA;IACA,SAAA;EvB2hLN;EuBzhLM;IAA2C,SAAA;EvB4hLjD;EuB3hLM;IAAoD,YAAA;EvB8hL1D;EuB7hLM;IACI,SAAA;IACA,WAAA;IACA,2BAAA;EvB+hLV;EuB3hLE;IACI,gBAAA;IACA,4BAAA;IACA,0BAAA;IACA,wBAAA;IACA,mBAAA;EvB6hLN;EuB3hLM;IAAU,WAAA;IAAa,YAAA;IAAc,gBAAA;IAAkB,mBAAA;IAAqB,eAAA;EvBkiLlF;EuBjiLM;IAAW,kBAAA;EvBoiLjB;EuBniLM;IAAa,kBAAA;EvBsiLnB;AACF;AuBniLA,mCAAA;AACA;EACI;;;;IAII,eAAA;EvBqiLN;EuBniLE;IAAuB,UAAA;IAAY,6BAAA;EvBuiLrC;EuBtiLE;IAAyB,eAAA;EvByiL3B;AACF;AwB95LA;EACI,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EAEA;;;oEAAA;EAIA,oFAAA;EACA,sDAAA;EACA,kDAAA;EAEA;;;oEAAA;EAIA,4CAAA;EACA,4CAAA;EAGA,qBAAA;EACA,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sCAAA;EACA,wBAAA;EACA,0BAAA;AxB45LJ;;AwBz5LA,mCAAA;AAEA;EACI,mCAAA;EACA,4BAAA;EACA,6CAAA;AxB25LJ;;AwBx5LA;EACI,oCAAA;AxB25LJ;;AwBx5LA;EACI,6BAAA;AxB25LJ;;AwBx5LA;EACI,6BAAA;AxB25LJ;;AwBx5LA;EACI,mBAAA;EACA,uCAAA;AxB25LJ;;AwBx5LA;EACI,uBAAA;EACA,mBAAA;AxB25LJ;;AwBx5LA;EACI,mBAAA;EACA,uCAAA;AxB25LJ;;AwBx5LA;EACI,mCAAA;AxB25LJ;;AwBx5LA;EACI,sBAAA;EACA,qCAAA;AxB25LJ;;AwBx5LA;EACI,oBAAA;EACA,uCAAA;AxB25LJ;;AwBx5LA;EACI,6BAAA;AxB25LJ;;AwBx5LA;EACI,oCAAA;EACA,gCAAA;EACA,qCAAA;AxB25LJ;;AwBx5LA;EACI,gCAAA;EACA,mBAAA;EACA,8CAAA;AxB25LJ;;AwBx5LA;EACI,qBAAA;AxB25LJ;;AwBx5LA;EACI,qBAAA;AxB25LJ;;AwBx5LA,qCAAA;AAEA;EACI,mBAAA;AxB05LJ;;AwBv5LA;EACI,qDAAA;AxB05LJ;;AwBv5LA;EACI,qDAAA;AxB05LJ;;AwBv5LA;EACI,gCAAA;AxB05LJ;;AwBv5LA;;;;EAII,UAAA;EACA,WAAA;AxB05LJ;;AwBv5LA;;;;EAII,qDAAA;EACA,oBAAA;AxB05LJ;;AwBv5LA;;;;EAII,mBAAA;EACA,oBAAA;AxB05LJ;;AwBv5LA,gCAAA;AAEA;;EAEI,4BAAA;EACA,mBAAA;EACA,oBAAA;AxBy5LJ;;AwBt5LA;;;EAGI,4BAAA;EACA,gCAAA;EACA,aAAA;AxBy5LJ;;AwBt5LA;EACI,gCAAA;EACA,4BAAA;AxBy5LJ;;AwBt5LA;EACI,4BAAA;EACA,gCAAA;AxBy5LJ;;AwBt5LA,4CAAA;AAEA;EACI,4BAAA;EACA,yBAAA;EACA,qCAAA;EACA,sBAAA;EACA,yHAAA;AxBw5LJ;;AwBr5LA;EACI,0BAAA;AxBw5LJ;;AwBr5LA;EACI,gCAAA;AxBw5LJ;;AwBr5LA;;EAEI,oBAAA;EACA,oBAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,yCAAA;EACA,6BAAA;EACA,6BAAA;EACA,2CAAA;EACA,2CAAA;EACA,mCAAA;AxBw5LJ;;AwBr5LA;;EAEI,mEAAA;EACA,+CAAA;AxBw5LJ;;AwBr5LA;;;;EAII,aAAA;EACA,gBAAA;AxBw5LJ;;AwBr5LA;;EAEI,uBAAA;EACA,oBAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,yCAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AxBw5LJ;;AwBr5LA;;;EAGI,uBAAA;EACA,8CAAA;EACA,6BAAA;EACA,0BAAA;EACA,mDAAA;EACA,8BAAA;EACA,2BAAA;EACA,oDAAA;EACA,gCAAA;EACA,8CAAA;AxBw5LJ;;AwBr5LA;EACI,uBAAA;EACA,6BAAA;EACA,qBAAA;AxBw5LJ;;AwBr5LA;EACI,WAAA;EACA,SAAA;EACA,mCAAA;AxBw5LJ;;AwBr5LA,+CAAA;AAEA;;EAEI,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;AxBu5LJ;;AwBp5LA;EACI,4BAAA;AxBu5LJ;;AwBp5LA;;EAEI,oCAAA;EACA,WAAA;EACA,gBAAA;AxBu5LJ;;AwBp5LA;;EAEI,qCAAA;EACA,gBAAA;EACA,uBAAA;AxBu5LJ;;AwBp5LA;;EAEI,+BAAA;EACA,YAAA;AxBu5LJ;;AwBp5LA;;EAEI,UAAA;AxBu5LJ;;AwBp5LA;EACI,oCAAA;AxBu5LJ;;AwBp5LA,sCAAA;AAEA;EACI,mBAAA;EACA,qCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;AxBs5LJ;;AwBn5LA;EACI,6DAAA;EACA,+CAAA;AxBs5LJ;;AwBn5LA;;EAEI,mBAAA;EACA,qBAAA;EACA,qCAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;AxBs5LJ;;AwBn5LA;;EAEI,+BAAA;EACA,oCAAA;AxBs5LJ;;AwBn5LA;;;EAGI,gCAAA;AxBs5LJ;;AwBn5LA;EACI,2CAAA;AxBs5LJ;;AwBn5LA;EACI,2CAAA;AxBs5LJ;;AwBn5LA;EACI,gCAAA;AxBs5LJ;;AwBn5LA;EACI,uCAAA;AxBs5LJ;;AwBn5LA;EACI,gCAAA;AxBs5LJ;;AwBn5LA;EACI,8BAAA;AxBs5LJ;;AwBn5LA;EACI,qCAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AxBs5LJ;;AwBp5LA,+FAAA;AACA;EACI,6BAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;AxBu5LJ;;AwBp5LA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0EAAA;AxBu5LJ;;AwBp5LA;EACI,kCAAA;AxBu5LJ;;AwBp5LA;EACI,WAAA;EACA,qCAAA;EACA,8CAAA;AxBu5LJ;;AwBp5LA;EACI,WAAA;AxBu5LJ;;AAhyMA;;;EAGI,sBAAA;AAmyMJ;;AAjyMA;EACI;;;oEAAA;EAIA,iFAAA;EACA,iFAAA;EACA,2DAAA;EACA,0DAAA;AAoyMJ;;AA/xMA;EAAc,kCAAA;AAmyMd;;AAlyMA;EAAW,+BAAA;AAsyMX;;AAryMA;EAAU,8BAAA;AAyyMV;;AAtyMA,mBAAA;AACA;EACE,uBAAA,EAAA,8BAAA;AAyyMF;;AAtyMA,qBAAA;AACA;EACE,UAAA;EACA,WAAA;AAyyMF;;AAtyMA;EACE,mBAAA,EAAA,qBAAA;EACA,mBAAA;AAyyMF;;AAtyMA;EACE,qDAAA,EAAA,kBAAA;EACA,mBAAA;AAyyMF;;AAtyMA;EACE,qDAAA,EAAA,iBAAA;AAyyMF;;AAtyMA,YAAA;AACA;EACE,qBAAA;EACA,gCAAA;AAyyMF;;AApyMA;EACI,SAAA;EACA,UAAA;EACA,2BAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AAuyMJ;AAryMI;EACI,YAAA;AAuyMR;AApyMI;EACI,WAAA;AAsyMR;AApyMQ;EACI,yBMnGF;ENoGE,gBAAA;EACA,mBAAA;EACA,WAAA;AAsyMZ;AApyMY;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;AAsyMhB;AAjyMI;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAmyMR;AAjyMQ;EACI,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AAmyMZ;AAjyMY;EACI,WAAA;EACA,aAAA;AAmyMhB;AA/xMQ;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAiyMZ;AA7xMI;EACI,cM5IC;EN6ID,gBAAA;AA+xMR;AA5xMI;EACI,WAAA;AA8xMR;AA5xMQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AA8xMZ;AA5xMY;EACI,uBAAA;AA8xMhB;AAxxMI;EACI,aAAA;EACA,gBAAA;AA0xMR;;AAtxMA;EACI,WM3KO;ANo8MX;;AArxMA;EACI,SAAA;AAwxMJ;;AArxMA;EACI,yBAAA;AAwxMJ;;AArxMA;EACI,mBAAA;AAwxMJ;;AArxMA;;;EAGE,eAAA;AAwxMF;;AArxMA;EACI,gBAAA;AAwxMJ;;AArxMA;EACI,mBAAA;AAwxMJ;;AArxMA;EACQ,eAAA;AAwxMR","sourcesContent":["@import \"./_variables.scss\";\n@import \"./_sidebar.scss\";\n@import \"./_login.scss\";\n@import \"./_signup.scss\";\n@import \"./_header.scss\";\n@import \"./_dropdown.scss\";\n@import \"./_tabWrapper.scss\";\n@import \"_table.scss\";\n@import \"./_footer.scss\";\n@import \"./_forgotPassword.scss\";\n@import \"./_stepper.scss\";\n@import \"_checkbox.scss\";\n@import \"_roleManagement.scss\";\n@import \"./contextMenu.scss\";\n@import \"./tempUserDetails.scss\";\n@import \"./_loader.scss\";\n@import \"./_customtable.scss\";\n@import \"./_commonTable.scss\";\n@import \"./_confirmDialog.scss\";\n@import \"./_settings.scss\";\n@import \"./_home.scss\";\n@import \"./_showInterest.scss\";\n@import \"./_appToast.scss\";\n@import \"./_theme.scss\";\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n:root {\n    --sidebar-gradient:\n        radial-gradient(280px 220px at 0% 0%, rgba(237, 0, 140, 0.38), transparent 64%),\n        radial-gradient(260px 240px at 120% 100%, rgba(30, 113, 187, 0.45), transparent 60%),\n        linear-gradient(180deg, #1c2468 0%, #12183a 48%, #0b1026 100%);\n    --button-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);\n    --import-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);\n    --yes-gradient: linear-gradient(to right, #4caf50, #2e7d32);\n    --no-gradient: linear-gradient(to right, #f44336, #c62828);\n}\n\n// Dynamically setting up theme\n\n.btn-import { background: var(--import-gradient); }\n.btn-yes { background: var(--yes-gradient); }\n.btn-no { background: var(--no-gradient); }\n\n\n/* Apply globally */\nhtml {\n  scroll-behavior: smooth; /* smooth anchor/page scroll */\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f4f4f4;   /* light gray track */\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #4f46e5, #3b82f6); /* indigo → blue */\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #4338ca, #2563eb); /* darker hover */\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #3b82f6 #f4f4f4;\n}\n\n\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-weight: 500 !important;\n    font-size: 0.875rem !important;\n    box-sizing: none;\n    height: 100%;\n    font-family: \"Montserrat\" !important;\n    overflow-x: hidden;\n\n    #root {\n        height: 100%;\n    }\n\n    .input_field {\n        width: 100%;\n\n        .form-control {\n            font-family: $fc-font;\n            font-weight: 500;\n            font-size: 0.875rem;\n            width: 100%;\n\n            &:focus {\n                outline: none;\n                box-shadow: none;\n                border: 1px solid $fc-black;\n            }\n        }\n    }\n\n    .main_container {\n        height: 100vh;\n        overflow: hidden;\n        width: 100vw;\n        position: relative;\n\n        .content {\n            display: flex;\n            height: calc(100vh - 92px);\n            position: relative;\n            z-index: 1;\n\n            .content_conteiner {\n                width: 100%;\n                padding: 1rem;\n            }\n        }\n\n        .welcome-portal {\n            text-align: center;\n            padding: 3rem 1rem;\n            color: #222;\n            background: #f8f8f8;\n            border-radius: 0;\n            width: 100%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n\n    .required {\n        color: $fc-red;\n        margin-left: 2px;\n    }\n\n    .form-po {\n        gap: 0.5rem;\n\n        .checkboxField {\n            display: flex;\n            gap: 0.5rem;\n            align-items: center;\n            justify-content: center;\n\n            .form-label {\n                margin-bottom: 0.875rem;\n            }\n\n        }\n    }\n\n    .modal-body {\n        height: 30rem;\n        overflow-y: clip;\n    }\n}\n\na {\n    color: $fc-black;\n}\n\n\nh1 {\n    margin: 0;\n}\n\n.form-select {\n    padding: .375rem .75rem;\n}\n\nol.breadcrumb.mb-0 {\n    align-items: center;\n}\n\ninput,\nselect,\ntextarea {\n  cursor: pointer;\n}\n\n.form-select-sm {\n    line-height: 1.2;\n}\n\n.belowSpace {\n    margin-bottom: 1.5%;\n}\n\n.MuiAutocomplete-listbox .MuiAutocomplete-option {\n        font-size: 14px;\n    }",".sidebarBox{\n        background: var(--sidebar-gradient);\n    background-repeat: no-repeat;\n    box-shadow: 8px 0 24px rgba(11, 16, 38, 0.12);\n      height: calc(100% + 2rem);\n}\n.sidebar {\n    z-index: 1000;\n    overflow: auto;\n    height: calc(100% - 4rem);\n    transition: .2s;\n  \n    left: 0;\n    top: 50px;\n    z-index: 9;\n    color: white;\n    width: 225px;\n\n    .sidebar-item {\n        .sidebar-title {\n            cursor: pointer;\n            font-family: \"Montserrat\", sans-serif;\n            font-weight: 600;\n            font-size: 13px;\n            line-height: 1.3;\n            padding: 6px 8px;\n            display: flex;\n            justify-content: space-between;\n            min-height: 44px;\n            height: auto;\n            align-items: center;\n\n            &:hover {\n                background: rgba(255, 255, 255, 0.1);\n            }\n        }\n\n        .sidebar-children {\n            display: grid;\n            grid-template-rows: 0fr;\n            margin-left: 1rem;\n            margin-top: 0;\n            transition: grid-template-rows 0.28s ease, margin-top 0.28s ease;\n\n            &.is-open {\n                grid-template-rows: 1fr;\n                margin-top: 0.3rem;\n            }\n\n            .sidebar-children-inner {\n                min-height: 0;\n                overflow: hidden;\n            }\n\n            .sidebar-item {\n                .sidebar-title {\n                    font-weight: 500;\n                    font-size: 12px;\n                    line-height: 1.3;\n                }\n            }\n        }\n    }\n\n    .arrow {\n        font-size: 0.8rem;\n        // display: none;\n    }\n\n    .icon-display {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        min-width: 0;\n    }\n\n    .sidebar-label {\n        font-family: \"Montserrat\", sans-serif;\n        font-weight: 600;\n        font-size: 13px;\n        line-height: 1.3;\n        color: #fff;\n    }\n\n    .sidebar-children .sidebar-label {\n        font-weight: 500;\n        font-size: 12px;\n    }\n\n    .sidebar-icon-badge {\n        width: 28px;\n        height: 28px;\n        border-radius: 8px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        background: #e4eef7;\n        color: #1e71bb;\n\n        i {\n            margin: 0;\n            font-size: 14px;\n            line-height: 1;\n            color: #1e71bb;\n        }\n    }\n\n    &.sidebar-collapsed {\n        .sidebar-title {\n            justify-content: center;\n            padding-left: 4px;\n            padding-right: 4px;\n        }\n\n        .icon-display {\n            justify-content: center;\n        }\n    }\n\n    // Responsive\n    @media (max-width: 768px) {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n    }\n}\n\n\n\n.sidebar {\n  color: white;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar .sidebar-item .sidebar-children {\n    transition: none;\n  }\n}\n\n\n.sidebar-footer {\n  flex-shrink: 0;\n  margin-top: auto;\n  padding: 5px 20px 20px;\n    display: flex;\n    flex-flow: nowrap;\n    align-items: center;\n    justify-content: center;\n  gap: 10px;\n}\n\n.powered-by-text {\n  font-size: 11px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.powered-by-logo {\n  display: block;\n  width: 80px;\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  object-position: left center;\n\n\n\n}\n\n.sidebar-footer.sidebar-collapsed {\n  padding: 0px !important;\n  align-items: center;\n}\n\n.sidebar-collapsed .powered-by-logo {\n     width: 100%;\n    margin: 10px 0px;\n    height: 36px;\n    object-position: center;\n    padding: 0px;\n}\n\n",".login-page {\n\tdisplay: flex;\n\tmin-height: 100vh;\n\tmax-height: 100vh;\n\toverflow: hidden;\n\tmax-width: 100%;\n}\n\n.login-left {\n\tflex: 1;\n\tbackground:\n\t\tradial-gradient(680px 460px at -6% -8%, rgba(176, 48, 168, 0.62), transparent 58%),\n\t\tradial-gradient(520px 380px at 108% 112%, rgba(36, 92, 196, 0.32), transparent 62%),\n\t\tlinear-gradient(180deg, #4c1d7a 0%, #2a1862 16%, #16184a 48%, #0c1438 78%, #090f28 100%);\n\tposition: relative;\n\toverflow: hidden;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: white;\n\tmax-height: 100vh;\n\tmin-width: 0;\n}\n\n.hero-frame {\n\tposition: relative;\n\taspect-ratio: 555 / 642;\n\theight: 100%;\n\twidth: auto;\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tcontainer-type: size;\n\tfont-family: \"Montserrat\", sans-serif;\n}\n\n.login-logo-section {\n\tposition: absolute;\n\tz-index: 6;\n\ttop: 3.6%;\n\tleft: 4.8%;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground: transparent;\n}\n\n.login-brand-logo {\n\tdisplay: block;\n\twidth: min(220px, 26%);\n\theight: auto;\n\tfilter: drop-shadow(0 2px 6px rgba(10, 4, 30, 0.35));\n}\n\n.hub-copy {\n\tposition: absolute;\n\tz-index: 3;\n\ttop: 20.6cqw;\n\tleft: 6%;\n\tright: 6%;\n\ttext-align: center;\n\n\th2 {\n\t\tmargin: 0;\n\t\tfont-family: \"Montserrat\", sans-serif;\n\t\tfont-size: 5.75cqw;\n\t\tfont-weight: 700;\n\t\tline-height: 1.12;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: #fff;\n\t}\n\n\tp {\n\t\tmargin: 1.35cqw 0 0;\n\t\tfont-size: 2.05cqw;\n\t\tfont-weight: 500;\n\t\tline-height: 1.45;\n\t\tcolor: rgba(255, 255, 255, 0.78);\n\t}\n}\n\n.hub-stage {\n\tposition: absolute;\n\tz-index: 2;\n\tleft: 5%;\n\twidth: 90%;\n\ttop: 36.5%;\n\taspect-ratio: 571 / 299;\n\tcontainer-type: size;\n}\n\n.hub-lines {\n\tposition: absolute;\n\tinset: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: visible;\n\tz-index: 1;\n\n\tline {\n\t\tstroke: rgba(198, 210, 240, 0.55);\n\t\tstroke-width: 1.15;\n\t\tstroke-dasharray: 2.4 3.6;\n\t\tstroke-linecap: round;\n\t}\n}\n\n.hub-dot {\n\tposition: absolute;\n\twidth: 1.25cqw;\n\theight: 1.25cqw;\n\tborder-radius: 50%;\n\ttransform: translate(-50%, -50%);\n\tbackground: #fff;\n\tbox-shadow: 0 0 0.8cqw rgba(255, 255, 255, 0.85);\n\tpointer-events: none;\n\tz-index: 2;\n\n\t&.is-pink {\n\t\tbackground: #f0abfc;\n\t\tbox-shadow: 0 0 0.9cqw rgba(232, 121, 249, 0.95);\n\t}\n}\n\n.hub-node {\n\tposition: absolute;\n\tleft: var(--nx);\n\ttop: var(--ny);\n\tz-index: 2;\n}\n\n.hub-node-ring {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 7.1cqw;\n\theight: 7.1cqw;\n\tdisplay: grid;\n\tplace-items: center;\n\ttransform: translate(-50%, -50%);\n\tborder-radius: 50%;\n\tborder: 0.16cqw solid rgba(214, 222, 248, 0.9);\n\tbackground: rgba(12, 18, 48, 0.55);\n\tcolor: #fff;\n\n\tsvg {\n\t\twidth: 46%;\n\t\theight: 46%;\n\t}\n}\n\n.hub-node-label {\n\tposition: absolute;\n\tcolor: rgba(255, 255, 255, 0.94);\n\tfont-size: 2.5cqw;\n\tfont-weight: 500;\n\tletter-spacing: -0.01em;\n\twhite-space: nowrap;\n\tline-height: 1;\n}\n\n.hub-node--left .hub-node-label {\n\tright: 4.7cqw;\n\ttop: 0;\n\ttransform: translateY(-50%);\n}\n\n.hub-node--right .hub-node-label {\n\tleft: 4.7cqw;\n\ttop: 0;\n\ttransform: translateY(-50%);\n}\n\n.hub-node--below .hub-node-label {\n\tleft: 0;\n\ttop: 4.3cqw;\n\ttransform: translateX(-50%);\n}\n\n.hub-core {\n\tposition: absolute;\n\tz-index: 3;\n\twidth: 13cqw;\n\theight: 13cqw;\n\tdisplay: grid;\n\tplace-items: center;\n\ttransform: translate(-50%, -50%);\n\tborder-radius: 50%;\n\tbackground: radial-gradient(circle at 50% 42%, rgba(206, 160, 255, 0.55), rgba(124, 64, 214, 0.16) 42%, transparent 68%);\n\tbox-shadow:\n\t\t0 0 0 0.14cqw rgba(226, 210, 255, 0.75),\n\t\t0 0 1.5cqw rgba(168, 85, 247, 0.42),\n\t\t0 0 3cqw rgba(236, 72, 153, 0.16);\n\n\tsvg {\n\t\twidth: 64%;\n\t\theight: 64%;\n\t\tfilter: drop-shadow(0 0.4cqw 0.6cqw rgba(18, 6, 40, 0.35));\n\t}\n}\n\n@keyframes hubCorePulse {\n\t0%,\n\t100% {\n\t\tbox-shadow:\n\t\t\t0 0 0 1.5px rgba(220, 196, 255, 0.5),\n\t\t\t0 0 22px rgba(168, 85, 247, 0.42),\n\t\t\t0 0 48px rgba(236, 72, 153, 0.16);\n\t}\n\n\t50% {\n\t\tbox-shadow:\n\t\t\t0 0 0 1.5px rgba(236, 220, 255, 0.8),\n\t\t\t0 0 36px rgba(168, 85, 247, 0.7),\n\t\t\t0 0 72px rgba(236, 72, 153, 0.28);\n\t}\n}\n\n.hub-pills {\n\tposition: absolute;\n\tz-index: 3;\n\ttop: 79.4%;\n\tleft: 7%;\n\tright: 7%;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tjustify-content: center;\n\tgap: 1.5cqw;\n\n\tspan {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmin-height: 5cqw;\n\t\tpadding: 0 2.1cqw;\n\t\tborder-radius: 999px;\n\t\tborder: 0.16cqw solid rgba(255, 255, 255, 0.22);\n\t\tbackground: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(8, 12, 36, 0.38));\n\t\tbox-shadow: inset 0 0.12cqw 0 rgba(255, 255, 255, 0.14);\n\t\tcolor: rgba(255, 255, 255, 0.92);\n\t\tfont-size: 2.05cqw;\n\t\tfont-weight: 500;\n\t\tletter-spacing: 0.01em;\n\t\twhite-space: nowrap;\n\t}\n}\n\n.hub-pills--single {\n\ttop: 85.2%;\n\tleft: 0;\n\tright: 0;\n}\n\n.hub-foot {\n\tposition: absolute;\n\tz-index: 3;\n\ttop: 93.6%;\n\tleft: 10%;\n\tright: 10%;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\tspan {\n\t\tfont-size: 2.25cqw;\n\t\tfont-weight: 500;\n\t\tcolor: rgba(255, 255, 255, 0.82);\n\t}\n}\n\n@media (prefers-reduced-motion: reduce) {\n\t.hub-core {\n\t\tanimation: none;\n\t}\n}\n\n.login-right {\n\tflex: 1;\n\tbackground-color: #f9fafb;\n\tbackground-image: url('https://www.toptal.com/designers/subtlepatterns/uploads/geometry2.png');\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 2rem;\n\tmax-height: 100vh;\n\toverflow: hidden;\n}\n\n.login-box {\n\tbackground: white;\n\tpadding: 3rem;\n\tborder-radius: 1rem;\n\tbox-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n\twidth: 450px;\n\tmax-width: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1rem;\n\tmax-height: 90vh;\n\toverflow: hidden;\n\n\th2 {\n\t\tfont-size: 1.75rem;\n\t\tcolor: #111827;\n\t\tmargin-bottom: 0.25rem;\n\t\ttext-align: center;\n\t}\n\n\tinput {\n\t\twidth: 100%;\n\t\tpadding: 0.75rem 1rem;\n\t\tborder: 1px solid #e5e7eb;\n\t\tborder-radius: 0.5rem;\n\t}\n}\n\n.subtext {\n\ttext-align: center;\n\tfont-size: 0.9rem;\n\tcolor: #6b7280;\n\tmargin-bottom: 1.5rem;\n}\n\n.google-button {\n\twidth: 100%;\n\tpadding: 0.75rem;\n\tborder: 1px solid #d1d5db;\n\tborder-radius: 0.5rem;\n\tbackground: white;\n\tfont-weight: 500;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 0.5rem;\n\tmargin-bottom: 1rem;\n\tcursor: pointer;\n\n\timg {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n.divider {\n\ttext-align: center;\n\tmargin: 1rem 0;\n\tcolor: #9ca3af;\n\tposition: relative;\n\n\tspan {\n\t\tbackground: white;\n\t\tpadding: 0 0.5rem;\n\t}\n}\n\n.divider::before,\n.divider::after {\n\tcontent: \"\";\n\theight: 1px;\n\tbackground: #e5e7eb;\n\tflex: 1;\n\tmargin: 0 1rem;\n}\n\n.actions {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tfont-size: 0.85rem;\n\tcolor: #6b7280;\n\n\ta {\n\t\tcolor: #2B3991;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n}\n\n.login-submit {\n\twidth: 100%;\n\tpadding: 0.75rem;\n\tbackground: #2B3991;\n\tcolor: white;\n\tborder: none;\n\tborder-radius: 0.5rem;\n\tfont-weight: 600;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground: #ED008C;\n\t}\n}\n\n.signup-link {\n\ttext-align: center;\n\tfont-size: 0.9rem;\n\tmargin-top: 1rem;\n\tcolor: #6b7280;\n\tdisplay: flex;\n\tgap: 0.5rem;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\n\tdiv {\n\t\twidth: 100%;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: center;\n\t}\n\n\tspan {\n\t\tcolor: #2B3991;\n\t\tcursor: pointer;\n\t}\n}\n\n.terms {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.5rem;\n\tfont-size: 0.85rem;\n\tcolor: #6b7280;\n\tmargin-bottom: 1rem;\n\n\tinput[type=\"checkbox\"] {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tmargin: 0;\n\t}\n\n\tlabel {\n\t\tdisplay: inline;\n\t\tcursor: pointer;\n\t}\n\n\ta {\n\t\tcolor: #2B3991;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n}\n\n// Responsive design with scroll prevention\n@media (max-width: 768px) {\n\t.login-page {\n\t\tflex-direction: column;\n\t\tmax-height: none;\n\t\toverflow-x: hidden;\n\t\toverflow-y: auto;\n\t}\n\t\n\t.login-left {\n\t\tflex: none;\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\t\tmin-height: 0;\n\t\tmax-height: none;\n\t\toverflow: hidden;\n\t\talign-items: stretch;\n\t}\n\n\t.hero-frame {\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tmax-height: none;\n\t}\n\t\n\t.login-right {\n\t\tflex: none;\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\t\tpadding: 1.5rem 1rem 2rem;\n\t\tmin-height: auto;\n\t\tmax-height: none;\n\t\toverflow: visible;\n\t}\n\n\t.login-stack,\n\t.login-right .login-card,\n\t.login-box {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t}\n\t\n\t.login-box {\n\t\tpadding: 2rem;\n\t\tmax-height: 100%;\n\t\toverflow: hidden;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.login-box {\n\t\tpadding: 1.5rem;\n\t}\n}\n\n.login-stack {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: min(420px, 100%);\n\tgap: 1.1rem;\n}\n\n.login-right.login-panel {\n\toverflow: auto;\n\tbackground-color: #f5f6fa;\n\tbackground-image:\n\t\tradial-gradient(520px 280px at 80% 0%, rgba(43, 57, 145, 0.07), transparent 70%),\n\t\tlinear-gradient(180deg, #f8f9fc 0%, #eef1f7 100%);\n\tbackground-repeat: no-repeat;\n\tbackground-size: auto;\n\tfont-family: \"Montserrat\", sans-serif;\n}\n\n.login-right .login-card {\n\twidth: min(420px, 100%);\n\tmax-height: none;\n\toverflow: visible;\n\tpadding: 2.4rem 2.15rem 1.85rem;\n\tborder-radius: 20px;\n\tborder: 1px solid rgba(43, 57, 145, 0.06);\n\tbackground: #fff;\n\tbox-shadow: 0 20px 48px rgba(43, 57, 145, 0.1);\n\tgap: 0;\n\ttext-align: center;\n\tfont-family: \"Montserrat\", sans-serif;\n\n\th2 {\n\t\tmargin: 0;\n\t\tfont-family: \"Montserrat\", sans-serif;\n\t\tfont-size: 1.85rem;\n\t\tfont-weight: 600;\n\t\tline-height: 1.15;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: #1c2140;\n\t\ttext-align: center;\n\t}\n\n\tinput {\n\t\twidth: 100%;\n\t\theight: 50px;\n\t\tpadding: 0 1rem;\n\t\tborder: 1px solid transparent;\n\t\tborder-radius: 12px;\n\t\tbackground: #eef3fb;\n\t\tcolor: #1c2140;\n\t\tfont-family: \"Montserrat\", sans-serif;\n\t\tfont-size: 0.9rem;\n\t\tfont-weight: 500;\n\t\ttext-align: left;\n\t\tcursor: text;\n\t\toutline: none;\n\t\ttransition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n\t\t&::placeholder {\n\t\t\tcolor: #8b95ad;\n\t\t\tfont-weight: 400;\n\t\t}\n\n\t\t&:focus {\n\t\t\tbackground: #fff;\n\t\t\tborder-color: #2b3991;\n\t\t\tbox-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);\n\t\t}\n\t}\n}\n\n.login-lead {\n\tmargin: 0.4rem 0 1.4rem;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-size: 0.84rem;\n\tfont-weight: 500;\n\tcolor: #6b7280;\n}\n\n.login-field {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: stretch;\n\tgap: 0.4rem;\n\tmargin-bottom: 0.85rem;\n\ttext-align: left;\n\n\t> span {\n\t\tfont-family: \"Montserrat\", sans-serif;\n\t\tfont-size: 0.68rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.14em;\n\t\ttext-transform: uppercase;\n\t\tcolor: #2b3991;\n\t}\n}\n\n.login-password {\n\tposition: relative;\n\n\tinput {\n\t\tpadding-right: 4.5rem;\n\t}\n}\n\n.login-reveal {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 0.9rem;\n\ttransform: translateY(-50%);\n\tborder: 0;\n\tpadding: 0;\n\tbackground: transparent;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-size: 0.66rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: #2b3991;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #ed008c;\n\t}\n}\n\n.login-right .login-card .actions {\n\tjustify-content: flex-end;\n\tmargin: -0.15rem 0 0.95rem;\n\tfont-family: \"Montserrat\", sans-serif;\n\n\ta {\n\t\tfont-weight: 600;\n\t}\n\n\ta:hover {\n\t\tcolor: #ed008c;\n\t\ttext-decoration: none;\n\t}\n}\n\n.login-right .login-card .login-submit {\n\theight: 48px;\n\tborder-radius: 12px;\n\tbackground: #2b3991;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-size: 0.75rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.16em;\n\ttext-transform: uppercase;\n\tbox-shadow: 0 10px 22px rgba(43, 57, 145, 0.2);\n\n\t&:hover:not(:disabled) {\n\t\tbackground: #ed008c;\n\t}\n\n\t&:disabled {\n\t\topacity: 0.7;\n\t\tcursor: wait;\n\t}\n}\n\n.login-right .login-card .signup-link {\n\tmargin-top: 1.15rem;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-weight: 500;\n\n\tspan {\n\t\tfont-weight: 600;\n\t}\n\n\tspan:hover {\n\t\tcolor: #ed008c;\n\t}\n}\n\n.login-success-overlay {\n\tposition: fixed;\n\tinset: 0;\n\tz-index: 2000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 1.5rem;\n\tbackground: rgba(18, 22, 48, 0.46);\n\tbackdrop-filter: blur(10px);\n}\n\n.login-success-modal {\n\twidth: min(440px, 100%);\n\tpadding: 2.35rem 2.1rem 1.85rem;\n\tborder-radius: 24px;\n\tborder: 1px solid rgba(43, 57, 145, 0.08);\n\tbackground:\n\t\tradial-gradient(280px 140px at 50% 0%, rgba(43, 57, 145, 0.08), transparent 70%),\n\t\t#fff;\n\tbox-shadow: 0 28px 70px rgba(28, 33, 64, 0.28);\n\ttext-align: center;\n\tfont-family: \"Montserrat\", sans-serif;\n\tanimation: loginSuccessIn 0.28s ease;\n\n\th2 {\n\t\tmargin: 0.35rem 0 0.7rem;\n\t\tfont-family: \"Montserrat\", sans-serif;\n\t\tfont-size: 1.55rem;\n\t\tfont-weight: 600;\n\t\tline-height: 1.25;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: #1c2140;\n\t}\n}\n\n@keyframes loginSuccessIn {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(12px) scale(0.98);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: none;\n\t}\n}\n\n.login-success-mark {\n\twidth: 64px;\n\theight: 64px;\n\tmargin: 0 auto 1rem;\n\tdisplay: grid;\n\tplace-items: center;\n\tborder-radius: 50%;\n\tbackground: linear-gradient(145deg, #2b3991 0%, #5b4db8 55%, #ed008c 140%);\n\tcolor: #fff;\n\tbox-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);\n\tfont-size: 1.7rem;\n\n\t&.is-pending {\n\t\tbackground: linear-gradient(145deg, #b45309 0%, #f59e0b 100%);\n\t\tbox-shadow: 0 12px 24px rgba(180, 83, 9, 0.24);\n\t}\n}\n\n.login-success-name {\n\tdisplay: block;\n\tmargin-top: 0.2rem;\n}\n\n.login-success-kicker {\n\tmargin: 0;\n\tfont-size: 0.68rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.16em;\n\ttext-transform: uppercase;\n\tcolor: #2b3991;\n}\n\n.login-success-copy {\n\tmargin: 0 0 1.15rem;\n\tfont-size: 0.9rem;\n\tfont-weight: 500;\n\tline-height: 1.5;\n\tcolor: #6b7280;\n}\n\n.login-success-meta {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 0.45rem;\n\tmargin-bottom: 1.35rem;\n}\n\n.login-success-role {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tmin-height: 32px;\n\tpadding: 0 0.85rem;\n\tborder-radius: 999px;\n\tbackground: rgba(43, 57, 145, 0.08);\n\tcolor: #2b3991;\n\tfont-size: 0.78rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.02em;\n}\n\n.login-success-email {\n\tfont-size: 0.8rem;\n\tfont-weight: 500;\n\tcolor: #8b95ad;\n}\n\n.login-success-setup {\n\tmargin-top: 0.15rem;\n}\n\n.login-success-track {\n\theight: 4px;\n\tborder-radius: 999px;\n\tbackground: rgba(43, 57, 145, 0.1);\n\toverflow: hidden;\n}\n\n.login-success-bar {\n\tdisplay: block;\n\theight: 100%;\n\twidth: 0;\n\tborder-radius: inherit;\n\tbackground: linear-gradient(90deg, #2b3991 0%, #ed008c 100%);\n\tanimation: loginSetupFill 2.6s ease forwards;\n}\n\n.login-success-status {\n\tmargin: 0.75rem 0 0;\n\tfont-size: 0.72rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.14em;\n\ttext-transform: uppercase;\n\tcolor: #2b3991;\n}\n\n@keyframes loginSetupFill {\n\tfrom {\n\t\twidth: 0;\n\t}\n\n\tto {\n\t\twidth: 100%;\n\t}\n}\n\n.login-interest {\n\tborder: 0;\n\tbackground: transparent;\n\tpadding: 0;\n\tfont-family: \"Montserrat\", sans-serif;\n\tfont-size: 0.84rem;\n\tfont-weight: 600;\n\tcolor: #2b3991;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #ed008c;\n\t}\n}\n",".signup-page {\n\tdisplay: flex;\n\tmin-height: 100vh;\n}\n.signup-left {\n\tflex: 1;\n\tbackground: #fff;\n\tpadding: 4rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tcolor: #111827;\n}\n.brand-logo {\n\tfont-size: 2.5rem;\n\tcolor: #2B3991;\n\tmargin-bottom: 2rem;\n\tletter-spacing: 1px;\n}\n.feature {\n\th4 {\n\t\tmargin: 1rem 0 0.5rem;\n\t\tcolor: #111827;\n\t}\n\tp {\n\t\tcolor: #6b7280;\n\t\tfont-size: 0.95rem;\n\t}\n}\n.footer-links {\n\tmargin-top: auto;\n\tdisplay: flex;\n\tgap: 1rem;\n\tfont-size: 0.9rem;\n\tcolor: #6b7280;\n\ta {\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n}\n.signup-right {\n\tflex: 1;\n\tbackground: #f9fafb  no-repeat center center;\n\tbackground-size: cover;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 2rem;\n}\n.signup-box {\n\tbackground: white;\n\tpadding: 3rem;\n\tborder-radius: 1rem;\n\tbox-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n\twidth: 100%;\n\tmax-width: 400px;\n\th2 {\n\t\tfont-size: 1.75rem;\n\t\tcolor: #111827;\n\t\tmargin-bottom: 0.25rem;\n\t\ttext-align: center;\n\t}\n\tlabel {\n\t\tfont-size: 0.9rem;\n\t\tmargin-top: 1rem;\n\t\tcolor: #374151;\n\t}\n}\n.subtext {\n\ttext-align: center;\n\tfont-size: 0.9rem;\n\tcolor: #6b7280;\n\tmargin-bottom: 1.5rem;\n}\n.signup-box input[type=\"text\"],\n.signup-box input[type=\"email\"],\n.signup-box input[type=\"password\"] {\n\twidth: 100%;\n\tpadding: 0.75rem 1rem;\n\tborder: 1px solid #e5e7eb;\n\tborder-radius: 0.5rem;\n\tmargin-top: 0.25rem;\n}\n.terms {\n\tmargin-top: 1rem;\n\tdisplay: flex;\n\tgap: 0.5rem;\n\tfont-size: 0.85rem;\n\tcolor: #6b7280;\n\ta {\n\t\tcolor: #2B3991;\n\t\ttext-decoration: underline;\n\t}\n}\n.signup-submit {\n\twidth: 100%;\n\tmargin-top: 1.5rem;\n\tpadding: 0.75rem;\n\tbackground: #111827;\n\tcolor: white;\n\tborder: none;\n\tborder-radius: 0.5rem;\n\tfont-weight: 600;\n\tcursor: pointer;\n\t&:hover {\n\t\tbackground: #000000;\n\t}\n}\n.signin-link {\n\ttext-align: center;\n\tfont-size: 0.9rem;\n\tmargin-top: 1rem;\n\tcolor: #6b7280;\n\tspan {\n\t\tcolor: #2B3991;\n\t\tcursor: pointer;\n\t\ttext-decoration: underline;\n\t}\n}\n","//top header css\n.top-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: #ffffff;\n\n  .logo {\n    height: 40px;\n\n    img {\n      height: 40px;\n      width: 60px;\n    }\n  }\n\n  .user_info {\n    position: absolute;\n    right: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n\n    .user_name {\n      font-weight: bold;\n    }\n\n    button {\n      font-size: 0.875rem;\n    }\n  }\n}\n\n.header_container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.25rem 1rem;\n  position: relative;\n  min-height: 48px;\n  background-color: transparent;\n  border-bottom: none;\n\n  i {\n    display: block;\n    cursor: pointer;\n\n    &::before {\n      font-size: 1rem;\n    }\n  }\n\n  // Compact dropdown styling\n  .simple-dropdown {\n    position: relative;\n\n    .location-dropdown-trigger,\n    .simple-dropdown-trigger,\n    .user-profile-trigger {\n      border-radius: 4px;\n      transition: all 0.2s ease;\n      min-height: 28px;\n      display: flex;\n      align-items: center;\n      padding: 2px 6px;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.04);\n      }\n\n      &:active {\n        background-color: rgba(0, 0, 0, 0.08);\n      }\n    }\n\n    // User profile specific styling - more compact\n    .user-profile-trigger {\n      .user-avatar {\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .user-details {\n        .user-name {\n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n          letter-spacing: 0.02em;\n        }\n\n        .user-role {\n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n          letter-spacing: 0.02em;\n        }\n      }\n    }\n\n    // Facility dropdown menu styling - compact\n    .facility-dropdown-menu {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      z-index: 1050;\n      min-width: 180px;\n      max-width: 250px;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      background-color: white;\n      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);\n      padding: 6px 0;\n      margin-top: 2px;\n\n      .facility-dropdown-item {\n        display: flex;\n        align-items: center;\n        padding: 8px 12px;\n        cursor: pointer;\n        transition: background-color 0.15s ease;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        &.active {\n          background-color: #e3f2fd;\n\n          .facility-name {\n            color: #1565c0;\n            font-weight: 600;\n          }\n        }\n\n        .facility-icon {\n          width: 20px;\n          height: 20px;\n          border-radius: 50%;\n          background-color: #e3f2fd;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-right: 10px;\n          flex-shrink: 0;\n\n          i {\n            font-size: 10px;\n            color: #1976d2;\n          }\n        }\n\n        .facility-content {\n          flex: 1;\n          min-width: 0;\n\n          .facility-name {\n            font-size: 0.8rem;\n            font-weight: 500;\n            color: #212529;\n            margin-bottom: 1px;\n            line-height: 1.1;\n          }\n\n          .facility-type {\n            font-size: 0.7rem;\n            color: #6c757d;\n            line-height: 1.1;\n          }\n        }\n\n        .bi-check {\n          font-size: 14px;\n          margin-left: 6px;\n        }\n      }\n    }\n\n    // Regular dropdown menu - compact\n    .dropdown-menu {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      z-index: 1050;\n      min-width: 160px;\n      border: 1px solid #dee2e6;\n      box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.15);\n      border-radius: 0.3rem;\n      padding: 0.4rem 0;\n      background-color: white;\n      margin-top: 2px;\n    }\n\n    .dropdown-item {\n      padding: 0.4rem 0.8rem;\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n      border: none;\n      background: none;\n      width: 100%;\n      text-align: left;\n      color: #212529;\n      font-size: 0.8rem;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n\n      &.active {\n        background-color: #e3f2fd;\n        color: #1976d2;\n      }\n    }\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n  }\n}\n\n.header-notifications {\n  position: relative;\n\n  &__btn {\n    position: relative;\n    width: 34px;\n    height: 34px;\n    border: 0;\n    border-radius: 8px;\n    background: #e4eef7;\n    color: #1e71bb;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    i {\n      font-size: 16px;\n      line-height: 1;\n    }\n\n    &:hover,\n    &.is-open {\n      background: #d5e6f5;\n    }\n  }\n\n  &__badge {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    min-width: 16px;\n    height: 16px;\n    padding: 0 4px;\n    border-radius: 999px;\n    background: #dc3545;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: center;\n  }\n\n  &__panel {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    z-index: 1060;\n    width: 360px;\n    max-width: min(360px, 80vw);\n    background: #fff;\n    border: 1px solid #e6eaf2;\n    border-radius: 12px;\n    box-shadow: 0 12px 32px rgba(16, 24, 40, 0.16);\n    overflow: hidden;\n  }\n\n  &__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 14px;\n    border-bottom: 1px solid #eef1f6;\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: #1c2468;\n  }\n\n  &__mark {\n    border: 0;\n    background: transparent;\n    color: #1e71bb;\n    font-size: 0.75rem;\n    font-weight: 600;\n    padding: 0;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 6px;\n    max-height: 380px;\n    overflow: auto;\n  }\n\n  &__item {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    text-align: left;\n    border: 0;\n    background: transparent;\n    border-radius: 10px;\n    padding: 10px;\n    position: relative;\n\n    &:hover {\n      background: #f6f8fc;\n    }\n\n    &.is-unread {\n      background: #f3f7fd;\n    }\n  }\n\n  &__icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: #e4eef7;\n    color: #1e71bb;\n\n    i {\n      font-size: 15px;\n    }\n\n    &--po {\n      background: #e8eefc;\n      color: #2b3991;\n    }\n\n    &--asn {\n      background: #e7f6ee;\n      color: #1b7a45;\n    }\n\n    &--sales {\n      background: #fff4e5;\n      color: #b86e00;\n    }\n\n    &--shipment {\n      background: #e4eef7;\n      color: #1e71bb;\n    }\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    padding-right: 10px;\n  }\n\n  &__title {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: #212529;\n  }\n\n  &__text {\n    font-size: 0.75rem;\n    color: #5c6778;\n    margin-top: 2px;\n  }\n\n  &__time {\n    font-size: 0.7rem;\n    color: #8b95a5;\n    margin-top: 4px;\n  }\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #1e71bb;\n    position: absolute;\n    top: 14px;\n    right: 10px;\n  }\n}",".dropdown_wrapper {\n    position: relative;\n    display: inline-block;\n    min-width: 70px;\n\n    .dropdown_label {\n        border: none;\n        background: $fc-white;\n        font-size: 0.875rem !important;\n        font-family: $fc-font;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 0.5rem;\n        padding: 0.5rem;\n        border-radius: 0.25rem;\n        cursor: pointer;\n        transition: border 0.2s, box-shadow 0.2s;\n        color: $fc-black;\n\n        &:hover,\n        &:focus {\n            outline: none;\n        }\n\n        i {\n            height: 1rem;\n            display: flex;\n            align-items: center;\n\n            &::before {\n                font-size: 12px;\n            }\n        }\n    }\n\n    .dropdown_list {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: max-content;\n        background: $fc-white;\n        border-radius: 0.25rem;\n        z-index: 1000;\n        padding: 0.5rem 0 0;\n        margin: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n        min-width: 180px;\n\n        .dropdown_item {\n            list-style: none;\n            padding: 0.5rem;\n            cursor: pointer;\n            border-radius: 0.2rem;\n            font-size: 0.75rem;\n            transition: background 0.15s;\n            color: $fc-black;\n\n            &:hover,\n            &:focus {\n                background: #f5f5f5;\n                // color: $fc-blue;\n            }\n        }\n    }\n\n    &.dropdown-menu-left {\n        .dropdown_list {\n            top: 110%;\n            left: 0;\n        }\n    }\n\n    &.dropdown-menu-right {\n        .dropdown_list {\n            left: 65% !important;\n            top: 105% !important;\n        }\n    }\n}\n\n.select_container {\n    .form-select {\n        &:focus {\n            box-shadow: none;\n            outline: none;\n            border: 1px solid $fc-black;\n        }\n\n        option {\n            background-color: white;\n            color: black;\n\n            &:hover {\n                background-color: $fc-black;\n                color: $fc-white;\n            }\n        }\n    }\n}","$fc-font: \"Montserrat\";\n$fc-white: #fff;\n$fc-black: #222;\n$fc-gray: #cccccc;\n$fc-blue-box-shadow: 0 0px 0px rgb(9 9 9 / 30%), 0 0px 4px rgb(29 29 29 / 20%);\n$fc-green: #008000;\n$fc-red: #ff0000;\n$lable-font : 12px;\n$header-font : 13px;\n\n",".tab-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 225px);\n  height: 100%;\n  overflow: hidden;\n  transition: width 0.2s;\n}\n\n.sidebar-collapsed+.tab-wrapper {\n  width: calc(100% - 56px);\n}\n\n.tab-bar {\n  display: flex;\n  background: #f8f8f8;\n  border-bottom: 1px solid #c1c1c1;\n  overflow-x: auto;\n  white-space: nowrap;\n  height: auto;\n  overflow-y: hidden;\n}\n\n.tab-bar::-webkit-scrollbar {\n  height: 4px; // Thin horizontal scrollbar for Chrome/Safari/Edge\n}\n\n.tab-bar::-webkit-scrollbar-thumb {\n  background: #000; // Black color for Chrome/Safari/Edge\n  border-radius: 2px;\n}\n\n.tab {\n  padding: 8px 12px;\n  cursor: pointer;\n  position: relative;\n  /* background: #e0e0e0; */\n  /* margin-right: 2px; */\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  display: flex;\n  align-items: center;\n  min-width: 100px;\n  /* max-width: 200px; */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.tab-icon-badge {\n  width: 28px;\n  height: 28px;\n  margin-right: 8px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #e4eef7;\n  color: #1e71bb;\n}\n\n.tab-icon {\n  margin-right: 0;\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n  color: #1e71bb;\n}\n\n.tab-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1 1 auto;\n}\n\n.tab.active {\n  background: #fff;\n  border-bottom: 2px solid #2B3991;\n}\n\n.close-btn {\n  margin-left: 5px;\n  color: #888;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.add-btn {\n  margin-left: 8px;\n  padding: 0 10px;\n  font-size: 18px;\n  cursor: pointer;\n  background: #e0e0e0;\n  border: none;\n  border-radius: 50%;\n  height: 28px;\n  display: flex;\n  align-items: center;\n}\n\n.tab-content {\n  flex: 1;\n  padding: 5px;\n  background: #fff;\n  overflow-x: hidden;\n  height: 100%;\n\n  // max-height: max-content;\n  .card {\n    height: calc(100% - 10px);\n  }\n\n}\n\n/* Inactive panes stay mounted (so tab state is kept) but hidden.\n   The active pane fades and eases in instead of snapping open. */\n.tab-pane-view {\n  display: none;\n}\n\n.tab-pane-view.is-active {\n  display: block;\n  animation: tabPaneIn 0.32s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes tabPaneIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tab-pane-view.is-active {\n    animation: none;\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .tab-bar {\n    font-size: 14px;\n    padding: 0 4px;\n    height: 30px;\n  }\n\n  .tab-bar::-webkit-scrollbar {\n    height: 3px;\n  }\n\n  .tab {\n    padding: 2px 8px;\n    min-width: 80px;\n    max-width: 120px;\n    font-size: 13px;\n    height: 22px;\n  }\n\n  .add-btn {\n    height: 22px;\n  }\n\n  .tab-content {\n    padding: 8px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tab-bar {\n    font-size: 12px;\n    padding: 0 2px;\n    height: 26px;\n  }\n\n  .tab-bar::-webkit-scrollbar {\n    height: 2px;\n  }\n\n  .tab {\n    padding: 1px 6px;\n    min-width: 60px;\n    max-width: 90px;\n    font-size: 12px;\n    height: 18px;\n  }\n\n  .add-btn {\n    height: 18px;\n  }\n\n  .tab-content {\n    padding: 4px;\n    font-size: 13px;\n  }\n}",".ag-root-wrapper {\n    font-weight: 400;\n    .ag-root-wrapper-body {\n        .ag-root {\n            .ag-header {\n                background-color: $fc-black;\n                color: $fc-white;\n\n                .ag-header-viewport {\n                    .ag-header-container {\n                        .ag-header-row {\n                            .ag-header-cell {\n                                padding: 0;\n                                font-size: $header-font;\n                                .ag-header-cell-resize {\n                                    &::after {\n                                        background-color: $fc-white;\n                                    }\n                                }\n                                .ag-header-cell-comp-wrapper {\n                                    .ag-cell-label-container {\n                                        .ag-header-cell-label {\n                                            .ag-header-cell-text {\n                                                padding: 0 0.5rem;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                }\n            }\n\n            .ag-body {\n                .ag-body-viewport {\n                    .ag-viewport {\n                        .ag-center-cols-container {\n                            height: 100% !important;\n                            .ag-row {\n                                border-bottom: 1px solid rgb(243, 243, 243);\n                                height: 40px !important;\n                                .ag-cell {\n                                    border: 0px !important;\n                                    font-size: $lable-font;\n                                }\n                                &.ag-row-hover {\n                                    &:not(.ag-full-width-row):before {\n                                        background-color: $fc-gray;\n                                    }\n                                }\n                                &:last-child {\n                                    border-bottom: none !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.row-deactivated {\n  color: #888 !important;\n  opacity: 0.7;\n}\n\n.ag-header-cell.ag-column-last,\n.ag-cell.ag-column-last {\n  border-right: none !important;\n}\n\n/* Hide resize handle for last column */\n.ag-column-last .ag-header-cell-resize {\n  display: none !important;\n}\n\n.MuiDataGrid-columnHeader {\n    background-color: #f7f9fc !important;\n}\n\n.MuiDataGrid-columnSeparator--sideRight {\n    right: -5px;\n    color: #e2e8f0 !important;\n}\n\n\n// .MuiDataGrid-columnSeparator.MuiDataGrid-columnSeparator--resizable.MuiDataGrid-columnSeparator--sideRight{\n\n// }\n\n.MuiDataGrid-scrollbarFiller {\n    background-color: #f7f9fc !important;\n}\n\n.MuiDataGrid-filler{\n     background-color: #f7f9fc !important;\n}\n\n.MuiDataGrid-virtualScroller {\n  scroll-behavior: smooth !important; \n}\n\n.MuiDataGrid-virtualScrollerContent {\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.userTableRole{\n    align-items: center;\n    padding-bottom: 10px;\n}\n\n/* —— Admin tenant lists (pending approval + tenants) —— */\n.admin-tenant-card {\n    border: none;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 12px 40px rgba(43, 57, 145, 0.12) !important;\n\n    .admin-tenant-card__header {\n        background: var(--sidebar-gradient) !important;\n        padding: 1.1rem 1.35rem;\n    }\n\n    .card-body {\n        padding: 1.35rem;\n        background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 140px);\n    }\n}\n\n.admin-tenant-grid-wrap {\n    border-radius: 14px;\n    overflow: hidden;\n    border: 1px solid rgba(43, 57, 145, 0.1);\n    box-shadow: 0 4px 24px rgba(30, 113, 187, 0.07);\n    background: #fff;\n\n    .ag-root-wrapper {\n        --ag-header-height: 46px;\n        --ag-row-hover-color: rgba(43, 57, 145, 0.07);\n        --ag-odd-row-background-color: rgba(248, 250, 252, 0.95);\n        --ag-border-color: rgba(0, 0, 0, 0.06);\n        font-size: 0.875rem;\n    }\n\n    .ag-header {\n        background: var(--sidebar-gradient) !important;\n        color: #fff !important;\n    }\n\n    .ag-header-cell,\n    .ag-header-cell .ag-header-cell-text {\n        color: #fff !important;\n        font-weight: 600;\n        letter-spacing: 0.02em;\n    }\n\n    .ag-icon {\n        color: #fff !important;\n        opacity: 0.9;\n    }\n\n    .ag-row {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;\n    }\n\n    .ag-cell {\n        padding-top: 10px !important;\n        padding-bottom: 10px !important;\n        line-height: 1.45;\n    }\n\n    .ag-row-hover:not(.ag-full-width-row)::before {\n        background-color: rgba(43, 57, 145, 0.06) !important;\n    }\n}\n\n.admin-tenant-grid-empty {\n    border-radius: 12px;\n    border: 1px dashed rgba(43, 57, 145, 0.2);\n    background: rgba(248, 250, 252, 0.6);\n}\n\n/* Row action control (admin grids) */\n.admin-grid-action-icon {\n    cursor: pointer;\n    font-size: 1.1rem !important;\n    color: #2b3991 !important;\n    padding: 0.4rem 0.5rem;\n    border-radius: 10px;\n    transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n\n    &:hover {\n        background: rgba(43, 57, 145, 0.12);\n        color: #1e71bb !important;\n    }\n\n    &:focus-visible {\n        outline: 2px solid rgba(30, 113, 187, 0.5);\n        outline-offset: 2px;\n    }\n}\n\n.admin-user-type-badge {\n    background: rgba(255, 255, 255, 0.95) !important;\n    border-color: rgba(43, 57, 145, 0.18) !important;\n    color: #1a1d2e !important;\n    font-weight: 600 !important;\n}",".footer {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: 2rem;\n    background-color: #e0e0e0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    color: $fc-black;\n\n    p {\n        margin: 0;\n        padding: 0.5rem;\n    }\n}",".password_container {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: $fc-white;\n    .card {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        background: #222;\n        color: #fff;\n        padding: 2rem 2.5rem;\n        border-radius: 12px;\n        width: 100%;\n        max-width: 400px;\n        h3 {\n            color: #fff;\n        }\n        form {\n            .form-label {\n                color: #ccc;\n            }\n            input {\n                width: 100%;\n                background: #111;\n                color: #fff;\n                border: 1px solid #444;\n                &:focus {\n                    border-color: #fff;\n                    outline: none;\n                    box-shadow: none;\n                }\n            }\n            .btn {\n                width: 100%;\n                background: #fff;\n                color: #111;\n                font-weight: bold;\n                border: none;\n            }\n        }\n    }\n}","// Self-signup / onboarding stepper — palette: primary #2563eb, secondary #1e293b, bg #f8fafc\n\n.onboarding-shell {\n    --onboarding-primary: #2563eb;\n    --onboarding-primary-hover: #1d4ed8;\n    --onboarding-primary-active: #1e40af;\n    --onboarding-secondary: #1e293b;\n    --onboarding-bg: #f8fafc;\n    --onboarding-muted: #64748b;\n    --onboarding-border: #e2e8f0;\n    --onboarding-card-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n\n    min-height: 100vh;\n    width: 100%;\n    background: var(--onboarding-bg);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1.5rem 1rem 3rem;\n    gap: 1.75rem;\n}\n\n.onboarding-layout__main {\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n    max-width: 960px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.75rem;\n}\n\n.onboarding-stepper-wrap {\n    width: 100%;\n    max-width: 960px;\n    overflow-x: auto;\n    overflow-y: visible;\n    padding: 0.5rem 0 0.25rem;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n        height: 6px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background: var(--onboarding-border);\n        border-radius: 3px;\n    }\n}\n\n.onboarding-stepper__row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    min-width: min(100%, 680px);\n    margin: 0 auto;\n    gap: 0;\n}\n\n.onboarding-step-segment {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex: 1 1 0;\n    min-width: 0;\n    max-width: 120px;\n}\n\n.onboarding-step-node {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    border: 2px solid var(--onboarding-border);\n    background: #fff;\n    color: var(--onboarding-muted);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    cursor: pointer;\n    transition:\n        background 0.25s ease,\n        border-color 0.25s ease,\n        color 0.25s ease,\n        transform 0.2s ease,\n        box-shadow 0.25s ease;\n\n    &:hover:not(:disabled) {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n    }\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.55;\n    }\n\n    &--current {\n        background: var(--onboarding-primary);\n        border-color: var(--onboarding-primary);\n        color: #fff;\n        box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);\n    }\n\n    &--complete {\n        background: var(--onboarding-primary);\n        border-color: var(--onboarding-primary);\n        color: #fff;\n    }\n\n    &--upcoming {\n        background: #fff;\n        color: var(--onboarding-muted);\n    }\n}\n\n.onboarding-step-node__inner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 0;\n}\n\n.onboarding-step-icon,\n.onboarding-step-check {\n    font-size: 1.25rem !important;\n}\n\n.onboarding-step-fallback {\n    font-size: 0.875rem;\n    font-weight: 700;\n}\n\n.onboarding-step-label {\n    margin-top: 0.5rem;\n    font-size: 0.7rem;\n    font-weight: 500;\n    color: var(--onboarding-muted);\n    text-align: center;\n    line-height: 1.2;\n    transition: color 0.25s ease;\n\n    @media (min-width: 576px) {\n        font-size: 0.75rem;\n    }\n\n    &--current {\n        color: var(--onboarding-primary);\n        font-weight: 600;\n    }\n}\n\n.onboarding-step-connector {\n    flex: 1 1 8px;\n    min-width: 4px;\n    height: 3px;\n    /* Align bar with vertical center of 44px step node */\n    margin-top: 20px;\n    background: var(--onboarding-border);\n    border-radius: 2px;\n    transition: background 0.35s ease;\n\n    &--active {\n        background: linear-gradient(90deg, var(--onboarding-primary), #60a5fa);\n    }\n}\n\n.onboarding-card {\n    width: min(100%, 560px);\n    align-self: center;\n    max-width: 560px;\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: var(--onboarding-card-shadow);\n    padding: 1.75rem 1.5rem 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    border: 1px solid rgba(226, 232, 240, 0.9);\n\n    @media (min-width: 768px) {\n        padding: 2rem 2.25rem 1.75rem;\n    }\n}\n\n.onboarding-back-link {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: var(--onboarding-primary);\n    text-decoration: none;\n    transition: color 0.2s ease;\n    align-self: center;\n    white-space: nowrap;\n\n    &:hover {\n        color: var(--onboarding-primary-hover);\n        text-decoration: underline;\n    }\n}\n\n.onboarding-step-panel {\n    animation: onboarding-step-in 0.4s ease;\n\n    .card_content {\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n\n        .onboarding-welcome-hero {\n            text-align: center;\n            margin-bottom: 0.25rem;\n\n            .onboarding-welcome-brand {\n                display: flex;\n                justify-content: center;\n                margin-bottom: 1.25rem;\n\n                img {\n                    height: 80px;\n                    width: auto;\n                    max-width: min(280px, 85vw);\n                    display: block;\n                    object-fit: contain;\n                }\n            }\n\n            .onboarding-page-subtitle {\n                margin-top: 0.5rem;\n            }\n        }\n\n        h4,\n        .onboarding-page-title {\n            margin: 0;\n            font-size: 1.375rem;\n            font-weight: 700;\n            color: var(--onboarding-secondary);\n            line-height: 1.3;\n            letter-spacing: -0.02em;\n\n            @media (min-width: 576px) {\n                font-size: 1.5rem;\n            }\n        }\n\n        p,\n        .onboarding-page-subtitle {\n            margin: 0;\n            font-size: 0.9375rem;\n            color: var(--onboarding-muted);\n            line-height: 1.55;\n        }\n\n        .select_container {\n            width: 100%;\n        }\n\n        .select-input {\n            width: 100%;\n        }\n\n        .form-label {\n            color: var(--onboarding-secondary);\n            margin-bottom: 0.35rem;\n        }\n\n        .form-select,\n        .form-control {\n            border-radius: 10px;\n            border: 1px solid var(--onboarding-border);\n            padding: 0.55rem 0.85rem;\n            transition:\n                border-color 0.2s ease,\n                box-shadow 0.2s ease;\n\n            &:hover:not(:disabled) {\n                border-color: #cbd5e1;\n            }\n\n            &:focus {\n                border-color: var(--onboarding-primary);\n                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n                outline: none;\n            }\n        }\n\n        .input {\n            width: 100%;\n        }\n\n        .card_container {\n            width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            gap: 1rem;\n\n            .input,\n            .select-input {\n                width: 100%;\n                min-width: 200px;\n\n                @media (min-width: 576px) {\n                    width: calc(50% - 0.5rem);\n                }\n            }\n\n            .onboarding-system-toggle {\n                .form-check.form-switch {\n                    display: flex;\n                    align-items: center;\n                    gap: 0.65rem;\n                    min-height: 46px;\n                    margin: 0;\n                    padding: 0.55rem 0.85rem;\n                    border: 1px solid var(--onboarding-border);\n                    border-radius: 10px;\n                    background: #fff;\n                }\n\n                .form-check-input {\n                    width: 2.5rem;\n                    height: 1.3rem;\n                    margin: 0;\n                    float: none;\n                    cursor: pointer;\n                }\n\n                .form-check-label {\n                    margin: 0;\n                    font-weight: 600;\n                    color: var(--onboarding-secondary);\n                }\n\n                .form-check-input:checked {\n                    background-color: var(--onboarding-primary);\n                    border-color: var(--onboarding-primary);\n                }\n\n                .form-check-input:focus {\n                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n                    border-color: var(--onboarding-primary);\n                }\n            }\n\n            .onboarding-admin-toggle {\n                width: 100%;\n                padding-top: 0.15rem;\n\n                .form-check {\n                    display: flex;\n                    align-items: center;\n                    gap: 0.55rem;\n                    margin: 0;\n                    min-height: 46px;\n                    padding: 0.55rem 0.85rem;\n                    border: 1px solid var(--onboarding-border);\n                    border-radius: 10px;\n                    background: #fff;\n                }\n\n                .form-check-input {\n                    margin: 0;\n                    float: none;\n                }\n\n                .form-check-label {\n                    margin: 0;\n                    color: var(--onboarding-secondary);\n                    font-weight: 600;\n                }\n\n                .form-check-input:checked {\n                    background-color: var(--onboarding-primary);\n                    border-color: var(--onboarding-primary);\n                }\n            }\n        }\n    }\n}\n\n@keyframes onboarding-step-in {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .onboarding-step-panel {\n        animation: none;\n    }\n\n    .onboarding-step-node,\n    .onboarding-step-connector,\n    .onboarding-btn {\n        transition: none;\n    }\n}\n\n.onboarding-actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem 1rem;\n    border-top: 1px solid var(--onboarding-border);\n    margin-top: 0.25rem;\n    padding-top: 1.25rem;\n}\n\n.onboarding-actions__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-left: auto;\n}\n\n.onboarding-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: inherit;\n    line-height: 1.25;\n    font-weight: 600;\n    font-size: 0.9375rem;\n    padding: 0.55rem 1.35rem;\n    border-radius: 10px;\n    min-width: 6rem;\n    transition:\n        background 0.2s ease,\n        color 0.2s ease,\n        border-color 0.2s ease,\n        box-shadow 0.2s ease,\n        transform 0.15s ease,\n        opacity 0.2s ease;\n\n    &--primary {\n        background: linear-gradient(180deg, #3b82f6 0%, var(--onboarding-primary) 100%);\n        border: none;\n        color: #fff;\n        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);\n\n        &:hover:not(:disabled) {\n            background: linear-gradient(180deg, #2563eb 0%, var(--onboarding-primary-hover) 100%);\n            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.4);\n            transform: translateY(-1px);\n            color: #fff;\n        }\n\n        &:active:not(:disabled) {\n            transform: translateY(0);\n            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);\n            background: var(--onboarding-primary-active);\n        }\n\n        &:disabled {\n            opacity: 0.45;\n            cursor: not-allowed;\n            box-shadow: none;\n            transform: none;\n        }\n    }\n\n    &--secondary {\n        background: #fff;\n        border: 1px solid var(--onboarding-border);\n        color: var(--onboarding-secondary);\n\n        &:hover:not(:disabled) {\n            background: #f1f5f9;\n            border-color: #cbd5e1;\n        }\n    }\n\n    &--ghost {\n        background: transparent;\n        border: 1px solid transparent;\n        color: var(--onboarding-muted);\n\n        &:hover:not(:disabled) {\n            color: var(--onboarding-secondary);\n            background: #f1f5f9;\n        }\n    }\n}\n\n",".form-check-input {\n    cursor: pointer;\n    &:checked {\n        background-color: $fc-black;\n        color: $fc-white;\n        border-color: $fc-black;\n    }\n    &:focus {\n        box-shadow: none;\n        border-color: $fc-black;\n    }\n}\n\n.checkbox_group {\n    .label {\n        font-weight: 600;\n        margin-bottom: 1rem;\n    }\n}",".card-header.bg-secondary {\n    background: #fff !important;\n    color: #0f172a !important;\n    border-bottom: 1px solid #eef2f7;\n    padding: 12px 16px;\n\n    h4,\n    h5,\n    h6,\n    .h6 {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin: 0;\n        font-size: 15px;\n        font-weight: 600;\n        letter-spacing: -0.01em;\n        color: #0f172a;\n\n        &::before {\n            content: \"\";\n            width: 4px;\n            height: 18px;\n            border-radius: 999px;\n            background: var(--button-gradient, linear-gradient(to bottom, #2b3991, #1e71bb));\n        }\n    }\n}\n\n.inventory-module-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    list-style: none;\n    padding: 0;\n    margin: 0 0 14px;\n\n    button {\n        border: 1px solid #d7dee8;\n        background: #fff;\n        color: #1e293b;\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 1.2;\n        padding: 8px 14px;\n        border-radius: 6px;\n\n        &.active {\n            background: #1e71bb;\n            border-color: #1e71bb;\n            color: #fff;\n        }\n    }\n}\n\n.card-body {\n    overflow-x: overlay;\n\n    .table-navbar {\n        button {\n            font-size: 12px;\n        }\n\n        .button-group {\n            .btn {\n                font-size: 12px;\n            }\n        }\n    }\n\n    .MuiBox-root {\n        gap: 10px;\n    }\n\n    .MuiButton-containedPrimary {\n        background: #2B3991;\n        box-shadow: none;\n        text-transform: capitalize;\n        font-family: \"Montserrat\" !important;\n        font-size: 12px;\n        padding: 6px 16px;\n        border-radius: 6px;\n\n        &:hover {\n            background: #ED008C;\n            outline: none;\n        }\n    }\n\n    .MuiButton-outlined {\n        text-transform: capitalize;\n        font-family: \"Montserrat\" !important;\n        color: #2B3991;\n        border-color: #2B3991;\n        font-size: 12px;\n        padding: 6px 16px;\n        border-radius: 6px;\n    }\n}\n\n.MuiDataGrid-root {\n    * {\n        font-family: \"Montserrat\" !important;\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n}\n\n.table-navbar .add-button {\n    background: #2B3991;\n    box-shadow: none;\n    text-transform: capitalize;\n    font-family: \"Montserrat\" !important;\n    color: white !important;\n\n    &:hover {\n        background: #ED008C;\n        outline: none;\n    }\n}\n\n\n.roleModule {\n    padding: 10px;\n}\n\n.noGap {\n    .gap-3 {\n        gap: 0 !important;\n    }\n}\n\n.default-role-row {\n  background-color: #f5f5f5 !important; /* light gray */\n}",".context-menu {\n  position: fixed;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  padding: 0;\n  margin: 0;\n  z-index: 9999;\n  list-style: none;\n  min-width: 85px;\n}\n",".temp-user-details {\n  max-width: 800px;\n  margin: 0 auto;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n  overflow: auto;\n  max-height: 475px;\n}\n\n.custom-accordion .accordion-item {\n  border: none;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n}\n\n.custom-accordion .accordion-header {\n  background: #f8f9fa;\n  button{\n        padding-left: 10px;\n        padding-right: 0px;\n  }\n}\n\n.custom-accordion .accordion-button {\n  font-weight: 600;\n  font-size: 1.1rem;\n  background: #f8f9fa;\n  color: #333;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  transition: background 0.2s;\n  position: relative;\n  /* padding-right: 2.5rem; */\n}\n\n.custom-accordion .accordion-button::after {\n  content: '';\n  display: inline-block;\n  width: 1.1em;\n  height: 1.1em;\n  background: url('data:image/svg+xml;utf8,<svg fill=\"%23333\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M1.5 6l6 6 6-6\" stroke=\"%23333\" stroke-width=\"2\" fill=\"none\"/></svg>') no-repeat center center;\n  background-size: 1.1em 1.1em;\n  position: absolute;\n  right: 1.2rem;\n  top: 50%;\n  transform: translateY(-50%) rotate(0deg);\n  transition: transform 0.3s;\n}\n\n.custom-accordion .accordion-button:not(.collapsed) {\n  background: #e9ecef;\n  color: #007bff;\n}\n\n.custom-accordion .accordion-button:not(.collapsed)::after {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.custom-accordion .accordion-body {\n  background: #fff;\n  padding: 1.5rem;\n}\n\n.contact-item {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 12px;\n  padding: 1.15rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid rgba(43, 57, 145, 0.08);\n  box-shadow: 0 2px 12px rgba(30, 113, 187, 0.05);\n}\n\n.tenants-manage-panel {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 0.25rem 0 1rem;\n\n  .tenants-manage-panel__title {\n    letter-spacing: -0.02em;\n    color: #1a1d2e;\n  }\n}\n\n.tenants-manage-accordion.custom-accordion .accordion-item {\n  border: 1px solid rgba(43, 57, 145, 0.1);\n  box-shadow: 0 4px 20px rgba(30, 113, 187, 0.06);\n}\n\n.tenants-manage-accordion.custom-accordion .accordion-button:not(.collapsed) {\n  background: linear-gradient(90deg, rgba(43, 57, 145, 0.08) 0%, rgba(30, 113, 187, 0.06) 100%);\n  color: #2b3991;\n}\n\n.section-review-box {\n  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%) !important;\n  box-shadow: 0 4px 20px rgba(43, 57, 145, 0.08);\n  border: 1px solid rgba(43, 57, 145, 0.1) !important;\n}\n\n.black-white-theme {\n  background: #fff !important;\n  color: #111 !important;\n}\n\n.black-white-theme .custom-accordion .accordion-item {\n  background: #f8f9fa;\n  color: #111;\n  border: 1px solid #e0e0e0;\n}\n\n.black-white-theme .custom-accordion .accordion-header,\n.black-white-theme .custom-accordion .accordion-button {\n  background: #f5f5f5;\n  color: #111;\n  border: none;\n}\n\n.black-white-theme .custom-accordion .accordion-button:not(.collapsed) {\n  background: #e9ecef;\n  color: #111;\n}\n\n.black-white-theme .custom-accordion .accordion-body {\n  background: #fff;\n  color: #111;\n}\n\n.form-label{\n  // min-height: 35px;\n  align-content: end;\n      font-size: 12px;\n}\nselect.form-control {\n  -webkit-appearance: auto !important;\n  -moz-appearance: auto !important;\n  appearance: auto !important;\n}\ninput[readonly], .form-control[readonly] {\n  background: #f5f5f5 !important;\n  color: #888 !important;\n  /* border: 1px solid #e0e0e0 !important; */\n}\n\n@media (max-width: 600px) {\n  .temp-user-details {\n    padding: 0.5rem !important;\n  }\n  .custom-accordion .accordion-body {\n    padding: 1rem;\n  }\n\n}\n",".stripe-loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(248, 250, 252, 0.72);\n  backdrop-filter: blur(6px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stripe-loader-overlay-dots {\n  background: rgba(248, 250, 252, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n.dot-loader {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 18px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 8px 24px rgba(30, 57, 145, 0.12);\n\n  span {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    background: linear-gradient(145deg, #2b3991, #1e71bb);\n    animation: dot-loader-wave 1.2s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n\n    &:nth-child(2) { animation-delay: 0.16s; }\n    &:nth-child(3) { animation-delay: 0.32s; }\n  }\n}\n\n@keyframes dot-loader-wave {\n  0%, 80%, 100% { transform: translateY(0) scale(0.85); opacity: 0.45; }\n  40% { transform: translateY(-7px) scale(1); opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dot-loader span { animation: none; opacity: 0.8; }\n}\n\n.brand-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n}\n\n.brand-loader-stage {\n  perspective: 900px;\n}\n\n.brand-loader-tile {\n  position: relative;\n  width: 220px;\n  height: 150px;\n  border-radius: 24px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(160deg, #ffffff 0%, #f3f7fc 55%, #e7eff8 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.95),\n    inset 0 -6px 14px rgba(30, 57, 145, 0.08),\n    0 2px 4px rgba(30, 57, 145, 0.08),\n    0 14px 28px rgba(30, 57, 145, 0.14),\n    0 30px 60px rgba(30, 113, 187, 0.16);\n  transform-style: preserve-3d;\n  animation: brand-loader-tilt 2.8s ease-in-out infinite;\n}\n\n.brand-loader-logo {\n  width: 170px;\n  height: auto;\n  display: block;\n  transform: translateZ(28px);\n  filter: drop-shadow(0 6px 10px rgba(43, 57, 145, 0.22));\n}\n\n.brand-loader-shine {\n  position: absolute;\n  inset: -40% auto -40% -60%;\n  width: 45%;\n  background: linear-gradient(\n    100deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.85) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transform: rotate(18deg);\n  animation: brand-loader-shine 2.8s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.brand-loader-floor {\n  width: 150px;\n  height: 14px;\n  border-radius: 50%;\n  background: radial-gradient(ellipse at center, rgba(30, 57, 145, 0.28) 0%, rgba(30, 57, 145, 0) 70%);\n  animation: brand-loader-floor 2.8s ease-in-out infinite;\n}\n\n@keyframes brand-loader-tilt {\n  0%, 100% { transform: rotateX(8deg) rotateY(-16deg) translateY(0); }\n  50% { transform: rotateX(4deg) rotateY(16deg) translateY(-8px); }\n}\n\n@keyframes brand-loader-shine {\n  0%, 25% { left: -60%; }\n  75%, 100% { left: 130%; }\n}\n\n@keyframes brand-loader-floor {\n  0%, 100% { transform: scaleX(1); opacity: 0.9; }\n  50% { transform: scaleX(0.82); opacity: 0.55; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .brand-loader-tile,\n  .brand-loader-shine,\n  .brand-loader-floor {\n    animation: none;\n  }\n}",".modules-container {\n  padding: 20px;\n  font-family: 'Segoe UI', sans-serif;\n\n  .title {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 16px;\n  }\n\n  .modules-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    background-color: #fff;\n    display: block;\n    max-height: 400px;\n    overflow-y: auto;\n    border: 1px solid #ddd; // add border for rounded effect\n    border-radius: 8px; // rounded corners\n    /* clip children overflow to keep rounded corners */\n    -webkit-overflow-scrolling: touch;\n    table-layout: fixed;\n\n    width: 100%;\n    table-layout: auto;\n    /* natural column sizing */\n    overflow-x: visible;\n    /* no horizontal scroll */\n    max-height: none;\n    /* remove max-height so no vertical scroll */\n\n    thead {\n      position: sticky;\n      top: 0;\n      background-color: #212121;\n      color: #fff;\n      z-index: 1;\n      border-top-left-radius: 8px; // round top corners\n      border-top-right-radius: 8px;\n    }\n\n    th,\n    td {\n      padding: 12px 16px;\n      white-space: nowrap;\n      border-bottom: 1px solid #e0e0e0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      border-right: 1px solid #e0e0e0;\n    }\n\n    th:last-child,\n\n    td:last-child {\n      border-right: none;\n    }\n\n    th:nth-child(1),\n    td:nth-child(1) {\n      width: 60px;\n      /* wider for the toggle icon */\n    }\n\n    th:nth-child(2),\n    td:nth-child(2) {\n      width: 300px;\n      /* wider for Title */\n    }\n\n    th:nth-child(3),\n    td:nth-child(3) {\n      width: 350px;\n      /* wider for Path */\n    }\n\n    th:nth-child(4),\n    td:nth-child(4) {\n      width: 150px;\n      /* Status */\n    }\n\n    th {\n      font-weight: 500;\n      font-size: 14px;\n    }\n\n    tr {\n      transition: background 0.2s;\n\n      &:hover {\n        background-color: transparent; // remove white hover effect\n      }\n    }\n\n    .parent-row {\n      background-color: #fff;\n      font-weight: 500;\n    }\n\n    .child-row {\n      background-color: #fafafa;\n\n      td:first-child {\n        padding-left: 28px;\n      }\n    }\n\n    .subchild-row {\n      background-color: #f2f2f2;\n\n      td:first-child {\n        padding-left: 48px;\n      }\n    }\n\n    /* round bottom corners on last row */\n    tr:last-child td:first-child {\n      border-bottom-left-radius: 8px;\n    }\n\n    tr:last-child td:last-child {\n      border-bottom-right-radius: 8px;\n    }\n  }\n}\n\n// Row styling for active and disabled rows\n.row-active {\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  \n  &:hover {\n    background-color: #f5f5f5 !important;\n  }\n}\n\n.row-disabled {\n  background-color: #f5f5f5 !important;\n  color: #666666 !important;\n  opacity: 0.7;\n  \n  &:hover {\n    background-color: #eeeeee !important;\n  }\n  \n  // Make text appear disabled\n  td {\n    color: #999999 !important;\n  }\n}",".cdt-root {\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.cdt-toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.cdt-toolbar .cdt-divider {\n  width: 1px;\n  height: 22px;\n  margin: 0 2px;\n  background: #e2e8f0;\n}\n\n.cdt-toolbar .cdt-btn.MuiButton-root {\n  height: 34px;\n  min-width: auto;\n  padding: 0 14px;\n  gap: 6px;\n  border-radius: 10px;\n  font-family: \"Montserrat\", sans-serif !important;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  text-transform: none;\n  white-space: nowrap;\n  box-shadow: none;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n\n  i {\n    font-size: 14px;\n    line-height: 1;\n  }\n\n  &:active {\n    transform: translateY(1px);\n  }\n}\n\n.cdt-toolbar .cdt-btn-primary.MuiButton-root {\n  color: #fff;\n  border: 0;\n  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n  box-shadow: 0 1px 2px rgba(43, 57, 145, 0.2), 0 6px 14px rgba(30, 113, 187, 0.22);\n\n  &:hover {\n    background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n    box-shadow: 0 2px 4px rgba(43, 57, 145, 0.24), 0 10px 20px rgba(30, 113, 187, 0.28);\n    transform: translateY(-1px);\n  }\n}\n\n.cdt-toolbar .cdt-btn-soft.MuiButton-root {\n  color: #2b3991;\n  background: #eef3fb;\n  border: 1px solid transparent;\n\n  &:hover {\n    background: #e2ebf8;\n    border-color: transparent;\n  }\n}\n\n.cdt-toolbar .cdt-btn-ghost.MuiButton-root {\n  color: #334155;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n\n  &:hover {\n    color: #1e71bb;\n    background: #f8fbff;\n    border-color: #c9d9ee;\n  }\n}\n\n.cdt-toolbar .cdt-btn-link.MuiButton-root {\n  height: 30px;\n  padding: 0 8px;\n  color: #dc2626;\n  background: transparent;\n\n  &:hover {\n    background: #fef2f2;\n  }\n}\n\n.cdt-toolbar .cdt-icon-btn.MuiIconButton-root {\n  width: 34px;\n  height: 34px;\n  padding: 0 !important;\n  border-radius: 10px;\n  color: #475569;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;\n\n  &:hover,\n  &.is-active {\n    color: #1e71bb;\n    background: #eef5fd;\n    border-color: #c9d9ee;\n  }\n\n  .MuiBadge-badge {\n    min-width: 16px;\n    height: 16px;\n    padding: 0 4px;\n    font-size: 10px;\n  }\n}\n\n.cdt-toolbar-end {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cdt-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 4px 0 12px;\n  border-radius: 999px;\n  background: #f7f9fc;\n  border: 1px solid #e6edf5;\n  font-size: 12px;\n}\n\n.cdt-refresh-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #22c55e;\n  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);\n}\n\n.cdt-refresh-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.cdt-refresh-time {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.cdt-refresh .cdt-refresh-btn.MuiIconButton-root {\n  width: 26px;\n  height: 26px;\n  padding: 0 !important;\n  color: #475569;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n\n  &:hover {\n    color: #1e71bb;\n    border-color: #c9d9ee;\n  }\n\n  &:hover svg {\n    transform: rotate(90deg);\n  }\n\n  svg {\n    transition: transform 0.3s ease;\n  }\n}\n\n.cdt-header-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.cdt-col-filter {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  border: 1px solid #d6dee8;\n  border-radius: 6px;\n  padding: 5px 8px;\n  font-size: 12px;\n  color: #111827;\n  background: #fff;\n  outline: none;\n}\n\n.cdt-col-filter:focus {\n  border-color: #1e71bb;\n  box-shadow: 0 0 0 2px rgba(30, 113, 187, 0.12);\n}\n\n.cdt-col-filter::placeholder {\n  color: #94a3b8;\n}\n\n.cdt-grid .MuiDataGrid-row {\n  animation: cdt-row-in 0.35s ease both;\n}\n\n.cdt-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n\n  &::before {\n    content: \"\";\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n  }\n}\n\n.cdt-status-primary { background: #eaf2fd; color: #1d5fae; }\n.cdt-status-info { background: #e6f6f8; color: #0e7490; }\n.cdt-status-success { background: #e8f6ee; color: #15803d; }\n.cdt-status-warning { background: #fdf3e2; color: #b45309; }\n.cdt-status-danger { background: #fdecec; color: #b91c1c; }\n.cdt-status-neutral { background: #f1f5f9; color: #475569; }\n\n@keyframes cdt-row-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cdt-grid .MuiDataGrid-row { animation: none; }\n}\n\n.cdt-columns-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(420px, 100vw);\n  height: 100%;\n  border-radius: 20px 0 0 20px !important;\n  font-family: \"Montserrat\", sans-serif;\n  color: #1c2140;\n  overflow: hidden;\n}\n\n.cdt-columns-dialog .cdt-columns-head,\n.cdt-columns-dialog .cdt-columns-foot {\n  flex-shrink: 0;\n}\n\n.cdt-columns-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.35rem 1.35rem 1rem;\n  background:\n    radial-gradient(220px 120px at 0% 0%, rgba(237, 0, 140, 0.16), transparent 70%),\n    linear-gradient(165deg, #1c2468 0%, #12183a 100%);\n  color: #fff;\n\n  h3 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n    letter-spacing: -0.03em;\n  }\n\n  p:last-child {\n    margin: 0.4rem 0 0;\n    max-width: 42ch;\n    font-size: 0.82rem;\n    font-weight: 500;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.74);\n  }\n}\n\n.cdt-columns-kicker {\n  margin: 0 0 0.35rem;\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #f4b6d6;\n}\n\n.cdt-columns-close {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.18);\n  }\n}\n\n.cdt-columns-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  padding: 1rem 1.35rem 0.4rem;\n}\n\n.cdt-columns-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #6b7280;\n\n  button {\n    border: 0;\n    padding: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #2b3991;\n    cursor: pointer;\n\n    &:hover {\n      color: #ed008c;\n    }\n  }\n}\n\n.cdt-columns-search {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  height: 44px;\n  padding: 0 0.85rem;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: #eef3fb;\n\n  i {\n    color: #8b95ad;\n  }\n\n  input {\n    flex: 1;\n    min-width: 0;\n    border: 0;\n    outline: none;\n    background: transparent;\n    font-family: inherit;\n    font-size: 0.88rem;\n    font-weight: 500;\n    color: #1c2140;\n\n    &::placeholder {\n      color: #8b95ad;\n      font-weight: 400;\n    }\n  }\n\n  button {\n    display: grid;\n    place-items: center;\n    width: 24px;\n    height: 24px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #6b7280;\n    cursor: pointer;\n\n    &:hover {\n      background: #fff;\n      color: #1c2140;\n    }\n  }\n\n  &:focus-within {\n    background: #fff;\n    border-color: #2b3991;\n    box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);\n  }\n}\n\n.cdt-columns-found {\n  margin: 0.45rem 0 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.cdt-columns-list {\n  flex: 1;\n  min-height: 0;\n  margin-top: 0.75rem;\n  overflow: auto;\n}\n\n.cdt-columns-empty {\n  margin: 0;\n  padding: 1.5rem 0.5rem;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.cdt-columns-row {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin: 0 0 0.35rem;\n  padding: 0.15rem 0.45rem 0.15rem 0.2rem;\n  border-radius: 12px;\n  cursor: pointer;\n\n  &:hover {\n    background: #f4f7fc;\n  }\n\n  &.is-on {\n    background: rgba(43, 57, 145, 0.06);\n  }\n\n  .MuiCheckbox-root {\n    color: #94a3b8;\n  }\n\n  .MuiCheckbox-root.Mui-checked {\n    color: #2b3991;\n  }\n}\n\n.cdt-columns-copy {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.cdt-columns-name {\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #1c2140;\n}\n\n.cdt-columns-field {\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: #8b95ad;\n}\n\n.cdt-columns-index {\n  min-width: 22px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-align: right;\n  color: #8b95ad;\n}\n\n.cdt-columns-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1.35rem 1.1rem;\n  border-top: 1px solid #eef1f6;\n}\n\n.cdt-columns-bulk,\n.cdt-columns-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.cdt-columns-foot button {\n  height: 36px;\n  padding: 0 0.85rem;\n  border: 0;\n  border-radius: 10px;\n  background: #eef3fb;\n  font-family: inherit;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #2b3991;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #e2ebf8;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  &.is-primary {\n    background: #2b3991;\n    color: #fff;\n    box-shadow: 0 8px 16px rgba(43, 57, 145, 0.2);\n\n    &:hover {\n      background: #ed008c;\n    }\n  }\n}\n\n.cdt-filters-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(420px, 100vw);\n  height: 100%;\n  border-radius: 20px 0 0 20px !important;\n  font-family: \"Montserrat\", sans-serif;\n  color: #1c2140;\n  overflow: hidden;\n}\n\n.cdt-filters-dialog .cdt-columns-head,\n.cdt-filters-dialog .cdt-columns-foot {\n  flex-shrink: 0;\n}\n\n.cdt-filters-body {\n  flex: 1;\n  min-height: 0;\n  padding: 1rem 1.35rem 0.85rem;\n  overflow: auto;\n}\n\n.cdt-filter-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n  margin-top: 0.35rem;\n  padding: 1.6rem 1rem 1.3rem;\n  border: 1px dashed rgba(43, 57, 145, 0.18);\n  border-radius: 16px;\n  background: #f7f9fc;\n  text-align: center;\n\n  i {\n    display: grid;\n    place-items: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    background: #fff;\n    color: #2b3991;\n    font-size: 1.05rem;\n    box-shadow: 0 8px 18px rgba(43, 57, 145, 0.08);\n  }\n\n  p {\n    margin: 0;\n    max-width: 28ch;\n    font-size: 0.84rem;\n    font-weight: 500;\n    line-height: 1.45;\n    color: #6b7280;\n  }\n\n  button {\n    height: 36px;\n    margin-top: 0.2rem;\n    padding: 0 0.95rem;\n    border: 0;\n    border-radius: 10px;\n    background: #2b3991;\n    color: #fff;\n    font-family: inherit;\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover {\n      background: #ed008c;\n    }\n  }\n}\n\n.cdt-filter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.cdt-filter-card {\n  padding: 0.75rem 0.8rem 0.85rem;\n  border: 1px solid rgba(43, 57, 145, 0.08);\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(28, 33, 64, 0.04);\n}\n\n.cdt-filter-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.65rem;\n}\n\n.cdt-filter-index {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 0 0.55rem;\n  border-radius: 999px;\n  background: rgba(43, 57, 145, 0.08);\n  color: #2b3991;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\n.cdt-filter-remove {\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n\n  &:hover {\n    background: #fdecec;\n    color: #b91c1c;\n  }\n}\n\n.cdt-filter-grid {\n  display: grid;\n  grid-template-columns: 1.3fr 0.9fr;\n  gap: 0.7rem;\n}\n\n.cdt-filter-span {\n  grid-column: 1 / -1;\n}\n\n.cdt-filter-field.MuiFormControl-root {\n  .MuiInputLabel-root {\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #6b7280;\n  }\n\n  .MuiInputLabel-root.Mui-focused {\n    color: #2b3991;\n  }\n\n  .MuiOutlinedInput-root {\n    border-radius: 12px;\n    background: #eef3fb;\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 0.86rem;\n    font-weight: 500;\n    color: #1c2140;\n\n    .MuiOutlinedInput-notchedOutline {\n      border-color: transparent;\n    }\n\n    &:hover .MuiOutlinedInput-notchedOutline {\n      border-color: transparent;\n    }\n\n    &.Mui-focused {\n      background: #fff;\n      box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);\n\n      .MuiOutlinedInput-notchedOutline {\n        border-color: #2b3991;\n        border-width: 1px;\n      }\n    }\n  }\n\n  .MuiSelect-select {\n    font-family: \"Montserrat\", sans-serif;\n  }\n}\n\n@media (max-width: 640px) {\n  .cdt-filter-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .cdt-filter-span {\n    grid-column: auto;\n  }\n\n  .cdt-columns-foot {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .cdt-columns-bulk,\n  .cdt-columns-actions {\n    justify-content: space-between;\n  }\n}\n",".confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0,0,0,0.5);\n  z-index: 1000;\n}\n\n.confirm-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0,0,0,0.25);\n  width: 350px;\n  z-index: 1001;\n}\n\n.confirm-title {\n  margin: 0 0 12px 0;\n  font-size: 20px;\n}\n\n.confirm-message {\n  margin: 0 0 20px 0;\n  color: #555;\n}\n\n.confirm-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.confirm-btn {\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s ease;\n}\n\n.yes-btn {\n  border: none;\n  background-color: #007bff;\n  color: #fff;\n}\n\n.yes-btn:hover {\n  background-color: #0056b3;\n}\n\n.no-btn {\n  border: 1px solid #ccc;\n  background-color: #f0f0f0;\n}\n\n.no-btn:hover {\n  background-color: #e0e0e0;\n}\n\n.modal-dialog.pp-disable-dialog {\n  max-width: 520px;\n  height: 100%;\n  min-height: 0;\n  align-items: center;\n}\n\n.pp-disable-content {\n  height: auto;\n  flex: 0 0 auto;\n  width: 100%;\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow:\n    0 24px 64px rgba(17, 24, 39, 0.18),\n    0 2px 8px rgba(17, 24, 39, 0.06);\n}\n\nbody .modal-body.pp-disable-body {\n  position: relative;\n  flex: 0 0 auto;\n  height: auto;\n  overflow: visible;\n  padding: 28px 28px 8px;\n}\n\n.pp-disable-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n}\n\n.pp-disable-mark {\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: linear-gradient(180deg, #f7f8fd 0%, #e8ebf7 100%);\n  color: #2b3991;\n  font-size: 1.35rem;\n  box-shadow: inset 0 0 0 1px rgba(43, 57, 145, 0.14);\n}\n\n.pp-disable-kicker {\n  font-size: 0.7rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.pp-disable-title {\n  margin: 0 0 8px;\n  padding-right: 24px;\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #111827;\n}\n\n.pp-disable-copy {\n  margin: 0;\n  color: #4b5563;\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n.pp-disable-details {\n  margin: 20px 0 0;\n  padding: 4px 16px;\n  border-radius: 14px;\n  background: #f7f8fc;\n  border: 1px solid #e6e8f2;\n}\n\n.pp-disable-detail {\n  display: grid;\n  grid-template-columns: 108px 1fr;\n  gap: 12px;\n  align-items: baseline;\n  padding: 10px 0;\n  border-bottom: 1px solid #e6e8f2;\n}\n\n.pp-disable-detail:last-child {\n  border-bottom: 0;\n}\n\n.pp-disable-detail dt {\n  margin: 0;\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.pp-disable-detail dd {\n  margin: 0;\n  color: #111827;\n  font-size: 0.92rem;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.pp-disable-detail-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  letter-spacing: 0.04em;\n  color: #2b3991;\n  font-weight: 700;\n}\n\n.pp-disable-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: #eef0f6;\n  color: #374151;\n}\n\n.pp-disable-status--active {\n  background: #e8f6ee;\n  color: #166534;\n}\n\n.pp-disable-status--inactive,\n.pp-disable-status--pending {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.pp-disable-footer {\n  border: 0;\n  padding: 20px 28px 28px;\n  gap: 10px;\n}\n\n.pp-disable-confirm {\n  background: #2b3991;\n  border-color: #2b3991;\n  color: #fff;\n  min-width: 112px;\n  font-weight: 600;\n}\n\n.pp-disable-confirm:hover,\n.pp-disable-confirm:focus {\n  background: #1e2870;\n  border-color: #1e2870;\n  color: #fff;\n}\n\n",".settings-content {\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.settings-content .card-header h5 {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.settings-content .form-label,\n.settings-content .form-check-label,\n.settings-content p,\n.settings-content li {\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.settings-content .form-control,\n.settings-content .form-select {\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n\n// Tenent Setting Section\n\n.tenant-card {\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.tenant-card-header {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.tenant-card-title {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.tenant-card-body {\n  font-size: 0.85rem;\n  font-weight: 400;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.tenant-label {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.tenant-input {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.tenant-select {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.tenant-subtitle {\n  font-size: 0.85rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.tenant-btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8rem;\n  border-radius: 6px;\n  min-width: 70px;\n}\n\n.tenant-url-row {\n  gap: 0.25rem;\n}\n\n// Password Section\n.password-card {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.password-card-header {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.password-card-title {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.password-card-body {\n  font-size: 0.85rem;\n  font-weight: 400;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.password-label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.password-input {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.password-btn {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n// Profile Card\n\n.profile-card {\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.profile-card-header {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.profile-card-title {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.profile-card-body {\n  font-size: 0.85rem;\n  font-weight: 400;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.profile-label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.profile-input {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.profile-btn {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n\n// perferneces \n\n.gradient-btn {\n  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n  color: #fff !important;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.gradient-btn:hover {\n  opacity: 0.9;\n}\n\n.user-settings {\n  --settings-ink: #171b2e;\n  --settings-muted: #6d758c;\n  --settings-line: rgba(28, 39, 84, 0.08);\n  --settings-surface: #ffffff;\n  --settings-canvas: #f3f5fb;\n  min-height: calc(100vh - 156px);\n  display: grid;\n  grid-template-columns: 292px minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n  padding: 16px;\n  background:\n    radial-gradient(900px 280px at 0% -20%, rgba(43, 57, 145, 0.1), transparent 60%),\n    radial-gradient(700px 240px at 100% 0%, rgba(30, 113, 187, 0.1), transparent 55%),\n    var(--settings-canvas);\n  color: var(--settings-ink);\n  font-family: \"Montserrat\", \"Segoe UI\", sans-serif;\n  font-size: 0.8rem;\n}\n\n.settings-rail,\n.settings-panel {\n  background: var(--settings-surface);\n  border: 1px solid var(--settings-line);\n  border-radius: 22px;\n  box-shadow: 0 16px 40px rgba(23, 32, 74, 0.06);\n}\n\n.settings-rail {\n  padding: 18px 14px 14px;\n  position: sticky;\n  top: 8px;\n  align-self: start;\n}\n\n.settings-identity {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  padding: 8px 8px 18px;\n  border-bottom: 1px solid var(--settings-line);\n  margin-bottom: 14px;\n}\n\n.settings-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  font-size: 0.85rem;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  color: #fff;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));\n  box-shadow: 0 10px 22px rgba(43, 57, 145, 0.28);\n}\n\n.settings-identity__copy {\n  min-width: 0;\n\n  h1 {\n    margin: 0 0 2px;\n    font-size: 0.84rem;\n    font-weight: 650;\n    line-height: 1.3;\n  }\n\n  p {\n    margin: 0;\n    color: var(--settings-muted);\n    font-size: 0.72rem;\n    word-break: break-word;\n  }\n}\n\n.settings-org {\n  display: inline-flex;\n  text-wrap: auto;\n  margin-top: 8px;\n  max-width: 100%;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: rgba(43, 57, 145, 0.08);\n  color: #2b3991;\n  font-size: 0.65rem;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.settings-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.settings-nav__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px;\n  border: 1px solid transparent;\n  border-radius: 14px;\n  background: transparent;\n  color: #30364a;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    font-size: 0.78rem;\n    font-weight: 650;\n  }\n\n  small {\n    margin-top: 1px;\n    color: var(--settings-muted);\n    font-size: 0.65rem;\n  }\n\n  &:hover {\n    background: #f6f8fd;\n  }\n\n  &.is-active {\n    background: linear-gradient(180deg, rgba(43, 57, 145, 0.1), rgba(30, 113, 187, 0.06));\n    border-color: rgba(43, 57, 145, 0.14);\n    color: #24306f;\n\n    .settings-nav__icon {\n      background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));\n      color: #fff;\n    }\n  }\n}\n\n.settings-nav__icon {\n  width: 30px;\n  height: 30px;\n  font-size: 0.85rem;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: #eef2fa;\n  color: #2b3991;\n  flex-shrink: 0;\n}\n\n.settings-panel {\n  padding: 26px 28px 22px;\n  min-width: 0;\n}\n\n.settings-kicker {\n  margin: 0 0 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #1e71bb;\n}\n\n.settings-panel__head {\n  margin-bottom: 22px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--settings-line);\n\n  h2 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 650;\n    letter-spacing: -0.02em;\n  }\n}\n\n.settings-lead {\n  margin: 8px 0 0;\n  max-width: 62ch;\n  color: var(--settings-muted);\n  font-size: 0.75rem;\n  line-height: 1.45;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 18px;\n}\n\n.settings-grid--single {\n  grid-template-columns: minmax(0, 520px);\n}\n\n.settings-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n}\n\n.settings-field__label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #7b8296;\n\n  em {\n    font-style: normal;\n    letter-spacing: 0;\n    text-transform: none;\n    font-size: 0.62rem;\n    font-weight: 600;\n    color: #9aa1b5;\n  }\n}\n\n.settings-field__value,\n.settings-input {\n  width: 100%;\n  min-height: 34px;\n  border-radius: 10px;\n  border: 1px solid #e4e8f2;\n  background: #f8f9fd;\n  color: var(--settings-ink);\n  padding: 7px 10px;\n  font: inherit;\n  font-size: 0.78rem;\n}\n\n.settings-input {\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #1e71bb;\n    box-shadow: 0 0 0 4px rgba(30, 113, 187, 0.14);\n  }\n\n  &:disabled {\n    background: #f4f6fb;\n    color: #98a0b3;\n  }\n\n  &.is-invalid {\n    border-color: #e15b64;\n    box-shadow: 0 0 0 4px rgba(225, 91, 100, 0.12);\n  }\n}\n\n.settings-input-wrap {\n  position: relative;\n\n  .settings-input {\n    padding-right: 46px;\n  }\n}\n\n.settings-eye {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #667089;\n  cursor: pointer;\n\n  &:hover {\n    background: #f1f4fb;\n    color: #2b3991;\n  }\n}\n\n.settings-hint,\n.settings-error,\n.settings-footnote {\n  font-size: 0.7rem;\n  line-height: 1.4;\n}\n\n.settings-hint,\n.settings-footnote {\n  color: var(--settings-muted);\n}\n\n.settings-error {\n  color: #c43b48;\n}\n\n.settings-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.settings-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 32px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.settings-btn--primary {\n  color: #fff;\n  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n  box-shadow: 0 10px 20px rgba(43, 57, 145, 0.22);\n\n  &:hover {\n    filter: brightness(1.05);\n  }\n}\n\n.settings-btn--ghost {\n  background: #fff;\n  color: #30364a;\n  border-color: #e1e6f0;\n\n  &:hover {\n    background: #f7f8fc;\n  }\n}\n\n.settings-security-note {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 18px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: linear-gradient(180deg, rgba(43, 57, 145, 0.06), rgba(30, 113, 187, 0.04));\n  color: #31406f;\n\n  i {\n    font-size: 0.9rem;\n    margin-top: 1px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.75rem;\n    line-height: 1.5;\n  }\n}\n\n.settings-toggle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.settings-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid #e6eaf3;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n\n  &.is-on {\n    border-color: rgba(43, 57, 145, 0.22);\n    background: linear-gradient(180deg, rgba(43, 57, 145, 0.05), #fff 70%);\n\n    .settings-switch {\n      background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n\n      span {\n        transform: translateX(18px);\n      }\n    }\n  }\n}\n\n.settings-toggle--compact {\n  min-height: 46px;\n  padding: 8px 10px 8px 14px;\n}\n\n.settings-toggle__icon,\n.settings-access__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: #eef2fa;\n  color: #2b3991;\n}\n\n.settings-toggle__copy {\n  flex: 1;\n  min-width: 0;\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    font-size: 0.78rem;\n  }\n\n  small {\n    margin-top: 2px;\n    color: var(--settings-muted);\n    font-size: 0.7rem;\n  }\n}\n\n.settings-switch {\n  width: 42px;\n  height: 24px;\n  border-radius: 999px;\n  background: #d7dce8;\n  padding: 3px;\n  flex-shrink: 0;\n  transition: background 0.18s ease;\n\n  span {\n    display: block;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 2px 6px rgba(20, 28, 60, 0.18);\n    transition: transform 0.18s ease;\n  }\n}\n\n.settings-theme {\n  margin-top: 22px;\n  padding: 18px;\n  border-radius: 18px;\n  border: 1px solid var(--settings-line);\n  background: #fbfcfe;\n}\n\n.settings-branding-source {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 10px 12px;\n  border: 1px solid var(--settings-line);\n  border-radius: 12px;\n  background: var(--settings-surface);\n}\n\n.settings-branding-source__logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 56px;\n  height: 44px;\n  border-radius: 10px;\n  background: #f4f6fb;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n}\n\n.settings-branding-source__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n\n  strong {\n    font-size: 0.78rem;\n  }\n\n  span {\n    color: var(--settings-muted);\n    font-size: 0.7rem;\n  }\n}\n\n.settings-theme__copy {\n  h3 {\n    margin: 0 0 4px;\n    font-size: 0.82rem;\n  }\n\n  p {\n    margin: 0 0 14px;\n    color: var(--settings-muted);\n    font-size: 0.72rem;\n  }\n}\n\n.settings-theme__preview {\n  height: 52px;\n  font-size: 0.75rem;\n  border-radius: 16px;\n  display: flex;\n  align-items: flex-end;\n  padding: 14px 16px;\n  color: #fff;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);\n}\n\n.settings-swatches {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.settings-swatch {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid #e7ebf4;\n\n  span,\n  em {\n    font-size: 0.65rem;\n  }\n\n  span {\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #7b8296;\n  }\n\n  em {\n    font-style: normal;\n    color: var(--settings-muted);\n  }\n\n  input[type=\"color\"] {\n    width: 100%;\n    height: 36px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n  }\n}\n\n.settings-preview-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.settings-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 650;\n}\n\n.settings-access-list {\n  display: grid;\n  gap: 12px;\n}\n\n.settings-access {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  padding: 16px;\n  border-radius: 16px;\n  border: 1px solid #e6eaf3;\n  background: #fff;\n\n  h3 {\n    margin: 0 0 4px;\n    font-size: 0.68rem;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #7b8296;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.78rem;\n    line-height: 1.45;\n  }\n}\n\n.settings-footnote {\n  margin: 16px 0 0;\n}\n\n.settings-feedback {\n  position: fixed;\n  inset: 0;\n  z-index: 4000;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n}\n\n.settings-feedback__backdrop {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  border: 0;\n  background: rgba(16, 22, 44, 0.52);\n  backdrop-filter: blur(8px);\n}\n\n.settings-feedback__panel {\n  position: relative;\n  z-index: 1;\n  width: min(420px, 100%);\n  padding: 28px 26px 24px;\n  border-radius: 24px;\n  background: #fff;\n  color: #171b2e;\n  text-align: center;\n  box-shadow: 0 30px 80px rgba(16, 22, 44, 0.28);\n  animation: settings-feedback-in 0.28s ease;\n\n  h3 {\n    margin: 6px 0 6px;\n    font-size: 1rem;\n    letter-spacing: -0.02em;\n  }\n}\n\n.settings-feedback__kicker {\n  margin: 14px 0 0;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #1e71bb;\n}\n\n.settings-feedback__message {\n  margin: 0 0 16px;\n  color: var(--settings-muted, #6d758c);\n  font-size: 0.8rem;\n  line-height: 1.45;\n}\n\n.settings-feedback__icon {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  font-size: 1.25rem;\n  background: var(--button-gradient, linear-gradient(135deg, #2b3991, #1e71bb));\n  box-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);\n}\n\n.settings-feedback__btn {\n  min-width: 112px;\n  min-height: 32px;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n  background: var(--button-gradient, linear-gradient(to right, #2b3991, #1e71bb));\n}\n\n@keyframes settings-feedback-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (max-width: 980px) {\n  .user-settings {\n    grid-template-columns: 1fr;\n  }\n\n  .settings-rail {\n    position: static;\n  }\n\n  .settings-nav {\n    flex-direction: row;\n    overflow-x: auto;\n    padding-bottom: 4px;\n  }\n\n  .settings-nav__item {\n    min-width: 180px;\n  }\n\n  .settings-swatches,\n  .settings-grid,\n  .admin-url-row {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-toolbar,\n  .admin-toolbar__actions,\n  .admin-request header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.admin-settings {\n  .settings-identity__copy h1 {\n    font-size: 1.02rem;\n    font-weight: 600;\n    letter-spacing: -0.03em;\n  }\n\n  .settings-panel__head h2 {\n    font-size: 1.45rem;\n    font-weight: 600;\n    letter-spacing: -0.035em;\n  }\n\n  .settings-lead,\n  .settings-kicker,\n  .settings-nav__item strong,\n  .settings-nav__item small,\n  .settings-field__label,\n  .settings-input,\n  .settings-btn,\n  .admin-toolbar p,\n  .admin-order-item {\n    font-family: \"Montserrat\", \"Segoe UI\", sans-serif;\n  }\n\n  .settings-lead,\n  .admin-toolbar p,\n  .settings-footnote {\n    font-size: 0.84rem;\n    font-weight: 500;\n    line-height: 1.55;\n  }\n\n  .settings-input {\n    min-height: 44px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    border-radius: 12px;\n  }\n\n  .settings-btn {\n    min-height: 40px;\n    padding: 0 16px;\n    font-size: 0.78rem;\n    font-weight: 600;\n  }\n}\n\n.admin-block {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.admin-toolbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n\n  h3 {\n    margin: 0 0 4px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n  }\n\n  p {\n    margin: 0;\n    max-width: 62ch;\n    color: var(--settings-muted, #6d758c);\n  }\n}\n\n.admin-toolbar__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.admin-urls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 18px;\n  border-top: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));\n}\n\n.admin-url-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.admin-url-row {\n  display: grid;\n  grid-template-columns: minmax(160px, 200px) minmax(0, 1fr) auto auto auto;\n  gap: 10px;\n  align-items: end;\n  padding: 12px;\n  border-radius: 16px;\n  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));\n  background: #fbfcfe;\n}\n\n.admin-sync,\n.admin-remove {\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid #e1e6f0;\n  background: #fff;\n  color: #4b5368;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.admin-sync {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n\n  &.is-on {\n    color: #24306f;\n    border-color: rgba(43, 57, 145, 0.22);\n    background: rgba(43, 57, 145, 0.08);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.admin-remove {\n  width: 44px;\n\n  &:hover:not(:disabled) {\n    color: #c43b48;\n    border-color: rgba(196, 59, 72, 0.3);\n    background: #fff6f7;\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n}\n\n.admin-module {\n  cursor: default;\n}\n\n.admin-status {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #eef1f6;\n  color: #6d758c;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n\n  &.is-on {\n    background: rgba(43, 57, 145, 0.1);\n    color: #2b3991;\n  }\n}\n\n.admin-extra,\n.admin-requests {\n  padding: 16px;\n  border-radius: 18px;\n  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));\n  background: #fbfcfe;\n\n  ul {\n    list-style: none;\n    margin: 12px 0 0;\n    padding: 0;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 0;\n    border-top: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));\n    font-size: 0.84rem;\n  }\n\n  code {\n    padding: 2px 6px;\n    border-radius: 8px;\n    background: #fff;\n    color: #6d758c;\n    font-size: 0.75rem;\n  }\n}\n\n.admin-request-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 320px;\n  overflow: auto;\n}\n\n.admin-request {\n  padding: 14px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid var(--settings-line, rgba(28, 39, 84, 0.08));\n\n  header {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 6px;\n  }\n\n  strong {\n    font-size: 0.86rem;\n  }\n\n  span,\n  p {\n    margin: 0;\n    color: var(--settings-muted, #6d758c);\n    font-size: 0.78rem;\n  }\n\n  p + p {\n    margin-top: 4px;\n  }\n}\n\n.admin-request__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.admin-order-lead {\n  margin: 0;\n  color: var(--settings-muted, #6d758c);\n  font-size: 0.84rem;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.admin-order-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-order-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  border: 1px solid #e6eaf3;\n  background: #fff;\n  cursor: grab;\n  touch-action: none;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    font-size: 0.88rem;\n    font-weight: 600;\n  }\n\n  small {\n    margin-top: 2px;\n    color: #6d758c;\n    font-size: 0.72rem;\n  }\n\n  > i {\n    margin-left: auto;\n    color: #98a0b3;\n    font-size: 1.1rem;\n  }\n}\n\n.admin-request-dialog {\n  max-width: 560px;\n}\n\n.admin-request-modal {\n  max-height: calc(100vh - 48px);\n  border: 0 !important;\n  border-radius: 24px;\n  overflow: auto;\n  padding: 22px 22px 18px;\n  color: #171b2e;\n  font-family: \"Montserrat\", \"Segoe UI\", sans-serif;\n  box-shadow: 0 30px 80px rgba(16, 22, 44, 0.28);\n}\n\n.admin-request-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n\n  h2 {\n    margin: 2px 0 6px;\n    font-size: 1.35rem;\n    font-weight: 600;\n    letter-spacing: -0.03em;\n  }\n\n  p:last-child {\n    margin: 0;\n    max-width: 46ch;\n    color: #6d758c;\n    font-size: 0.84rem;\n    font-weight: 500;\n    line-height: 1.5;\n  }\n}\n\n.admin-request-modal__close {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 12px;\n  background: #f3f5fb;\n  color: #4b5368;\n  flex-shrink: 0;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #e7ebf5;\n    color: #171b2e;\n  }\n}\n\n.admin-request-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  margin-bottom: 12px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid #e4e8f2;\n  background: #f8f9fd;\n  color: #7b8296;\n\n  input {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    color: #171b2e;\n    font: inherit;\n    font-size: 0.88rem;\n    font-weight: 500;\n    outline: none;\n  }\n\n  &:focus-within {\n    background: #fff;\n    border-color: #2b3991;\n    box-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);\n  }\n}\n\n.admin-request-modal__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  color: #6d758c;\n  font-size: 0.75rem;\n  font-weight: 600;\n\n  div {\n    display: flex;\n    gap: 12px;\n  }\n\n  button {\n    border: 0;\n    padding: 0;\n    background: transparent;\n    color: #2b3991;\n    font: inherit;\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n\n    &:hover {\n      color: #ed008c;\n    }\n  }\n}\n\n.admin-menu-list {\n  max-height: 280px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-right: 2px;\n}\n\n.admin-menu-option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 42px;\n  margin: 0;\n  padding: 8px 10px;\n  border-radius: 12px;\n  border: 1px solid #e6eaf3;\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.84rem;\n  font-weight: 500;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &.is-on {\n    border-color: rgba(43, 57, 145, 0.22);\n    background: linear-gradient(180deg, rgba(43, 57, 145, 0.06), #fff 72%);\n\n    .admin-menu-option__mark {\n      background: #2b3991;\n      border-color: #2b3991;\n      color: #fff;\n    }\n  }\n}\n\n.admin-menu-option__mark {\n  width: 18px;\n  height: 18px;\n  border-radius: 6px;\n  border: 1px solid #cfd5e4;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  color: transparent;\n  font-size: 0.75rem;\n  background: #fff;\n}\n\n.admin-request-note {\n  margin-top: 14px;\n\n  textarea.settings-input {\n    min-height: 84px;\n    padding-top: 10px;\n    resize: vertical;\n    font-family: inherit;\n  }\n}\n\n.admin-request-modal__status {\n  margin: 8px 0 16px;\n  color: #6d758c;\n  font-size: 0.84rem;\n  font-weight: 500;\n}\n\n.admin-request-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n\n  .settings-btn {\n    min-height: 40px;\n    padding: 0 16px;\n    font-family: inherit;\n    font-size: 0.78rem;\n    font-weight: 600;\n  }\n}\n\n.admin-order-item__index {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: #eef2fa;\n  color: #2b3991;\n  font-size: 0.75rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n@media (max-width: 640px) {\n  .user-settings,\n  .settings-panel {\n    padding: 14px;\n  }\n\n  .settings-panel__head h2 {\n    font-size: 0.95rem;\n  }\n\n  .settings-actions {\n    flex-direction: column-reverse;\n  }\n\n  .settings-btn {\n    width: 100%;\n  }\n}",".select-facility-container {\n    background-color: #f5f5f5 !important;\n    height: calc(100vh - 92px) !important;\n\n    .facility-card {\n        width: 400px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n        h2 {\n            font-size: 1.5rem;\n            font-weight: 600;\n        }\n\n        .form-label {\n            font-size: 0.95rem;\n        }\n\n        .form-control,\n        .form-select {\n            border-radius: 0.375rem;\n        }\n\n        .btn {\n            font-size: 1rem;\n            font-weight: 500;\n        }\n    }\n}",".interest-page {\n\tmin-height: 100vh;\n\tdisplay: grid;\n\tgrid-template-columns: minmax(320px, 0.92fr) minmax(440px, 1.08fr);\n\tfont-family: \"Montserrat\", sans-serif;\n\tbackground: #f4f6fb;\n\tcolor: #1c2140;\n}\n\n.interest-story {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 2.4rem 3.2rem 3rem;\n\tcolor: #fff;\n\tbackground:\n\t\tradial-gradient(520px 320px at 8% 0%, rgba(237, 0, 140, 0.32), transparent 62%),\n\t\tradial-gradient(460px 340px at 100% 100%, rgba(30, 113, 187, 0.38), transparent 58%),\n\t\tlinear-gradient(168deg, #1c2468 0%, #12183a 52%, #0b1026 100%);\n}\n\n.interest-logo-frame {\n\twidth: 112px;\n\theight: 72px;\n\toverflow: hidden;\n\talign-self: flex-start;\n\tbackground: transparent;\n}\n\n.interest-logo {\n\tdisplay: block;\n\theight: 200px;\n\twidth: 200px;\n\tmax-width: none;\n\ttransform: translate(-41px, -65px);\n\tmix-blend-mode: screen;\n}\n\n.interest-story-body {\n\tposition: sticky;\n\ttop: 2.4rem;\n\tmax-width: 480px;\n\tmargin-top: 2.6rem;\n}\n\n.interest-kicker {\n\tmargin: 0 0 0.85rem;\n\tfont-size: 0.68rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.2em;\n\ttext-transform: uppercase;\n\tcolor: #f4b6d6;\n}\n\n.interest-kicker-dark {\n\tcolor: #2b3991;\n}\n\n.interest-story h1 {\n\tmargin: 0;\n\tfont-size: clamp(2.15rem, 3.2vw, 3.2rem);\n\tfont-weight: 600;\n\tline-height: 1.06;\n\tletter-spacing: -0.045em;\n}\n\n.interest-story-copy {\n\tmax-width: 38ch;\n\tmargin: 1.15rem 0 0;\n\tfont-size: 0.98rem;\n\tfont-weight: 500;\n\tline-height: 1.65;\n\tcolor: rgba(255, 255, 255, 0.78);\n}\n\n.interest-points {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.8rem;\n\tmargin: 1.8rem 0 0;\n\tpadding: 0;\n\tlist-style: none;\n\n\tli {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.8rem;\n\t\tfont-size: 0.88rem;\n\t\tfont-weight: 500;\n\t\tcolor: rgba(255, 255, 255, 0.92);\n\t}\n\n\ti {\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 10px;\n\t\tbackground: rgba(255, 255, 255, 0.1);\n\t\tfont-size: 0.95rem;\n\t}\n}\n\n.interest-direct {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 0.85rem;\n\twidth: fit-content;\n\tmax-width: 100%;\n\tmargin-top: 2rem;\n\tpadding: 0.85rem 1rem 0.85rem 0.9rem;\n\tborder: 1px solid rgba(255, 255, 255, 0.16);\n\tborder-radius: 16px;\n\tbackground: rgba(255, 255, 255, 0.08);\n\tcolor: inherit;\n\ttext-decoration: none;\n\tbackdrop-filter: blur(10px);\n\ttransition: background 0.2s ease, transform 0.2s ease;\n\n\ti {\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tborder-radius: 12px;\n\t\tbackground: rgba(255, 255, 255, 0.12);\n\t\tfont-size: 1.05rem;\n\t}\n\n\tsmall {\n\t\tdisplay: block;\n\t\tmargin-bottom: 0.15rem;\n\t\tfont-size: 0.62rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.16em;\n\t\ttext-transform: uppercase;\n\t\tcolor: rgba(255, 255, 255, 0.62);\n\t}\n\n\tstrong {\n\t\tfont-size: 0.95rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: -0.01em;\n\t}\n\n\t&:hover {\n\t\tbackground: rgba(255, 255, 255, 0.14);\n\t\ttransform: translateY(-1px);\n\t}\n}\n\n.interest-panel {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 2rem 1.75rem;\n\tbackground:\n\t\tradial-gradient(480px 240px at 88% 0%, rgba(43, 57, 145, 0.08), transparent 70%),\n\t\tlinear-gradient(180deg, #f8f9fc 0%, #eef1f7 100%);\n}\n\n.interest-card {\n\twidth: min(560px, 100%);\n\tpadding: 2.15rem 2.1rem 1.55rem;\n\tborder: 1px solid rgba(43, 57, 145, 0.06);\n\tborder-radius: 24px;\n\tbackground: #fff;\n\tbox-shadow: 0 24px 60px rgba(28, 33, 64, 0.08);\n\n\th2 {\n\t\tmargin: 0;\n\t\tfont-size: 1.7rem;\n\t\tfont-weight: 600;\n\t\tline-height: 1.2;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: #1c2140;\n\t}\n}\n\n.interest-lead {\n\tmargin: 0.5rem 0 1.15rem;\n\tfont-size: 0.88rem;\n\tfont-weight: 500;\n\tline-height: 1.55;\n\tcolor: #6b7280;\n}\n\n.interest-destination {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 1rem;\n\tmargin-bottom: 1.15rem;\n\tpadding: 0.9rem 1rem;\n\tborder: 1px solid rgba(43, 57, 145, 0.08);\n\tborder-radius: 16px;\n\tbackground: linear-gradient(100deg, rgba(43, 57, 145, 0.08), rgba(237, 0, 140, 0.07));\n\n\tsmall {\n\t\tdisplay: block;\n\t\tmargin-bottom: 0.15rem;\n\t\tfont-size: 0.62rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.16em;\n\t\ttext-transform: uppercase;\n\t\tcolor: #2b3991;\n\t}\n\n\ta {\n\t\tcolor: #1c2140;\n\t\tfont-size: 0.98rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: -0.01em;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\tcolor: #ed008c;\n\t\t}\n\t}\n\n\t> i {\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\twidth: 36px;\n\t\theight: 36px;\n\t\tflex-shrink: 0;\n\t\tborder-radius: 50%;\n\t\tbackground: #fff;\n\t\tcolor: #2b3991;\n\t\tbox-shadow: 0 6px 16px rgba(43, 57, 145, 0.12);\n\t}\n}\n\n.interest-grid {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 0.85rem 0.9rem;\n}\n\n.interest-field {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.38rem;\n\tmargin: 0;\n\ttext-align: left;\n\n\t> span {\n\t\tfont-size: 0.66rem;\n\t\tfont-weight: 600;\n\t\tletter-spacing: 0.14em;\n\t\ttext-transform: uppercase;\n\t\tcolor: #2b3991;\n\t}\n\n\tinput,\n\ttextarea {\n\t\twidth: 100%;\n\t\tborder: 1px solid transparent;\n\t\tborder-radius: 12px;\n\t\tbackground: #eef3fb;\n\t\tcolor: #1c2140;\n\t\tfont-family: inherit;\n\t\tfont-size: 0.9rem;\n\t\tfont-weight: 500;\n\t\toutline: none;\n\t\ttransition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n\n\t\t&::placeholder {\n\t\t\tcolor: #8b95ad;\n\t\t\tfont-weight: 400;\n\t\t}\n\n\t\t&:focus {\n\t\t\tbackground: #fff;\n\t\t\tborder-color: #2b3991;\n\t\t\tbox-shadow: 0 0 0 4px rgba(43, 57, 145, 0.12);\n\t\t}\n\t}\n\n\tinput {\n\t\theight: 48px;\n\t\tpadding: 0 0.95rem;\n\t}\n\n\ttextarea {\n\t\tmin-height: 118px;\n\t\tpadding: 0.85rem 0.95rem;\n\t\tresize: vertical;\n\t}\n}\n\n.interest-span {\n\tgrid-column: 1 / -1;\n}\n\n.interest-error {\n\tmargin: 0.85rem 0 0;\n\tfont-size: 0.82rem;\n\tfont-weight: 600;\n\tcolor: #b42318;\n}\n\n.interest-submit {\n\twidth: 100%;\n\theight: 50px;\n\tmargin-top: 1.15rem;\n\tborder: 0;\n\tborder-radius: 12px;\n\tbackground: #2b3991;\n\tcolor: #fff;\n\tfont-family: inherit;\n\tfont-size: 0.74rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.16em;\n\ttext-transform: uppercase;\n\tcursor: pointer;\n\tbox-shadow: 0 12px 24px rgba(43, 57, 145, 0.22);\n\ttransition: background 0.2s ease;\n\n\t&:hover {\n\t\tbackground: #ed008c;\n\t}\n}\n\n.interest-back {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\twidth: 100%;\n\tmargin-top: 0.95rem;\n\tcolor: #2b3991;\n\tfont-size: 0.84rem;\n\tfont-weight: 600;\n\ttext-decoration: none;\n\n\t&:hover {\n\t\tcolor: #ed008c;\n\t}\n}\n\n.interest-success {\n\ttext-align: center;\n\n\th2 {\n\t\tmargin-bottom: 0.7rem;\n\t}\n\n\tp:not(.interest-kicker) {\n\t\tmargin: 0 0 0.4rem;\n\t\tfont-size: 0.9rem;\n\t\tfont-weight: 500;\n\t\tline-height: 1.55;\n\t\tcolor: #6b7280;\n\t}\n}\n\n.interest-success-mark {\n\tdisplay: grid;\n\tplace-items: center;\n\twidth: 64px;\n\theight: 64px;\n\tmargin: 0.2rem auto 1rem;\n\tborder-radius: 50%;\n\tbackground: linear-gradient(145deg, #2b3991 0%, #5b4db8 55%, #ed008c 140%);\n\tcolor: #fff;\n\tfont-size: 1.55rem;\n\tbox-shadow: 0 12px 24px rgba(43, 57, 145, 0.28);\n}\n\n@media (max-width: 980px) {\n\t.interest-page {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.interest-story {\n\t\tmin-height: auto;\n\t\tpadding: 1.4rem 1.25rem 1.6rem;\n\t}\n\n\t.interest-story-body {\n\t\tposition: static;\n\t\tmargin-top: 1.6rem;\n\t}\n\n\t.interest-story h1 {\n\t\tfont-size: 2.1rem;\n\t}\n\n\t.interest-panel {\n\t\talign-items: flex-start;\n\t\tpadding: 1.25rem 1rem 2rem;\n\t}\n}\n\n@media (max-width: 640px) {\n\t.interest-grid {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.interest-span {\n\t\tgrid-column: auto;\n\t}\n\n\t.interest-card {\n\t\tpadding: 1.4rem 1.15rem 1.2rem;\n\t\tborder-radius: 18px;\n\t}\n\n\t.interest-points li:nth-child(2) {\n\t\tdisplay: none;\n\t}\n}\n","// Premium notification cards rendered by src/components/AppToast.\n// Glass surface over the portal palette (navy / blue / magenta) with per-tone accents.\n\n$pp-toast-ease-out: cubic-bezier(0.22, 1, 0.36, 1);\n\n.pp-toast-region {\n    position: fixed;\n    z-index: 12000;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: min(480px, calc(100vw - 32px));\n    pointer-events: none;\n\n    &--top-center    { top: 20px; left: 50%; transform: translateX(-50%); }\n    &--top-right     { top: 20px; right: 20px; }\n    &--top-left      { top: 20px; left: 20px; }\n    &--bottom-center { bottom: 20px; left: 50%; transform: translateX(-50%); }\n    &--bottom-right  { bottom: 20px; right: 20px; }\n    &--bottom-left   { bottom: 20px; left: 20px; }\n}\n\n.pp-toast {\n    // tone tokens (overridden per modifier below)\n    --pp-toast-accent: #2b3991;\n    --pp-toast-accent-2: #ed008c;\n    --pp-toast-tint: rgba(237, 0, 140, 0.14);\n    --pp-toast-shadow: rgba(43, 57, 145, 0.28);\n\n    position: relative;\n    isolation: isolate;\n    pointer-events: auto;\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    column-gap: 14px;\n    align-items: flex-start;\n    padding: 16px 14px 18px 20px;\n    padding-inline-start: 20px;\n    padding-inline-end: 14px;\n    border-radius: 18px;\n    overflow: hidden;\n    font-family: \"Montserrat\", sans-serif;\n    color: var(--pp-ink, #1c2140);\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.92) 100%);\n    backdrop-filter: blur(18px) saturate(1.6);\n    -webkit-backdrop-filter: blur(18px) saturate(1.6);\n    border: 1px solid rgba(255, 255, 255, 0.85);\n    box-shadow:\n        0 1px 1px rgba(11, 16, 38, 0.04),\n        0 10px 24px rgba(28, 33, 64, 0.12),\n        0 28px 64px rgba(28, 33, 64, 0.18),\n        0 0 0 1px rgba(28, 36, 104, 0.05),\n        inset 0 1px 0 rgba(255, 255, 255, 0.95);\n    transition: box-shadow 0.25s ease;\n    will-change: transform, opacity;\n\n    &.is-clickable { cursor: pointer; }\n\n    &:hover {\n        box-shadow:\n            0 1px 1px rgba(11, 16, 38, 0.05),\n            0 14px 30px rgba(28, 33, 64, 0.16),\n            0 34px 72px rgba(28, 33, 64, 0.22),\n            0 0 0 1px rgba(28, 36, 104, 0.07),\n            inset 0 1px 0 rgba(255, 255, 255, 0.95);\n    }\n\n    // accent rail\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 14px;\n        bottom: 14px;\n        inset-inline-start: 0;\n        width: 4px;\n        border-radius: 0 4px 4px 0;\n        background: linear-gradient(180deg, var(--pp-toast-accent), var(--pp-toast-accent-2));\n        box-shadow: 0 0 12px var(--pp-toast-shadow);\n    }\n\n    // top sheen\n    &::after {\n        content: \"\";\n        position: absolute;\n        inset: 0 0 auto 0;\n        height: 46%;\n        background: linear-gradient(180deg, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0));\n        pointer-events: none;\n        z-index: -1;\n    }\n\n    &__glow {\n        position: absolute;\n        top: -110px;\n        inset-inline-end: -70px;\n        width: 220px;\n        height: 220px;\n        border-radius: 50%;\n        background: radial-gradient(closest-side, var(--pp-toast-tint), transparent 72%);\n        pointer-events: none;\n        z-index: -1;\n    }\n\n    &__icon {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 42px;\n        height: 42px;\n        flex: 0 0 42px;\n        border-radius: 14px;\n        color: #fff;\n        font-size: 1.15rem;\n        line-height: 1;\n        background: linear-gradient(135deg, var(--pp-toast-accent) 0%, var(--pp-toast-accent-2) 100%);\n        box-shadow:\n            0 10px 22px var(--pp-toast-shadow),\n            inset 0 1px 0 rgba(255, 255, 255, 0.35),\n            inset 0 -2px 6px rgba(0, 0, 0, 0.12);\n        animation: pp-toast-icon-pop 0.55s $pp-toast-ease-out 0.08s both;\n\n        i { display: block; }\n        i.bi-check-lg,\n        i.bi-x-lg { font-weight: 700; }\n    }\n\n    &__spinner {\n        width: 18px;\n        height: 18px;\n        border-radius: 50%;\n        border: 2.5px solid rgba(255, 255, 255, 0.35);\n        border-top-color: #fff;\n        animation: pp-toast-spin 0.8s linear infinite;\n    }\n\n    &__body {\n        min-width: 0;\n        padding-top: 2px;\n    }\n\n    &__title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 0.92rem;\n        font-weight: 700;\n        letter-spacing: -0.012em;\n        line-height: 1.25;\n        color: var(--pp-ink, #1c2140);\n    }\n\n    &__count {\n        display: inline-flex;\n        align-items: center;\n        padding: 2px 8px;\n        border-radius: 999px;\n        font-size: 0.68rem;\n        font-weight: 700;\n        letter-spacing: 0.02em;\n        color: var(--pp-toast-accent);\n        background: var(--pp-toast-tint);\n    }\n\n    &__message {\n        margin-top: 4px;\n        font-size: 0.82rem;\n        font-weight: 500;\n        line-height: 1.5;\n        color: #4b5270;\n        overflow-wrap: anywhere;\n        word-break: break-word;\n    }\n\n    &__action {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        margin-top: 10px;\n        padding: 6px 12px;\n        border: 0;\n        border-radius: 999px;\n        font-family: inherit;\n        font-size: 0.76rem;\n        font-weight: 700;\n        letter-spacing: 0.01em;\n        color: var(--pp-toast-accent);\n        background: var(--pp-toast-tint);\n        cursor: pointer;\n        transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;\n\n        &:hover {\n            color: #fff;\n            background: linear-gradient(135deg, var(--pp-toast-accent), var(--pp-toast-accent-2));\n        }\n        &:active { transform: translateY(1px); }\n    }\n\n    &__close {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 28px;\n        height: 28px;\n        margin: -4px -2px 0 0;\n        padding: 0;\n        border: 0;\n        border-radius: 50%;\n        background: transparent;\n        color: var(--pp-muted, #6b7280);\n        font-size: 0.72rem;\n        cursor: pointer;\n        transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;\n\n        &:hover {\n            color: var(--pp-ink, #1c2140);\n            background: rgba(28, 33, 64, 0.07);\n            transform: rotate(90deg);\n        }\n        &:focus-visible {\n            outline: none;\n            box-shadow: var(--pp-focus-ring, 0 0 0 4px rgba(43, 57, 145, 0.14));\n        }\n    }\n\n    &__progress {\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        height: 3px;\n        background: linear-gradient(90deg, var(--pp-toast-accent), var(--pp-toast-accent-2));\n        transform-origin: left center;\n        opacity: 0.9;\n        animation-name: pp-toast-progress;\n        animation-timing-function: linear;\n        animation-fill-mode: forwards;\n    }\n\n    /* ----- enter / exit ----- */\n    &.is-open {\n        animation: pp-toast-in 0.46s $pp-toast-ease-out both;\n    }\n\n    &.is-closing {\n        pointer-events: none;\n        animation: pp-toast-out 0.26s cubic-bezier(0.4, 0, 1, 1) forwards;\n    }\n\n    /* ----- tones ----- */\n    &--success {\n        --pp-toast-accent: #10b981;\n        --pp-toast-accent-2: #047857;\n        --pp-toast-tint: rgba(16, 185, 129, 0.16);\n        --pp-toast-shadow: rgba(16, 185, 129, 0.32);\n    }\n\n    &--error {\n        --pp-toast-accent: #f43f5e;\n        --pp-toast-accent-2: #be123c;\n        --pp-toast-tint: rgba(244, 63, 94, 0.16);\n        --pp-toast-shadow: rgba(244, 63, 94, 0.32);\n    }\n\n    &--warning {\n        --pp-toast-accent: #f59e0b;\n        --pp-toast-accent-2: #d97706;\n        --pp-toast-tint: rgba(245, 158, 11, 0.18);\n        --pp-toast-shadow: rgba(245, 158, 11, 0.32);\n    }\n\n    &--info {\n        --pp-toast-accent: #2b3991;\n        --pp-toast-accent-2: #1e71bb;\n        --pp-toast-tint: rgba(30, 113, 187, 0.16);\n        --pp-toast-shadow: rgba(43, 57, 145, 0.3);\n    }\n\n    &--loading {\n        --pp-toast-accent: #1c2468;\n        --pp-toast-accent-2: #3a48b4;\n        --pp-toast-tint: rgba(43, 57, 145, 0.14);\n        --pp-toast-shadow: rgba(43, 57, 145, 0.3);\n    }\n}\n\n/* bottom regions slide up instead of down */\n.pp-toast-region[class*=\"--bottom\"] .pp-toast {\n    &.is-open    { animation-name: pp-toast-in-up; }\n    &.is-closing { animation-name: pp-toast-out-down; }\n}\n\n/* RTL */\n[dir=\"rtl\"] .pp-toast {\n    &::before { border-radius: 4px 0 0 4px; }\n    &__close { margin: -4px 0 0 -2px; }\n    &__progress {\n        transform-origin: right center;\n        background: linear-gradient(270deg, var(--pp-toast-accent), var(--pp-toast-accent-2));\n    }\n}\n\n/* ----- keyframes ----- */\n@keyframes pp-toast-in {\n    from { opacity: 0; transform: translateY(-18px) scale(0.94); filter: blur(6px); }\n    to   { opacity: 1; transform: translateY(0) scale(1);      filter: blur(0); }\n}\n\n@keyframes pp-toast-out {\n    from { opacity: 1; transform: translateY(0) scale(1); }\n    to   { opacity: 0; transform: translateY(-10px) scale(0.96); filter: blur(4px); }\n}\n\n@keyframes pp-toast-in-up {\n    from { opacity: 0; transform: translateY(18px) scale(0.94); filter: blur(6px); }\n    to   { opacity: 1; transform: translateY(0) scale(1);     filter: blur(0); }\n}\n\n@keyframes pp-toast-out-down {\n    from { opacity: 1; transform: translateY(0) scale(1); }\n    to   { opacity: 0; transform: translateY(10px) scale(0.96); filter: blur(4px); }\n}\n\n@keyframes pp-toast-icon-pop {\n    from { transform: scale(0.55) rotate(-8deg); opacity: 0; }\n    60%  { transform: scale(1.08) rotate(2deg); opacity: 1; }\n    to   { transform: scale(1) rotate(0); opacity: 1; }\n}\n\n@keyframes pp-toast-progress {\n    from { transform: scaleX(1); }\n    to   { transform: scaleX(0); }\n}\n\n@keyframes pp-toast-spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ----- responsive ----- */\n@media (max-width: 520px) {\n    .pp-toast-region {\n        width: calc(100vw - 20px);\n        gap: 10px;\n\n        &--top-center, &--top-right, &--top-left { top: 10px; }\n        &--bottom-center, &--bottom-right, &--bottom-left { bottom: 10px; }\n        &--top-right, &--top-left, &--bottom-right, &--bottom-left {\n            left: 50%;\n            right: auto;\n            transform: translateX(-50%);\n        }\n    }\n\n    .pp-toast {\n        column-gap: 12px;\n        padding: 14px 12px 16px 16px;\n        padding-inline-start: 16px;\n        padding-inline-end: 12px;\n        border-radius: 16px;\n\n        &__icon { width: 36px; height: 36px; flex-basis: 36px; border-radius: 12px; font-size: 1rem; }\n        &__title { font-size: 0.86rem; }\n        &__message { font-size: 0.78rem; }\n    }\n}\n\n/* ----- motion preferences ----- */\n@media (prefers-reduced-motion: reduce) {\n    .pp-toast,\n    .pp-toast.is-open,\n    .pp-toast.is-closing,\n    .pp-toast__icon {\n        animation: none;\n    }\n    .pp-toast.is-closing { opacity: 0; transition: opacity 0.2s ease; }\n    .pp-toast__close:hover { transform: none; }\n}\n","// Shared portal theme: navy surface, blue accent, magenta highlight.\n// Imported last from _main.scss so these rules win over module styles.\n\n:root {\n    --pp-navy-900: #0b1026;\n    --pp-navy-700: #12183a;\n    --pp-navy-500: #1c2468;\n    --pp-blue: #2b3991;\n    --pp-blue-soft: #eef3fb;\n    --pp-pink: #ed008c;\n    --pp-ink: #1c2140;\n    --pp-muted: #6b7280;\n    --pp-surface: #f4f6fb;\n    --pp-line: #e6eaf2;\n\n    --pp-panel-gradient:\n        radial-gradient(520px 320px at 8% 0%, rgba(237, 0, 140, 0.32), transparent 62%),\n        radial-gradient(460px 340px at 100% 100%, rgba(30, 113, 187, 0.38), transparent 58%),\n        linear-gradient(168deg, #1c2468 0%, #12183a 52%, #0b1026 100%);\n    --pp-button-gradient: linear-gradient(135deg, #1c2468 0%, #2b3991 58%, #3a48b4 100%);\n    --pp-button-shadow: 0 8px 18px rgba(28, 36, 104, 0.22);\n    --pp-focus-ring: 0 0 0 4px rgba(43, 57, 145, 0.14);\n\n    --sidebar-gradient:\n        radial-gradient(280px 220px at 0% 0%, rgba(237, 0, 140, 0.38), transparent 64%),\n        radial-gradient(260px 240px at 120% 100%, rgba(30, 113, 187, 0.45), transparent 60%),\n        linear-gradient(180deg, #1c2468 0%, #12183a 48%, #0b1026 100%);\n    --button-gradient: var(--pp-button-gradient);\n    --import-gradient: var(--pp-button-gradient);\n\n    // Bootstrap tokens so utilities such as text-primary and bg-primary follow the theme.\n    --bs-primary: #2b3991;\n    --bs-primary-rgb: 43, 57, 145;\n    --bs-link-color: #2b3991;\n    --bs-link-color-rgb: 43, 57, 145;\n    --bs-link-hover-color: #ed008c;\n    --bs-link-hover-color-rgb: 237, 0, 140;\n    --bs-body-color: #1c2140;\n    --bs-border-color: #e6eaf2;\n}\n\n/* ---------- Surfaces ---------- */\n\n.sidebar {\n    background: var(--sidebar-gradient);\n    background-repeat: no-repeat;\n    box-shadow: 8px 0 24px rgba(11, 16, 38, 0.12);\n}\n\n.sidebar .sidebar-item .sidebar-title:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.main_container {\n    background: var(--pp-surface);\n}\n\n.main_container .content {\n    background: var(--pp-surface);\n}\n\n.top-header {\n    background: #ffffff;\n    border-bottom: 1px solid var(--pp-line);\n}\n\n.header_container {\n    background: transparent;\n    border-bottom: none;\n}\n\n.tab-bar {\n    background: #eef1f7;\n    border-bottom: 1px solid var(--pp-line);\n}\n\n.tab-bar::-webkit-scrollbar-thumb {\n    background: rgba(43, 57, 145, 0.35);\n}\n\n.tab {\n    color: var(--pp-muted);\n    font-family: \"Montserrat\", sans-serif;\n}\n\n.tab.active {\n    color: var(--pp-ink);\n    border-bottom: 2px solid var(--pp-pink);\n}\n\n.tab-content {\n    background: var(--pp-surface);\n}\n\n.footer {\n    background: var(--pp-panel-gradient);\n    color: rgba(255, 255, 255, 0.78);\n    font-family: \"Montserrat\", sans-serif;\n}\n\n.card {\n    border: 1px solid var(--pp-line);\n    border-radius: 14px;\n    box-shadow: 0 10px 28px rgba(28, 33, 64, 0.05);\n}\n\na {\n    color: var(--pp-blue);\n}\n\na:hover {\n    color: var(--pp-pink);\n}\n\n/* ---------- Scrollbars ---------- */\n\n::-webkit-scrollbar-track {\n    background: #eef1f7;\n}\n\n::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #2b3991, #1c2468);\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(180deg, #3a48b4, #2b3991);\n}\n\n* {\n    scrollbar-color: #2b3991 #eef1f7;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar,\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar,\n.ag-body-vertical-scroll-viewport::-webkit-scrollbar,\n.table-responsive::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb,\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,\n.ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,\n.table-responsive::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #2b3991, #1c2468);\n    border-radius: 999px;\n}\n\n.MuiDataGrid-virtualScroller::-webkit-scrollbar-track,\n.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,\n.ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,\n.table-responsive::-webkit-scrollbar-track {\n    background: #eef1f7;\n    border-radius: 999px;\n}\n\n/* ---------- Forms ---------- */\n\n.form-control,\n.form-select {\n    border-color: var(--pp-line);\n    border-radius: 10px;\n    color: var(--pp-ink);\n}\n\n.form-control:focus,\n.form-select:focus,\nbody .input_field .form-control:focus {\n    border-color: var(--pp-blue);\n    box-shadow: var(--pp-focus-ring);\n    outline: none;\n}\n\n.form-check-input:checked {\n    background-color: var(--pp-blue);\n    border-color: var(--pp-blue);\n}\n\n.form-check-input:focus {\n    border-color: var(--pp-blue);\n    box-shadow: var(--pp-focus-ring);\n}\n\n/* ---------- Bootstrap buttons ---------- */\n\n.btn {\n    --bs-btn-border-radius: 10px;\n    --bs-btn-font-weight: 600;\n    font-family: \"Montserrat\", sans-serif;\n    letter-spacing: 0.01em;\n    transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.btn:active {\n    transform: translateY(1px);\n}\n\n.btn:focus-visible {\n    box-shadow: var(--pp-focus-ring);\n}\n\n.btn-primary,\n.btn-dark {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #2b3991;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #ed008c;\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #c8007a;\n    --bs-btn-active-border-color: transparent;\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #2b3991;\n    --bs-btn-disabled-border-color: transparent;\n    background-image: var(--pp-button-gradient);\n    box-shadow: var(--pp-button-shadow);\n}\n\n.btn-primary:hover,\n.btn-dark:hover {\n    background-image: linear-gradient(135deg, #ed008c 0%, #c8007a 100%);\n    box-shadow: 0 10px 22px rgba(237, 0, 140, 0.24);\n}\n\n.btn-primary:disabled,\n.btn-primary.disabled,\n.btn-dark:disabled,\n.btn-dark.disabled {\n    opacity: 0.55;\n    box-shadow: none;\n}\n\n.btn-secondary,\n.btn-light {\n    --bs-btn-color: #2b3991;\n    --bs-btn-bg: #eef3fb;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color: #1c2468;\n    --bs-btn-hover-bg: #e2ebf8;\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-color: #1c2468;\n    --bs-btn-active-bg: #d6e2f4;\n    --bs-btn-active-border-color: transparent;\n    --bs-btn-disabled-color: #8b95ad;\n    --bs-btn-disabled-bg: #eef3fb;\n    --bs-btn-disabled-border-color: transparent;\n}\n\n.btn-outline-primary,\n.btn-outline-secondary,\n.btn-outline-dark {\n    --bs-btn-color: #2b3991;\n    --bs-btn-border-color: rgba(43, 57, 145, 0.28);\n    --bs-btn-hover-color: #2b3991;\n    --bs-btn-hover-bg: #eef3fb;\n    --bs-btn-hover-border-color: rgba(43, 57, 145, 0.4);\n    --bs-btn-active-color: #1c2468;\n    --bs-btn-active-bg: #e2ebf8;\n    --bs-btn-active-border-color: rgba(43, 57, 145, 0.4);\n    --bs-btn-disabled-color: #8b95ad;\n    --bs-btn-disabled-border-color: var(--pp-line);\n}\n\n.btn-link {\n    --bs-btn-color: #2b3991;\n    --bs-btn-hover-color: #ed008c;\n    text-decoration: none;\n}\n\n.btn-import {\n    color: #fff;\n    border: 0;\n    box-shadow: var(--pp-button-shadow);\n}\n\n/* ---------- Modals and offcanvas ---------- */\n\n.modal-content,\n.offcanvas {\n    border: 0;\n    border-radius: 18px;\n    overflow: hidden;\n    box-shadow: 0 28px 70px rgba(28, 33, 64, 0.28);\n}\n\n.offcanvas {\n    border-radius: 18px 0 0 18px;\n}\n\n.modal-header:not([class*=\"bg-\"]),\n.offcanvas-header:not([class*=\"bg-\"]) {\n    background: var(--pp-panel-gradient);\n    color: #fff;\n    border-bottom: 0;\n}\n\n.modal-header:not([class*=\"bg-\"]) .modal-title,\n.offcanvas-header:not([class*=\"bg-\"]) .offcanvas-title {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n}\n\n.modal-header:not([class*=\"bg-\"]) .btn-close,\n.offcanvas-header:not([class*=\"bg-\"]) .btn-close {\n    filter: brightness(0) invert(1);\n    opacity: 0.8;\n}\n\n.modal-header:not([class*=\"bg-\"]) .btn-close:hover,\n.offcanvas-header:not([class*=\"bg-\"]) .btn-close:hover {\n    opacity: 1;\n}\n\n.modal-footer {\n    border-top: 1px solid var(--pp-line);\n}\n\n/* ---------- Material UI ---------- */\n\n.MuiButton-root.MuiButton-containedPrimary:not(.cdt-btn) {\n    border-radius: 10px;\n    background: var(--pp-button-gradient);\n    box-shadow: var(--pp-button-shadow);\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 600;\n    text-transform: none;\n}\n\n.MuiButton-root.MuiButton-containedPrimary:not(.cdt-btn):hover {\n    background: linear-gradient(135deg, #ed008c 0%, #c8007a 100%);\n    box-shadow: 0 10px 22px rgba(237, 0, 140, 0.24);\n}\n\n.MuiButton-root.MuiButton-outlinedPrimary:not(.cdt-btn),\n.MuiButton-root.MuiButton-textPrimary:not(.cdt-btn) {\n    border-radius: 10px;\n    color: var(--pp-blue);\n    border-color: rgba(43, 57, 145, 0.28);\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 600;\n    text-transform: none;\n}\n\n.MuiButton-root.MuiButton-outlinedPrimary:not(.cdt-btn):hover,\n.MuiButton-root.MuiButton-textPrimary:not(.cdt-btn):hover {\n    background: var(--pp-blue-soft);\n    border-color: rgba(43, 57, 145, 0.4);\n}\n\n.MuiCheckbox-root.Mui-checked,\n.MuiRadio-root.Mui-checked,\n.MuiSwitch-switchBase.Mui-checked {\n    color: var(--pp-blue) !important;\n}\n\n.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n    background-color: var(--pp-blue) !important;\n}\n\n.MuiTabs-indicator {\n    background-color: var(--pp-pink) !important;\n}\n\n.MuiTab-root.Mui-selected {\n    color: var(--pp-blue) !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: var(--pp-blue) !important;\n}\n\n.MuiInputLabel-root.Mui-focused {\n    color: var(--pp-blue) !important;\n}\n\n.MuiDialog-paper {\n    border-radius: 18px !important;\n}\n\n.MuiDialogTitle-root {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    color: var(--pp-ink);\n}\n/* Entity detail tabs (Customer / Supplier edit & view: \"<Entity>\" | \"Ship To\" / \"Ship From\") */\n.pp-entity-tabs {\n    --bs-nav-tabs-border-width: 0;\n    gap: 0.35rem;\n    padding: 0.3rem;\n    border-radius: 12px;\n    background: var(--pp-blue-soft);\n    width: fit-content;\n}\n\n.pp-entity-tabs .nav-link {\n    border: 0;\n    border-radius: 9px;\n    color: var(--pp-blue);\n    font-weight: 600;\n    font-size: 0.85rem;\n    padding: 0.45rem 1rem;\n    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pp-entity-tabs .nav-link:hover {\n    background: rgba(43, 57, 145, 0.1);\n}\n\n.pp-entity-tabs .nav-link.active {\n    color: #fff;\n    background: var(--pp-button-gradient);\n    box-shadow: 0 4px 12px rgba(43, 57, 145, 0.28);\n}\n\n.pp-entity-tabs .nav-link.active i {\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
